<!-- AI.vue -->
<template>
  <Admin style="background: #f2f2f2">
    <v-main>
      <v-container fluid>
        <v-snackbar
          v-model="snackbar.show"
          :color="snackbar.color"
          :timeout="3000"
          top
        >
          {{ snackbar.message }}
          <template v-slot:action="{ attrs }">
            <v-btn text v-bind="attrs" @click="snackbar.show = false"
              >ปิด</v-btn
            >
          </template>
        </v-snackbar>

        <v-dialog v-model="isShowHistoryDialog" max-width="1100" scrollable>
          <v-card>
            <v-card-title class="tw-flex tw-items-center tw-gap-2">
              <v-icon color="brown">mdi-history</v-icon>
              ข้อมูลการใช้งานรวม
              <v-spacer></v-spacer>
              <v-btn icon @click="isShowHistoryDialog = false" aria-label="ปิดหน้าต่าง">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-divider></v-divider>

            <v-card-text class="tw-pt-4">
              <v-tabs v-model="historyTabIndex">
                <v-tab>
                  <v-icon left>mdi-clipboard-text-clock</v-icon>
                  Legacy
                </v-tab>
                <v-tab>
                  <v-icon left>mdi-brain</v-icon>
                  AI Usage
                </v-tab>
              </v-tabs>

              <v-tabs-items v-model="historyTabIndex">
                <!-- Tab 1: Legacy (ChatGptActivityLog) -->
                <v-tab-item>
                  <v-row dense class="tw-mt-2">
                    <v-col cols="12" sm="6" md="4">
                      <v-select
                        :menu-props="{ bottom: true, offsetY: true }"
                        v-model="selectedMonth"
                        :items="selectedChatGptActivityLog"
                        item-value="id"
                        item-text="id"
                        label="เลือกเดือน"
                        outlined
                        dense
                        hide-details
                      ></v-select>
                    </v-col>
                  </v-row>

                  <div class="tw-mt-4">
                    <v-data-table
                      class="nowrap"
                      hide-default-footer
                      :items-per-page="-1"
                      :headers="[
                        { text: 'วันที่', value: 'id' },
                        { text: 'ไฟล์ PDF', value: 'countDetails' },
                        { text: 'Input Tokens', value: 'tokenPrompt' },
                        { text: 'Output Tokens', value: 'tokenCompletion' },
                        { text: 'รวม Tokens', value: 'tokenTotal' },
                      ]"
                      :loading="loading"
                      loading-text="กำลังโหลด..."
                      no-data-text="ไม่พบข้อมูลการใช้งานในเดือนนี้"
                      :items="formatNumbers(selectedDateChatGptActivityLog)"
                      item-key="id"
                      :single-expand="singleExpand"
                      :expanded.sync="expanded"
                      show-expand
                    >
                      <template v-slot:expanded-item="{ item }">
                        <td :colspan="6" class="expanded-item-td">
                          <v-data-table
                            hide-default-footer
                            dense
                            class="elevation-1"
                            :headers="[
                              { text: 'รุ่นโมเดล', value: 'modelVersion', class: 'my-header-style' },
                              { text: 'ไฟล์ PDF', value: 'countDetails', class: 'my-header-style' },
                              { text: 'Input Tokens', value: 'tokenPrompt', class: 'my-header-style' },
                              { text: 'Output Tokens', value: 'tokenCompletion', class: 'my-header-style' },
                              { text: 'รวม Tokens', value: 'tokenTotal', class: 'my-header-style' },
                            ]"
                            :items="formatNumbers(item.modelData)"
                            item-key="modelVersion"
                            full-width
                            :item-class="rowClass"
                          ></v-data-table>
                        </td>
                      </template>
                    </v-data-table>
                  </div>

                  <div v-if="modelData && modelData.length" class="history-totals">
                    <div class="history-totals-title">สรุปยอดรวมตามโมเดล</div>
                    <v-row
                      v-for="model in modelData"
                      :key="model.modelVersion"
                      class="pa-0 ma-0"
                      justify="end"
                    >
                      <v-col cols="12" sm="6" md="4" class="tw-py-0">
                        <v-text-field label="โมเดล" readonly :value="model?.modelVersion" outlined dense hide-details class="tw-mt-2"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="2" class="tw-py-0">
                        <v-text-field label="รวม PDF" readonly :value="model.countDetails?.toLocaleString()" reverse outlined dense hide-details class="tw-mt-2"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="2" class="tw-py-0">
                        <v-text-field label="รวม Input" readonly :value="model.tokenPrompt?.toLocaleString()" reverse outlined dense hide-details class="tw-mt-2"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="2" class="tw-py-0">
                        <v-text-field label="รวม Output" readonly :value="model.tokenCompletion?.toLocaleString()" reverse outlined dense hide-details class="tw-mt-2"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="2" class="tw-py-0">
                        <v-text-field label="รวมทั้งหมด" readonly :value="model.tokenTotal?.toLocaleString()" reverse outlined dense hide-details class="tw-mt-2"></v-text-field>
                      </v-col>
                    </v-row>
                  </div>
                </v-tab-item>

                <!-- Tab 2: AI Usage (AiUsageLog) -->
                <v-tab-item>
                  <v-row dense class="tw-mt-2">
                    <v-col cols="12" sm="6" md="4">
                      <v-select
                        :menu-props="{ bottom: true, offsetY: true }"
                        v-model="selectedAiMonth"
                        :items="selectedAiUsageLog"
                        item-value="id"
                        item-text="id"
                        label="เลือกเดือน"
                        outlined
                        dense
                        hide-details
                      ></v-select>
                    </v-col>
                  </v-row>

                  <div class="tw-mt-4">
                    <v-data-table
                      class="nowrap"
                      hide-default-footer
                      :items-per-page="-1"
                      :headers="[
                        { text: 'วันที่', value: 'id' },
                        { text: 'Requests', value: 'countDetails' },
                        { text: 'Input Tokens', value: 'tokenPrompt' },
                        { text: 'Output Tokens', value: 'tokenCompletion' },
                        { text: 'Cached', value: 'cachedTokens' },
                        { text: 'Reasoning', value: 'reasoningTokens' },
                        { text: 'รวม Tokens', value: 'tokenTotal' },
                      ]"
                      :loading="loading"
                      loading-text="กำลังโหลด..."
                      no-data-text="ไม่พบข้อมูลการใช้งานในเดือนนี้"
                      :items="formatAiNumbers(selectedDateAiUsageLog)"
                      item-key="id"
                      :single-expand="singleExpand"
                      :expanded.sync="aiExpanded"
                      show-expand
                    >
                      <template v-slot:expanded-item="{ item }">
                        <td :colspan="8" class="expanded-item-td">
                          <v-data-table
                            hide-default-footer
                            dense
                            class="elevation-1"
                            :headers="[
                              { text: 'รุ่นโมเดล', value: 'modelVersion', class: 'my-header-style' },
                              { text: 'Requests', value: 'countDetails', class: 'my-header-style' },
                              { text: 'Input Tokens', value: 'tokenPrompt', class: 'my-header-style' },
                              { text: 'Output Tokens', value: 'tokenCompletion', class: 'my-header-style' },
                              { text: 'Cached', value: 'cachedTokens', class: 'my-header-style' },
                              { text: 'Reasoning', value: 'reasoningTokens', class: 'my-header-style' },
                              { text: 'รวม Tokens', value: 'tokenTotal', class: 'my-header-style' },
                            ]"
                            :items="formatAiNumbers(toEntries(item.modelTotals, 'modelVersion'))"
                            item-key="modelVersion"
                            full-width
                            :item-class="rowClass"
                          ></v-data-table>
                        </td>
                      </template>
                    </v-data-table>
                  </div>

                  <div v-if="aiModelTotalsList.length" class="history-totals">
                    <div class="history-totals-title">สรุปยอดรวมตามโมเดล</div>
                    <v-row
                      v-for="model in aiModelTotalsList"
                      :key="'m-' + model.modelVersion"
                      class="pa-0 ma-0"
                      justify="end"
                    >
                      <v-col cols="12" sm="6" md="3" class="tw-py-0">
                        <v-text-field label="โมเดล" readonly :value="model.modelVersion" outlined dense hide-details class="tw-mt-2"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="1" class="tw-py-0">
                        <v-text-field label="Requests" readonly :value="model.countDetails?.toLocaleString()" reverse outlined dense hide-details class="tw-mt-2"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="2" class="tw-py-0">
                        <v-text-field label="Input" readonly :value="model.tokenPrompt?.toLocaleString()" reverse outlined dense hide-details class="tw-mt-2"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="2" class="tw-py-0">
                        <v-text-field label="Output" readonly :value="model.tokenCompletion?.toLocaleString()" reverse outlined dense hide-details class="tw-mt-2"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="2" class="tw-py-0">
                        <v-text-field label="Cached" readonly :value="model.cachedTokens?.toLocaleString()" reverse outlined dense hide-details class="tw-mt-2"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="2" class="tw-py-0">
                        <v-text-field label="รวม" readonly :value="model.tokenTotal?.toLocaleString()" reverse outlined dense hide-details class="tw-mt-2"></v-text-field>
                      </v-col>
                    </v-row>
                  </div>

                  <div v-if="aiServiceTotalsList.length" class="history-totals">
                    <div class="history-totals-title">สรุปยอดรวมตามบริการ</div>
                    <v-row
                      v-for="svc in aiServiceTotalsList"
                      :key="'s-' + svc.serviceType"
                      class="pa-0 ma-0"
                      justify="end"
                    >
                      <v-col cols="12" sm="6" md="3" class="tw-py-0">
                        <v-text-field label="บริการ" readonly :value="svc.serviceType" outlined dense hide-details class="tw-mt-2"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="1" class="tw-py-0">
                        <v-text-field label="Requests" readonly :value="svc.countDetails?.toLocaleString()" reverse outlined dense hide-details class="tw-mt-2"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="2" class="tw-py-0">
                        <v-text-field label="Input" readonly :value="svc.tokenPrompt?.toLocaleString()" reverse outlined dense hide-details class="tw-mt-2"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="2" class="tw-py-0">
                        <v-text-field label="Output" readonly :value="svc.tokenCompletion?.toLocaleString()" reverse outlined dense hide-details class="tw-mt-2"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="2" class="tw-py-0">
                        <v-text-field label="Cached" readonly :value="svc.cachedTokens?.toLocaleString()" reverse outlined dense hide-details class="tw-mt-2"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="2" class="tw-py-0">
                        <v-text-field label="รวม" readonly :value="svc.tokenTotal?.toLocaleString()" reverse outlined dense hide-details class="tw-mt-2"></v-text-field>
                      </v-col>
                    </v-row>
                  </div>
                </v-tab-item>
              </v-tabs-items>
            </v-card-text>

            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="isShowHistoryDialog = false">ปิด</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-card class="rounded-xl tw-min-h-80">
          <v-card-text>
            <v-breadcrumbs :items="items">
              <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
              <template v-slot:item="{ item }">
                <v-breadcrumbs-item
                  :to="item.to"
                  :disabled="item.disabled"
                  :exact="true"
                >
                  {{ item.text }}
                </v-breadcrumbs-item>
              </template>
            </v-breadcrumbs>

            <nav
              v-if="sectionNavItems.length > 1"
              class="section-nav"
              aria-label="Section navigation"
            >
              <a
                v-for="item in sectionNavItems"
                :key="item.key"
                :href="`#section-${item.key}`"
                class="section-nav-item"
                :class="{
                  'section-nav-item--active': activeSection === item.key,
                  'section-nav-item--dirty': dirtyByKey[item.key],
                }"
                :aria-label="dirtyByKey[item.key] ? `${item.label} (มีการเปลี่ยนแปลงที่ยังไม่ได้บันทึก)` : item.label"
                @click.prevent="scrollToSection(item.key)"
              >
                <v-icon
                  small
                  left
                  :color="activeSection === item.key ? 'primary' : 'grey darken-1'"
                >{{ item.icon }}</v-icon>
                {{ item.label }}
                <span
                  v-if="dirtyByKey[item.key]"
                  class="section-nav-item-dot"
                  aria-hidden="true"
                ></span>
              </a>
            </nav>

            <section v-if="isStaff" id="section-api" class="settings-section settings-section--api">
              <div class="settings-section-header">
                <div class="settings-section-title-block">
                  <div class="settings-section-title">
                    <v-icon left color="deep-purple darken-1">mdi-api</v-icon>
                    ตั้งค่าการเชื่อมต่อ API
                  </div>
                  <div class="settings-section-description">
                    จัดการ API key สำหรับบริการ AI ที่ใช้ประมวลผลเอกสาร AP
                  </div>
                </div>
                <div class="settings-section-actions">
                  <v-btn
                    @click="showHistoryDialog"
                    text
                    outlined
                    color="brown"
                    :disabled="isInitializing"
                  >
                    <v-icon left>mdi-history</v-icon>
                    ข้อมูลการใช้งานรวม
                  </v-btn>
                </div>
              </div>

              <v-row class="api-key-grid" align="start">
                <v-col cols="12" md="7" lg="8">
                  <v-text-field
                    v-model="OpenAIapiKey"
                    outlined
                    dense
                    :type="showKeyOpenAI ? 'text' : 'password'"
                    :append-icon="showKeyOpenAI ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="toggleshowKeyOpenAI"
                    label="OpenAI API Key"
                    placeholder="sk-..."
                    persistent-placeholder
                    hint="ใช้สำหรับเรียก OpenAI ในการประมวลผลเอกสาร"
                    persistent-hint
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="5" lg="4">
                  <div class="api-key-actions">
                    <v-btn
                      color="primary"
                      :loading="isSavingOpenAIApiKey"
                      :disabled="!OpenAIapiKey"
                      @click="saveOpenAIApiKey"
                    >
                      <v-icon left>mdi-content-save</v-icon>
                      บันทึก
                    </v-btn>
                    <v-btn
                      color="info"
                      :loading="isTestingConnectionOpenAI"
                      :disabled="!OpenAIapiKey"
                      outlined
                      @click="testConnectionOpenAI"
                    >
                      <v-icon left>mdi-router-wireless</v-icon>
                      ทดสอบ
                    </v-btn>
                  </div>
                </v-col>
              </v-row>

              <v-row class="api-key-grid" align="start">
                <v-col cols="12" md="7" lg="8">
                  <v-text-field
                    v-model="GoogleAIapiKey"
                    outlined
                    dense
                    :type="showKeyGoogleAI ? 'text' : 'password'"
                    :append-icon="showKeyGoogleAI ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="toggleShowKeyGoogleAI"
                    label="GoogleAI API Key"
                    placeholder="AIza..."
                    persistent-placeholder
                    hint="ใช้สำหรับเรียก Gemini ในการประมวลผลเอกสาร"
                    persistent-hint
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="5" lg="4">
                  <div class="api-key-actions">
                    <v-btn
                      color="primary"
                      :loading="isSavingGoogleAIApiKey"
                      :disabled="!GoogleAIapiKey"
                      @click="saveGoogleAIApiKey"
                    >
                      <v-icon left>mdi-content-save</v-icon>
                      บันทึก
                    </v-btn>
                    <v-btn
                      color="info"
                      :loading="isTestingConnectionGoogleAI"
                      :disabled="!GoogleAIapiKey"
                      outlined
                      @click="testConnectionOpenAIGoogleAI"
                    >
                      <v-icon left>mdi-router-wireless</v-icon>
                      ทดสอบ
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </section>

            <!-- SAP B1 Configuration Section -->
            <section v-if="isStaff && isApTypeOne" id="section-sap" class="settings-section settings-section--sap">
              <div class="settings-section-header">
                <div class="settings-section-title-block">
                  <div class="settings-section-title">
                    <v-icon left color="blue-grey darken-2">mdi-server-network</v-icon>
                    ตั้งค่าการเชื่อมต่อ SAP Business One
                  </div>
                  <div class="settings-section-description">
                    ตั้งค่า Service Layer และบัญชีเชื่อมต่อสำหรับดึงข้อมูลจาก SAP Business One
                  </div>
                </div>
                <div class="settings-section-actions">
                  <v-btn
                    v-if="!isEditingSAPConfig"
                    @click="toggleSAPConfigEdit"
                    color="warning"
                    outlined
                  >
                    <v-icon left>mdi-pencil</v-icon>
                    แก้ไข
                  </v-btn>
                  <v-btn
                    v-if="isEditingSAPConfig"
                    @click="saveSAPConfig"
                    color="primary"
                    :loading="isSavingSAPConfig"
                  >
                    <v-icon left>mdi-content-save</v-icon>
                    บันทึก
                  </v-btn>
                  <v-btn
                    v-if="isEditingSAPConfig"
                    @click="cancelSAPConfigEdit"
                    outlined
                  >
                    ยกเลิก
                  </v-btn>
                  <v-btn
                    color="info"
                    :loading="isTestingSAPConnection"
                    :disabled="!sapConfig.b1sServiceUrl || !sapConfig.b1wsUsername || !sapConfig.b1wsPassword"
                    outlined
                    @click="testSAPConnection"
                  >
                    <v-icon left>mdi-router-wireless</v-icon>
                    ทดสอบการเชื่อมต่อ
                  </v-btn>
                </div>
              </div>

              <div class="settings-section-body">
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="sapConfig.b1sServiceUrl"
                    outlined
                    dense
                    label="Service Layer URL"
                    placeholder="https://server:50000/b1s/v1"
                    persistent-placeholder
                    :disabled="!isEditingSAPConfig"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="sapConfig.databaseName"
                    outlined
                    dense
                    label="Company Database Name"
                    placeholder="SBODEMO_SG"
                    persistent-placeholder
                    :disabled="!isEditingSAPConfig"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="sapConfig.b1wsUsername"
                    outlined
                    dense
                    label="Service Layer Username"
                    placeholder="manager"
                    persistent-placeholder
                    :disabled="!isEditingSAPConfig"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="sapConfig.b1wsPassword"
                    outlined
                    dense
                    :type="showSAPPassword ? 'text' : 'password'"
                    :append-icon="showSAPPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="toggleShowSAPPassword"
                    label="Service Layer Password"
                    persistent-placeholder
                    :disabled="!isEditingSAPConfig"
                  ></v-text-field>
                </v-col>
              </v-row>

              </div>
            </section>

            <!-- Sync Provider Picker -->
            <section v-if="isStaff && (isApTypeOne || isApTypeTwo)" id="section-sync" class="settings-section settings-section--sync">
              <div class="sync-picker-header settings-section-header">
                <div class="settings-section-title-block">
                  <div class="settings-section-title">
                    <v-icon left color="blue-grey darken-2">mdi-cloud-sync-outline</v-icon>
                    เลือกบริการซิงค์เอกสาร
                  </div>
                  <div class="settings-section-description">
                    เลือกผู้ให้บริการซิงค์เอกสารได้เพียงหนึ่งบริการเท่านั้น
                  </div>
                </div>
                <div v-if="selectedSyncProviderOption" class="settings-section-actions sync-picker-current">
                  <v-chip small outlined color="primary">
                    <v-icon left small>mdi-check-circle</v-icon>
                    กำลังใช้: {{ selectedSyncProviderOption.name }}
                  </v-chip>
                </div>
              </div>
              <div class="sync-picker-grid">
                <div
                  v-for="opt in displaySyncProviderOptions"
                  :key="opt.key"
                  class="sync-picker-card"
                  :role="opt.available === false ? undefined : 'button'"
                  :tabindex="opt.available === false || isSavingSyncProvider ? -1 : 0"
                  :aria-pressed="isApSelectedSyncProvider === opt.key ? 'true' : 'false'"
                  :aria-disabled="opt.available === false || isSavingSyncProvider ? 'true' : 'false'"
                  :aria-label="opt.available === false ? `${opt.name} ยังไม่พร้อมใช้งาน` : `${opt.name} เลือกบริการซิงค์เอกสาร`"
                  :class="{
                    'sync-picker-card--active': isApSelectedSyncProvider === opt.key,
                    'sync-picker-card--disabled': isSavingSyncProvider,
                    'sync-picker-card--unavailable': opt.available === false,
                    'sync-picker-card--blocked': opt.blocked === true,
                  }"
                  @click="opt.available === false || isSavingSyncProvider ? null : setSyncProvider(opt.key)"
                  @keydown.enter="opt.available === false || isSavingSyncProvider ? null : setSyncProvider(opt.key)"
                  @keydown.space.prevent="opt.available === false || isSavingSyncProvider ? null : setSyncProvider(opt.key)"
                >
                  <div v-if="opt.blocked" class="sync-picker-card-ribbon sync-picker-card-ribbon--blocked">
                    <v-icon x-small>mdi-alert-circle-outline</v-icon>
                    {{ opt.blockedLabel || 'มีปัญหา' }}
                  </div>
                  <div v-else-if="opt.available === false" class="sync-picker-card-ribbon">
                    <v-icon x-small>mdi-clock-outline</v-icon>
                    เร็ว ๆ นี้
                  </div>
                  <div class="sync-picker-card-icon">
                    <v-icon :color="opt.color" size="32">{{ opt.icon }}</v-icon>
                  </div>
                  <div class="sync-picker-card-name">{{ opt.name }}</div>
                  <div class="sync-picker-card-description">{{ opt.description }}</div>
                  <div class="sync-picker-card-badge">
                    <template v-if="opt.blocked">
                      <v-icon color="red darken-1" x-small>mdi-alert-circle</v-icon>
                      <span class="tw-text-red-600">{{ opt.blockedReason || 'ไม่รองรับ' }}</span>
                    </template>
                    <template v-else-if="opt.available === false">
                      <template v-if="opt.progress">
                        <div class="sync-picker-card-progress">
                          <div class="sync-picker-card-progress-header">
                            <span>กำลังพัฒนา</span>
                            <span class="sync-picker-card-progress-value">{{ opt.progress }}%</span>
                          </div>
                          <div class="sync-picker-card-progress-bar">
                            <div
                              class="sync-picker-card-progress-fill"
                              :style="{ width: opt.progress + '%' }"
                            ></div>
                          </div>
                        </div>
                      </template>
                      <template v-else>
                        <v-icon color="grey lighten-1" x-small>mdi-lock-outline</v-icon>
                        <span>ยังไม่พร้อมใช้งาน</span>
                      </template>
                    </template>
                    <template v-else>
                      <v-icon
                        :color="isApSelectedSyncProvider === opt.key ? 'success' : 'grey lighten-1'"
                        x-small
                      >
                        {{ isApSelectedSyncProvider === opt.key ? 'mdi-check-circle' : 'mdi-circle-outline' }}
                      </v-icon>
                      <span>{{ isApSelectedSyncProvider === opt.key ? 'เลือกอยู่' : 'เลือก' }}</span>
                    </template>
                  </div>
                </div>
              </div>
              <div v-if="!isApSelectedSyncProvider" class="sync-picker-empty">
                <v-icon small color="grey">mdi-information-outline</v-icon>
                <span>กรุณาเลือกบริการซิงค์เพื่อแสดงการตั้งค่า</span>
              </div>

            <!-- Google Drive Configuration Section -->
            <div v-if="isStaff && (isApTypeOne || isApTypeTwo) && isApSelectedSyncProvider === 'googleDrive'" class="sync-provider-config cloud-provider-card cloud-provider-card--google">

              <!-- Section header -->
              <div class="cloud-provider-header">
                <div class="cloud-provider-title-row">
                  <div class="cloud-provider-icon">
                    <v-icon color="blue darken-2">mdi-google-drive</v-icon>
                  </div>
                  <div>
                    <div class="cloud-provider-heading">Google Drive</div>
                    <div class="cloud-provider-description">
                      เชื่อมต่อ Drive และเลือกโฟลเดอร์ใบซื้อสำหรับ Watch อัตโนมัติ
                    </div>
                    <div
                      class="cloud-status-pill"
                      :class="driveIsConnected ? 'cloud-status-pill--connected' : 'cloud-status-pill--idle'"
                    >
                      <v-icon x-small>{{ driveIsConnected ? 'mdi-check-circle' : 'mdi-link-variant-off' }}</v-icon>
                      {{ driveIsConnected ? 'เชื่อมต่อแล้ว' : 'ยังไม่เชื่อมต่อ' }}
                    </div>
                  </div>
                </div>
                <div v-if="driveIsConnected && !driveIsLoadingStatus" class="cloud-provider-actions">
                  <v-btn
                    color="info"
                    outlined
                    small
                    :loading="isTestingDriveConnection"
                    @click="testDriveConnection"
                  >
                    <v-icon left>mdi-router-wireless</v-icon>
                    ทดสอบ
                  </v-btn>
                  <v-btn
                    color="error"
                    outlined
                    small
                    :loading="driveIsDisconnecting"
                    @click="disconnectGoogleDrive"
                  >
                    <v-icon left>mdi-link-off</v-icon>
                    ยกเลิกการเชื่อมต่อ
                  </v-btn>
                </div>
              </div>

              <!-- LOADING STATUS -->
              <div
                v-if="driveIsLoadingStatus"
                class="cloud-loading-card"
              >
                <v-skeleton-loader type="list-item-avatar" class="tw-rounded-lg" />
                <v-skeleton-loader type="list-item-two-line" class="tw-rounded-lg" />
                <v-skeleton-loader type="button" width="160" />
              </div>

              <!-- NOT CONNECTED -->
              <div
                v-else-if="!driveIsConnected"
                class="connect-state-card"
              >
                <div class="connect-state-copy">
                  <div class="connect-state-icon">
                    <v-icon color="blue darken-2">mdi-google-drive</v-icon>
                  </div>
                  <div>
                    <div class="connect-state-title">ยังไม่ได้เชื่อมต่อ Google Drive</div>
                    <div class="connect-state-description">
                      เริ่มจากเชื่อมต่อบัญชี Google แล้วค่อยเลือกโฟลเดอร์ที่ต้องการให้ระบบติดตามไฟล์ใหม่
                    </div>
                    <div class="connect-steps">
                      <span>1. Connect</span>
                      <v-icon x-small color="grey">mdi-chevron-right</v-icon>
                      <span>2. Select folder</span>
                      <v-icon x-small color="grey">mdi-chevron-right</v-icon>
                      <span>3. Start Watch</span>
                    </div>
                  </div>
                </div>
                <v-btn
                  color="primary"
                  :loading="driveIsConnecting"
                  @click="connectGoogleDrive"
                  class="connect-state-action"
                >
                  <v-icon left>mdi-google</v-icon>
                  เชื่อมต่อ Google Drive
                </v-btn>
              </div>

              <!-- CONNECTED -->
              <div v-else class="tw-mt-4">

                <!-- Connected badge -->
                <div class="connected-summary">
                  <div class="connected-summary-icon">
                    <v-icon color="success" small>mdi-check-circle</v-icon>
                  </div>
                  <div>
                    <div class="connected-summary-title">เชื่อมต่อ Google Drive แล้ว</div>
                    <div class="connected-summary-description">เลือกโฟลเดอร์เพื่อเริ่ม Watch หรือจัดการ Watch ที่ใช้งานอยู่</div>
                  </div>
                </div>

                <!-- Active Watch Status Card -->
                <v-card
                  v-if="driveWatchStatus && driveWatchStatus.isWatching"
                  outlined
                  class="watch-status-card tw-mb-6"
                >
                  <v-card-text>
                    <div class="tw-flex tw-justify-between tw-items-start tw-flex-wrap tw-gap-3">
                      <div>
                        <div class="tw-flex tw-items-center tw-gap-2 tw-mb-1">
                          <v-icon color="success" small>mdi-eye</v-icon>
                          <span class="tw-font-semibold tw-text-sm">กำลัง Watch โฟลเดอร์</span>
                        </div>
                        <v-chip small color="success" text-color="white" class="tw-mb-2">
                          <v-icon left x-small>mdi-folder</v-icon>
                          {{ driveWatchStatus.folderName || driveWatchStatus.folderId }}
                        </v-chip>
                        <div v-if="driveWatchStatus.expiresAt" class="tw-text-xs tw-text-gray-400 tw-mt-1">
                          หมดอายุ: {{ formatDriveDate(driveWatchStatus.expiresAt) }}
                        </div>
                        <div
                          v-if="driveWatchStatus.lastFilesDetected && driveWatchStatus.lastFilesDetected.length"
                          class="tw-mt-2"
                        >
                          <span class="tw-text-xs tw-text-gray-500 tw-mr-1">ไฟล์ใหม่ล่าสุด:</span>
                          <v-chip
                            v-for="f in driveWatchStatus.lastFilesDetected.slice(0, 3)"
                            :key="f.fileId"
                            x-small
                            class="tw-mr-1"
                          >{{ f.name }}</v-chip>
                        </div>
                      </div>
                      <div class="tw-flex tw-gap-2 tw-flex-wrap">
                        <v-btn
                          small
                          outlined
                          :loading="isCheckingChanges"
                          @click="checkFolderChanges"
                        >
                          <v-icon left x-small>mdi-refresh</v-icon>
                          ตรวจสอบ
                        </v-btn>
                        <v-btn
                          small
                          color="error"
                          outlined
                          :loading="isStoppingWatch"
                          @click="stopWatchFolder"
                        >
                          <v-icon left x-small>mdi-eye-off</v-icon>
                          หยุด Watch
                        </v-btn>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>

                <!-- Folder Picker (shown when NOT watching) -->
                <div v-if="!driveWatchStatus || !driveWatchStatus.isWatching">
                  <div class="tw-font-semibold tw-text-black tw-mb-3 tw-text-sm">
                    เลือกโฟลเดอร์สำหรับ Watch
                  </div>

                  <!-- Drive type tabs -->
                  <v-tabs v-model="driveTab" dense @change="onDriveTabChange">
                    <v-tab>
                      <v-icon left small>mdi-harddisk</v-icon>
                      My Drive
                    </v-tab>
                    <v-tab>
                      <v-icon left small>mdi-folder-network</v-icon>
                      Shared Drives
                    </v-tab>
                  </v-tabs>

                  <v-tabs-items v-model="driveTab" class="tw-border tw-border-t-0 tw-rounded-b-lg tw-p-3">

                    <!-- ── My Drive tab ── -->
                    <v-tab-item>
                      <!-- Breadcrumb -->
                      <div class="tw-flex tw-items-center tw-flex-wrap tw-gap-1 tw-mb-3">
                        <span
                          v-for="(crumb, idx) in currentFolderPath"
                          :key="crumb.id"
                          class="tw-flex tw-items-center tw-gap-1"
                        >
                          <span
                            class="tw-text-sm tw-cursor-pointer hover:tw-underline"
                            :class="idx === currentFolderPath.length - 1
                              ? 'tw-text-black tw-font-semibold'
                              : 'tw-text-blue-600'"
                            @click="navigateToBreadcrumb(idx)"
                          >{{ crumb.name }}</span>
                          <v-icon
                            v-if="idx < currentFolderPath.length - 1"
                            x-small
                            class="tw-text-gray-400"
                          >mdi-chevron-right</v-icon>
                        </span>
                      </div>

                      <!-- Loading -->
                      <div v-if="isLoadingFolders" class="tw-flex tw-justify-center tw-py-8">
                        <v-progress-circular indeterminate color="primary" size="28" />
                      </div>

                      <!-- Empty -->
                      <div
                        v-else-if="!isLoadingFolders && folderItems.length === 0"
                        class="tw-text-center tw-py-8 tw-text-gray-400 tw-text-sm"
                      >
                        ไม่พบโฟลเดอร์ในตำแหน่งนี้
                      </div>

                      <!-- Folder list -->
                      <v-list v-else dense class="tw-rounded-lg tw-border tw-overflow-y-auto" style="max-height: 280px;">
                        <v-list-item
                          v-for="folder in folderItems"
                          :key="folder.id"
                          :class="[
                            'tw-cursor-pointer',
                            selectedWatchFolder && selectedWatchFolder.id === folder.id
                              ? 'blue lighten-5'
                              : ''
                          ]"
                          @click="selectWatchFolder(folder)"
                        >
                          <v-list-item-icon class="mr-2">
                            <v-icon color="amber darken-2" small>mdi-folder</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title class="tw-text-sm">{{ folder.name }}</v-list-item-title>
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-btn icon x-small @click.stop="navigateToFolder(folder)">
                              <v-icon small>mdi-chevron-right</v-icon>
                            </v-btn>
                          </v-list-item-action>
                        </v-list-item>
                      </v-list>
                    </v-tab-item>

                    <!-- ── Shared Drives tab ── -->
                    <v-tab-item>

                      <!-- Loading shared drives -->
                      <div v-if="isLoadingSharedDrives" class="tw-flex tw-justify-center tw-py-8">
                        <v-progress-circular indeterminate color="primary" size="28" />
                      </div>

                      <!-- No shared drives -->
                      <div
                        v-else-if="!selectedSharedDrive && sharedDrives.length === 0"
                        class="tw-text-center tw-py-8 tw-text-gray-400 tw-text-sm"
                      >
                        ไม่พบ Shared Drive
                      </div>

                      <!-- Shared Drive list -->
                      <v-list
                        v-else-if="!selectedSharedDrive"
                        dense
                        class="tw-rounded-lg tw-border tw-mt-2 tw-overflow-y-auto"
                        style="max-height: 280px;"
                      >
                        <v-list-item
                          v-for="drive in sharedDrives"
                          :key="drive.id"
                          class="tw-cursor-pointer"
                          @click="openSharedDrive(drive)"
                        >
                          <v-list-item-icon class="mr-2">
                            <v-icon color="blue darken-1" small>mdi-folder-network</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title class="tw-text-sm">{{ drive.name }}</v-list-item-title>
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-icon small>mdi-chevron-right</v-icon>
                          </v-list-item-action>
                        </v-list-item>
                      </v-list>

                      <!-- Inside a Shared Drive — breadcrumb + folder list -->
                      <div v-else>
                        <!-- Breadcrumb -->
                        <div class="tw-flex tw-items-center tw-flex-wrap tw-gap-1 tw-mb-3 tw-mt-1">
                          <span
                            class="tw-text-sm tw-cursor-pointer tw-text-blue-600 hover:tw-underline"
                            @click="selectedSharedDrive = null; sharedFolderItems = []"
                          >Shared Drives</span>
                          <v-icon x-small class="tw-text-gray-400">mdi-chevron-right</v-icon>
                          <span
                            v-for="(crumb, idx) in sharedFolderPath"
                            :key="crumb.id"
                            class="tw-flex tw-items-center tw-gap-1"
                          >
                            <span
                              class="tw-text-sm tw-cursor-pointer hover:tw-underline"
                              :class="idx === sharedFolderPath.length - 1
                                ? 'tw-text-black tw-font-semibold'
                                : 'tw-text-blue-600'"
                              @click="navigateToSharedBreadcrumb(idx)"
                            >{{ crumb.name }}</span>
                            <v-icon
                              v-if="idx < sharedFolderPath.length - 1"
                              x-small
                              class="tw-text-gray-400"
                            >mdi-chevron-right</v-icon>
                          </span>
                        </div>

                        <!-- Loading folders -->
                        <div v-if="isLoadingSharedFolders" class="tw-flex tw-justify-center tw-py-8">
                          <v-progress-circular indeterminate color="primary" size="28" />
                        </div>

                        <!-- Empty -->
                        <div
                          v-else-if="sharedFolderItems.length === 0"
                          class="tw-text-center tw-py-8 tw-text-gray-400 tw-text-sm"
                        >
                          ไม่พบโฟลเดอร์
                        </div>

                        <!-- Folder list inside shared drive -->
                        <v-list v-else dense class="tw-rounded-lg tw-border tw-overflow-y-auto" style="max-height: 280px;">
                          <v-list-item
                            v-for="folder in sharedFolderItems"
                            :key="folder.id"
                            :class="[
                              'tw-cursor-pointer',
                              selectedWatchFolder && selectedWatchFolder.id === folder.id
                                ? 'blue lighten-5'
                                : ''
                            ]"
                            @click="selectWatchFolder(folder)"
                          >
                            <v-list-item-icon class="mr-2">
                              <v-icon color="amber darken-2" small>mdi-folder</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title class="tw-text-sm">{{ folder.name }}</v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-action>
                              <v-btn icon x-small @click.stop="navigateToSharedFolder(folder)">
                                <v-icon small>mdi-chevron-right</v-icon>
                              </v-btn>
                            </v-list-item-action>
                          </v-list-item>
                        </v-list>
                      </div>
                    </v-tab-item>

                  </v-tabs-items>

                  <!-- Selected folder confirmation + Start Watch button -->
                  <div
                    v-if="selectedWatchFolder && !isStartingWatch"
                    class="watch-selection-bar"
                  >
                    <div class="watch-selection-info">
                      <div class="watch-selection-icon">
                        <v-icon color="amber darken-2" small>mdi-folder-check</v-icon>
                      </div>
                      <div>
                        <div class="watch-selection-label">โฟลเดอร์ที่เลือก</div>
                        <div class="watch-selection-name">{{ selectedWatchFolder.name }}</div>
                      </div>
                    </div>
                    <div class="watch-selection-actions">
                      <v-btn small outlined @click="selectedWatchFolder = null">
                        ยกเลิก
                      </v-btn>
                      <v-btn small color="primary" @click="startWatchFolder">
                        <v-icon left small>mdi-eye</v-icon>
                        เริ่ม Watch
                      </v-btn>
                    </div>
                  </div>

                  <!-- Starting watch indicator -->
                  <div
                    v-if="isStartingWatch"
                    class="watch-starting-bar"
                  >
                    <v-progress-circular indeterminate size="20" width="2" color="primary" />
                    <span class="tw-text-sm tw-text-gray-700">
                      กำลังเริ่ม Watch โฟลเดอร์ <span class="tw-font-semibold tw-text-blue-700">{{ selectedWatchFolder ? selectedWatchFolder.name : '' }}</span> ...
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <!-- OneDrive Configuration Section (currently unavailable) -->
            <div v-if="false && isStaff && (isApTypeOne || isApTypeTwo) && isApSelectedSyncProvider === 'oneDrive'" class="sync-provider-config cloud-provider-card cloud-provider-card--onedrive">
              <div class="cloud-provider-header">
                <div class="cloud-provider-title-row">
                  <div class="cloud-provider-icon">
                    <v-icon color="blue darken-3">mdi-microsoft-onedrive</v-icon>
                  </div>
                  <div>
                    <div class="cloud-provider-heading">OneDrive</div>
                    <div class="cloud-provider-description">
                      เชื่อมต่อ Microsoft OneDrive และเลือกโฟลเดอร์เอกสารที่ต้องการให้ระบบ Watch
                    </div>
                    <div
                      class="cloud-status-pill"
                      :class="oneDriveIsConnected ? 'cloud-status-pill--connected' : 'cloud-status-pill--idle'"
                    >
                      <v-icon x-small>{{ oneDriveIsConnected ? 'mdi-check-circle' : 'mdi-link-variant-off' }}</v-icon>
                      {{ oneDriveIsConnected ? 'เชื่อมต่อแล้ว' : 'ยังไม่เชื่อมต่อ' }}
                    </div>
                  </div>
                </div>
                <div v-if="oneDriveIsConnected && !oneDriveIsLoadingStatus" class="cloud-provider-actions">
                  <v-btn
                    color="info"
                    outlined
                    small
                    :loading="isTestingOneDriveConnection"
                    @click="testOneDriveConnection"
                  >
                    <v-icon left>mdi-router-wireless</v-icon>
                    ทดสอบ
                  </v-btn>
                  <v-btn
                    color="error"
                    outlined
                    small
                    :loading="oneDriveIsDisconnecting"
                    @click="disconnectOneDrive"
                  >
                    <v-icon left>mdi-link-off</v-icon>
                    ยกเลิกการเชื่อมต่อ
                  </v-btn>
                </div>
              </div>

              <div
                v-if="oneDriveIsLoadingStatus"
                class="cloud-loading-card"
              >
                <v-skeleton-loader type="list-item-avatar" class="tw-rounded-lg" />
                <v-skeleton-loader type="list-item-two-line" class="tw-rounded-lg" />
                <v-skeleton-loader type="button" width="160" />
              </div>

              <div
                v-else-if="!oneDriveIsConnected"
                class="connect-state-card"
              >
                <div class="connect-state-copy">
                  <div class="connect-state-icon">
                    <v-icon color="blue darken-3">mdi-microsoft-onedrive</v-icon>
                  </div>
                  <div>
                    <div class="connect-state-title">ยังไม่ได้เชื่อมต่อ OneDrive</div>
                    <div class="connect-state-description">
                      เชื่อมต่อบัญชี Microsoft เพื่อให้ระบบเข้าถึงไดรฟ์และตั้งค่าโฟลเดอร์รับเอกสาร
                    </div>
                    <div class="connect-steps">
                      <span>1. Connect</span>
                      <v-icon x-small color="grey">mdi-chevron-right</v-icon>
                      <span>2. Select drive</span>
                      <v-icon x-small color="grey">mdi-chevron-right</v-icon>
                      <span>3. Start Watch</span>
                    </div>
                  </div>
                </div>
                <v-btn
                  color="primary"
                  :loading="oneDriveIsConnecting"
                  @click="connectOneDrive"
                  class="connect-state-action"
                >
                  <v-icon left>mdi-microsoft</v-icon>
                  เชื่อมต่อ OneDrive
                </v-btn>
              </div>

              <div v-else class="tw-mt-4">
                <div class="connected-summary">
                  <div class="connected-summary-icon">
                    <v-icon color="success" small>mdi-check-circle</v-icon>
                  </div>
                  <div>
                    <div class="connected-summary-title">เชื่อมต่อ OneDrive แล้ว</div>
                    <div class="connected-summary-description">เลือกไดรฟ์และโฟลเดอร์สำหรับรับไฟล์ใบซื้ออัตโนมัติ</div>
                  </div>
                </div>

                <v-card
                  v-if="oneDriveWatchStatus && oneDriveWatchStatus.isWatching"
                  outlined
                  class="watch-status-card tw-mb-6"
                >
                  <v-card-text>
                    <div class="tw-flex tw-justify-between tw-items-start tw-flex-wrap tw-gap-3">
                      <div>
                        <div class="tw-flex tw-items-center tw-gap-2 tw-mb-1">
                          <v-icon color="success" small>mdi-eye</v-icon>
                          <span class="tw-font-semibold tw-text-sm">กำลัง Watch โฟลเดอร์</span>
                        </div>
                        <v-chip small color="success" text-color="white" class="tw-mb-2">
                          <v-icon left x-small>mdi-folder</v-icon>
                          {{ oneDriveWatchStatus.folderName || oneDriveWatchStatus.folderId }}
                        </v-chip>
                        <div v-if="oneDriveWatchStatus.expiresAt" class="tw-text-xs tw-text-gray-400 tw-mt-1">
                          หมดอายุ: {{ formatDriveDate(oneDriveWatchStatus.expiresAt) }}
                        </div>
                        <div
                          v-if="oneDriveWatchStatus.lastFilesDetected && oneDriveWatchStatus.lastFilesDetected.length"
                          class="tw-mt-2"
                        >
                          <span class="tw-text-xs tw-text-gray-500 tw-mr-1">ไฟล์ใหม่ล่าสุด:</span>
                          <v-chip
                            v-for="f in oneDriveWatchStatus.lastFilesDetected.slice(0, 3)"
                            :key="f.itemId"
                            x-small
                            class="tw-mr-1"
                          >{{ f.name }}</v-chip>
                        </div>
                      </div>
                      <div class="tw-flex tw-gap-2 tw-flex-wrap">
                        <v-btn
                          small
                          outlined
                          :loading="isCheckingOneDriveChanges"
                          @click="checkOneDriveFolderChanges"
                        >
                          <v-icon left x-small>mdi-refresh</v-icon>
                          ตรวจสอบ
                        </v-btn>
                        <v-btn
                          small
                          color="error"
                          outlined
                          :loading="isStoppingOneDriveWatch"
                          @click="stopOneDriveWatchFolder"
                        >
                          <v-icon left x-small>mdi-eye-off</v-icon>
                          หยุด Watch
                        </v-btn>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>

                <div v-if="!oneDriveWatchStatus || !oneDriveWatchStatus.isWatching">
                  <div class="tw-font-semibold tw-text-black tw-mb-3 tw-text-sm">
                    เลือกโฟลเดอร์สำหรับ Watch
                  </div>

                  <div v-if="!selectedOneDriveDrive">
                    <div v-if="isLoadingOneDriveDrives" class="tw-flex tw-justify-center tw-py-8">
                      <v-progress-circular indeterminate color="primary" size="28" />
                    </div>
                    <div
                      v-else-if="oneDriveDrives.length === 0"
                      class="tw-text-center tw-py-8 tw-text-gray-400 tw-text-sm"
                    >
                      ไม่พบ OneDrive
                    </div>
                    <v-list v-else dense class="tw-rounded-lg tw-border tw-overflow-y-auto" style="max-height: 280px;">
                      <v-list-item
                        v-for="drive in oneDriveDrives"
                        :key="drive.id"
                        class="tw-cursor-pointer"
                        @click="openOneDriveDrive(drive)"
                      >
                        <v-list-item-icon class="mr-2">
                          <v-icon color="blue darken-3" small>mdi-harddisk</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title class="tw-text-sm">{{ drive.name || 'OneDrive' }}</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-icon small>mdi-chevron-right</v-icon>
                        </v-list-item-action>
                      </v-list-item>
                    </v-list>
                  </div>

                  <div v-else>
                    <div class="tw-flex tw-items-center tw-flex-wrap tw-gap-1 tw-mb-3">
                      <span
                        class="tw-text-sm tw-cursor-pointer tw-text-blue-600 hover:tw-underline"
                        @click="resetOneDriveDriveSelection"
                      >OneDrive</span>
                      <v-icon x-small class="tw-text-gray-400">mdi-chevron-right</v-icon>
                      <span
                        v-for="(crumb, idx) in oneDriveFolderPath"
                        :key="crumb.id"
                        class="tw-flex tw-items-center tw-gap-1"
                      >
                        <span
                          class="tw-text-sm tw-cursor-pointer hover:tw-underline"
                          :class="idx === oneDriveFolderPath.length - 1
                            ? 'tw-text-black tw-font-semibold'
                            : 'tw-text-blue-600'"
                          @click="navigateToOneDriveBreadcrumb(idx)"
                        >{{ crumb.name }}</span>
                        <v-icon
                          v-if="idx < oneDriveFolderPath.length - 1"
                          x-small
                          class="tw-text-gray-400"
                        >mdi-chevron-right</v-icon>
                      </span>
                    </div>

                    <div v-if="isLoadingOneDriveFolders" class="tw-flex tw-justify-center tw-py-8">
                      <v-progress-circular indeterminate color="primary" size="28" />
                    </div>
                    <div
                      v-else-if="oneDriveFolderItems.length === 0"
                      class="tw-text-center tw-py-8 tw-text-gray-400 tw-text-sm"
                    >
                      ไม่พบโฟลเดอร์
                    </div>
                    <v-list v-else dense class="tw-rounded-lg tw-border tw-overflow-y-auto" style="max-height: 280px;">
                      <v-list-item
                        v-for="folder in oneDriveFolderItems"
                        :key="folder.id"
                        :class="[
                          'tw-cursor-pointer',
                          selectedOneDriveWatchFolder && selectedOneDriveWatchFolder.id === folder.id
                            ? 'blue lighten-5'
                            : ''
                        ]"
                        @click="selectOneDriveWatchFolder(folder)"
                      >
                        <v-list-item-icon class="mr-2">
                          <v-icon color="amber darken-2" small>mdi-folder</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title class="tw-text-sm">{{ folder.name }}</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-btn icon x-small @click.stop="navigateToOneDriveFolder(folder)">
                            <v-icon small>mdi-chevron-right</v-icon>
                          </v-btn>
                        </v-list-item-action>
                      </v-list-item>
                    </v-list>
                  </div>

                  <div
                    v-if="selectedOneDriveWatchFolder && !isStartingOneDriveWatch"
                    class="watch-selection-bar"
                  >
                    <div class="watch-selection-info">
                      <div class="watch-selection-icon">
                        <v-icon color="amber darken-2" small>mdi-folder-check</v-icon>
                      </div>
                      <div>
                        <div class="watch-selection-label">โฟลเดอร์ที่เลือก</div>
                        <div class="watch-selection-name">{{ selectedOneDriveWatchFolder.name }}</div>
                      </div>
                    </div>
                    <div class="watch-selection-actions">
                      <v-btn small outlined @click="selectedOneDriveWatchFolder = null">
                        ยกเลิก
                      </v-btn>
                      <v-btn small color="primary" @click="startOneDriveWatchFolder">
                        <v-icon left small>mdi-eye</v-icon>
                        เริ่ม Watch
                      </v-btn>
                    </div>
                  </div>

                  <div
                    v-if="isStartingOneDriveWatch"
                    class="watch-starting-bar"
                  >
                    <v-progress-circular indeterminate size="20" width="2" color="primary" />
                    <span class="tw-text-sm tw-text-gray-700">
                      กำลังเริ่ม Watch โฟลเดอร์ <span class="tw-font-semibold tw-text-blue-700">{{ selectedOneDriveWatchFolder ? selectedOneDriveWatchFolder.name : '' }}</span> ...
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Dropbox Configuration Section -->
            <div v-if="isStaff && (isApTypeOne || isApTypeTwo) && isApSelectedSyncProvider === 'dropbox'" class="sync-provider-config cloud-provider-card cloud-provider-card--dropbox">
              <div class="cloud-provider-header">
                <div class="cloud-provider-title-row">
                  <div class="cloud-provider-icon">
                    <v-icon color="blue darken-3">mdi-dropbox</v-icon>
                  </div>
                  <div>
                    <div class="cloud-provider-heading">Dropbox</div>
                    <div class="cloud-provider-description">
                      เชื่อมต่อ Dropbox และ Watch โฟลเดอร์เอกสารที่เข้ามาใหม่แบบต่อเนื่อง
                    </div>
                    <div
                      class="cloud-status-pill"
                      :class="dropboxIsConnected ? 'cloud-status-pill--connected' : 'cloud-status-pill--idle'"
                    >
                      <v-icon x-small>{{ dropboxIsConnected ? 'mdi-check-circle' : 'mdi-link-variant-off' }}</v-icon>
                      {{ dropboxIsConnected ? 'เชื่อมต่อแล้ว' : 'ยังไม่เชื่อมต่อ' }}
                    </div>
                  </div>
                </div>
                <div v-if="dropboxIsConnected && !dropboxIsLoadingStatus" class="cloud-provider-actions">
                  <v-btn
                    color="info"
                    outlined
                    small
                    :loading="isTestingDropboxConnection"
                    @click="testDropboxConnection"
                  >
                    <v-icon left>mdi-router-wireless</v-icon>
                    ทดสอบ
                  </v-btn>
                  <v-btn
                    color="error"
                    outlined
                    small
                    :loading="dropboxIsDisconnecting"
                    @click="disconnectDropbox"
                  >
                    <v-icon left>mdi-link-off</v-icon>
                    ยกเลิกการเชื่อมต่อ
                  </v-btn>
                </div>
              </div>

              <div
                v-if="dropboxIsLoadingStatus"
                class="cloud-loading-card"
              >
                <v-skeleton-loader type="list-item-avatar" class="tw-rounded-lg" />
                <v-skeleton-loader type="list-item-two-line" class="tw-rounded-lg" />
                <v-skeleton-loader type="button" width="160" />
              </div>

              <div
                v-else-if="!dropboxIsConnected"
                class="connect-state-card"
              >
                <div class="connect-state-copy">
                  <div class="connect-state-icon">
                    <v-icon color="blue darken-3">mdi-dropbox</v-icon>
                  </div>
                  <div>
                    <div class="connect-state-title">ยังไม่ได้เชื่อมต่อ Dropbox</div>
                    <div class="connect-state-description">
                      เชื่อมต่อ Dropbox เพื่อให้ระบบติดตามโฟลเดอร์และดึงไฟล์ใหม่เข้า AP Automation
                    </div>
                    <div class="connect-steps">
                      <span>1. Connect</span>
                      <v-icon x-small color="grey">mdi-chevron-right</v-icon>
                      <span>2. Pick folder</span>
                      <v-icon x-small color="grey">mdi-chevron-right</v-icon>
                      <span>3. Start Watch</span>
                    </div>
                  </div>
                </div>
                <v-btn
                  color="primary"
                  :loading="dropboxIsConnecting"
                  @click="connectDropbox"
                  class="connect-state-action"
                >
                  <v-icon left>mdi-dropbox</v-icon>
                  เชื่อมต่อ Dropbox
                </v-btn>
              </div>

              <div v-else class="tw-mt-4">
                <div class="connected-summary">
                  <div class="connected-summary-icon">
                    <v-icon color="success" small>mdi-check-circle</v-icon>
                  </div>
                  <div>
                    <div class="connected-summary-title">เชื่อมต่อ Dropbox แล้ว</div>
                    <div class="connected-summary-description">เลือกโฟลเดอร์ที่ต้องการให้ระบบตรวจไฟล์ใหม่จาก Dropbox</div>
                  </div>
                </div>

                <v-card
                  v-if="dropboxWatchStatus && dropboxWatchStatus.isWatching"
                  outlined
                  class="watch-status-card tw-mb-6"
                >
                  <v-card-text>
                    <div class="tw-flex tw-justify-between tw-items-start tw-flex-wrap tw-gap-3">
                      <div>
                        <div class="tw-flex tw-items-center tw-gap-2 tw-mb-1">
                          <v-icon color="success" small>mdi-eye</v-icon>
                          <span class="tw-font-semibold tw-text-sm">กำลัง Watch โฟลเดอร์</span>
                        </div>
                        <v-chip small color="success" text-color="white" class="tw-mb-2">
                          <v-icon left x-small>mdi-folder</v-icon>
                          {{ dropboxWatchStatus.folderName || dropboxWatchStatus.folderPath || dropboxWatchStatus.folderId }}
                        </v-chip>
                        <div
                          v-if="dropboxWatchStatus.lastFilesDetected && dropboxWatchStatus.lastFilesDetected.length"
                          class="tw-mt-2"
                        >
                          <span class="tw-text-xs tw-text-gray-500 tw-mr-1">ไฟล์ใหม่ล่าสุด:</span>
                          <v-chip
                            v-for="f in dropboxWatchStatus.lastFilesDetected.slice(0, 3)"
                            :key="f.id"
                            x-small
                            class="tw-mr-1"
                          >{{ f.name }}</v-chip>
                        </div>
                      </div>
                      <div class="tw-flex tw-gap-2 tw-flex-wrap">
                        <v-btn
                          small
                          outlined
                          :loading="isCheckingDropboxChanges"
                          @click="checkDropboxFolderChanges"
                        >
                          <v-icon left x-small>mdi-refresh</v-icon>
                          ตรวจสอบ
                        </v-btn>
                        <v-btn
                          small
                          color="error"
                          outlined
                          :loading="isStoppingDropboxWatch"
                          @click="stopDropboxWatchFolder"
                        >
                          <v-icon left x-small>mdi-eye-off</v-icon>
                          หยุด Watch
                        </v-btn>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>

                <div v-if="!dropboxWatchStatus || !dropboxWatchStatus.isWatching">
                  <div class="tw-font-semibold tw-text-black tw-mb-3 tw-text-sm">
                    เลือกโฟลเดอร์สำหรับ Watch
                  </div>

                  <div class="tw-flex tw-items-center tw-flex-wrap tw-gap-1 tw-mb-3">
                    <span
                      class="tw-text-sm tw-cursor-pointer tw-text-blue-600 hover:tw-underline"
                      @click="resetDropboxBreadcrumb"
                    >Dropbox</span>
                    <v-icon x-small class="tw-text-gray-400">mdi-chevron-right</v-icon>
                    <span
                      v-for="(crumb, idx) in dropboxFolderPath"
                      :key="crumb.path"
                      class="tw-flex tw-items-center tw-gap-1"
                    >
                      <span
                        class="tw-text-sm tw-cursor-pointer hover:tw-underline"
                        :class="idx === dropboxFolderPath.length - 1
                          ? 'tw-text-black tw-font-semibold'
                          : 'tw-text-blue-600'"
                        @click="navigateToDropboxBreadcrumb(idx)"
                      >{{ crumb.name }}</span>
                      <v-icon
                        v-if="idx < dropboxFolderPath.length - 1"
                        x-small
                        class="tw-text-gray-400"
                      >mdi-chevron-right</v-icon>
                    </span>
                  </div>

                  <div v-if="isLoadingDropboxFolders" class="tw-flex tw-justify-center tw-py-8">
                    <v-progress-circular indeterminate color="primary" size="28" />
                  </div>
                  <div
                    v-else-if="dropboxFolderItems.length === 0"
                    class="tw-text-center tw-py-8 tw-text-gray-400 tw-text-sm"
                  >
                    ไม่พบโฟลเดอร์
                  </div>
                  <v-list v-else dense class="tw-rounded-lg tw-border tw-overflow-y-auto" style="max-height: 280px;">
                    <v-list-item
                      v-for="folder in dropboxFolderItems"
                      :key="folder.id"
                      :class="[
                        'tw-cursor-pointer',
                        selectedDropboxWatchFolder && selectedDropboxWatchFolder.id === folder.id
                          ? 'blue lighten-5'
                          : ''
                      ]"
                      @click="selectDropboxWatchFolder(folder)"
                    >
                      <v-list-item-icon class="mr-2">
                        <v-icon color="amber darken-2" small>mdi-folder</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title class="tw-text-sm">{{ folder.name }}</v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-btn icon x-small @click.stop="navigateToDropboxFolder(folder)">
                          <v-icon small>mdi-chevron-right</v-icon>
                        </v-btn>
                      </v-list-item-action>
                    </v-list-item>
                  </v-list>

                  <div
                    v-if="selectedDropboxWatchFolder && !isStartingDropboxWatch"
                    class="watch-selection-bar"
                  >
                    <div class="watch-selection-info">
                      <div class="watch-selection-icon">
                        <v-icon color="amber darken-2" small>mdi-folder-check</v-icon>
                      </div>
                      <div>
                        <div class="watch-selection-label">โฟลเดอร์ที่เลือก</div>
                        <div class="watch-selection-name">{{ selectedDropboxWatchFolder.name }}</div>
                      </div>
                    </div>
                    <div class="watch-selection-actions">
                      <v-btn small outlined @click="selectedDropboxWatchFolder = null">
                        ยกเลิก
                      </v-btn>
                      <v-btn small color="primary" @click="startDropboxWatchFolder">
                        <v-icon left small>mdi-eye</v-icon>
                        เริ่ม Watch
                      </v-btn>
                    </div>
                  </div>

                  <div
                    v-if="isStartingDropboxWatch"
                    class="watch-starting-bar"
                  >
                    <v-progress-circular indeterminate size="20" width="2" color="primary" />
                    <span class="tw-text-sm tw-text-gray-700">
                      กำลังเริ่ม Watch โฟลเดอร์ <span class="tw-font-semibold tw-text-blue-700">{{ selectedDropboxWatchFolder ? selectedDropboxWatchFolder.name : '' }}</span> ...
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Box.com Configuration Section -->
            <div v-if="isStaff && (isApTypeOne || isApTypeTwo) && isApSelectedSyncProvider === 'box'" class="sync-provider-config cloud-provider-card cloud-provider-card--box">
              <div class="cloud-provider-header">
                <div class="cloud-provider-title-row">
                  <div class="cloud-provider-icon">
                    <v-icon color="blue darken-3">mdi-package-variant-closed</v-icon>
                  </div>
                  <div>
                    <div class="cloud-provider-heading">Box.com</div>
                    <div class="cloud-provider-description">
                      เชื่อมต่อ Box และเลือกโฟลเดอร์ที่ใช้รับเอกสารใบซื้อสำหรับ Watch
                    </div>
                    <div
                      class="cloud-status-pill"
                      :class="boxIsConnected ? 'cloud-status-pill--connected' : 'cloud-status-pill--idle'"
                    >
                      <v-icon x-small>{{ boxIsConnected ? 'mdi-check-circle' : 'mdi-link-variant-off' }}</v-icon>
                      {{ boxIsConnected ? 'เชื่อมต่อแล้ว' : 'ยังไม่เชื่อมต่อ' }}
                    </div>
                  </div>
                </div>
                <div v-if="boxIsConnected && !boxIsLoadingStatus" class="cloud-provider-actions">
                  <v-btn
                    color="info"
                    outlined
                    small
                    :loading="isTestingBoxConnection"
                    @click="testBoxConnection"
                  >
                    <v-icon left>mdi-router-wireless</v-icon>
                    ทดสอบ
                  </v-btn>
                  <v-btn
                    color="error"
                    outlined
                    small
                    :loading="boxIsDisconnecting"
                    @click="disconnectBox"
                  >
                    <v-icon left>mdi-link-off</v-icon>
                    ยกเลิกการเชื่อมต่อ
                  </v-btn>
                </div>
              </div>

              <div
                v-if="boxIsLoadingStatus"
                class="cloud-loading-card"
              >
                <v-skeleton-loader type="list-item-avatar" class="tw-rounded-lg" />
                <v-skeleton-loader type="list-item-two-line" class="tw-rounded-lg" />
                <v-skeleton-loader type="button" width="160" />
              </div>

              <div
                v-else-if="!boxIsConnected"
                class="connect-state-card"
              >
                <div class="connect-state-copy">
                  <div class="connect-state-icon">
                    <v-icon color="blue darken-3">mdi-package-variant-closed</v-icon>
                  </div>
                  <div>
                    <div class="connect-state-title">ยังไม่ได้เชื่อมต่อ Box.com</div>
                    <div class="connect-state-description">
                      เชื่อมต่อ Box เพื่อให้ระบบอ่านโฟลเดอร์และ Watch ไฟล์ใหม่จากพื้นที่เอกสารของบริษัท
                    </div>
                    <div class="connect-steps">
                      <span>1. Connect</span>
                      <v-icon x-small color="grey">mdi-chevron-right</v-icon>
                      <span>2. Pick folder</span>
                      <v-icon x-small color="grey">mdi-chevron-right</v-icon>
                      <span>3. Start Watch</span>
                    </div>
                  </div>
                </div>
                <v-btn
                  color="primary"
                  :loading="boxIsConnecting"
                  @click="connectBox"
                  class="connect-state-action"
                >
                  <v-icon left>mdi-package-variant-closed</v-icon>
                  เชื่อมต่อ Box.com
                </v-btn>
              </div>

              <div v-else class="tw-mt-4">
                <div class="connected-summary">
                  <div class="connected-summary-icon">
                    <v-icon color="success" small>mdi-check-circle</v-icon>
                  </div>
                  <div>
                    <div class="connected-summary-title">เชื่อมต่อ Box.com แล้ว</div>
                    <div class="connected-summary-description">เลือกโฟลเดอร์ Box ที่ต้องการใช้เป็นช่องทางรับไฟล์อัตโนมัติ</div>
                  </div>
                </div>

                <v-card
                  v-if="boxWatchStatus && boxWatchStatus.isWatching"
                  outlined
                  class="watch-status-card tw-mb-6"
                >
                  <v-card-text>
                    <div class="tw-flex tw-justify-between tw-items-start tw-flex-wrap tw-gap-3">
                      <div>
                        <div class="tw-flex tw-items-center tw-gap-2 tw-mb-1">
                          <v-icon color="success" small>mdi-eye</v-icon>
                          <span class="tw-font-semibold tw-text-sm">กำลัง Watch โฟลเดอร์</span>
                        </div>
                        <v-chip small color="success" text-color="white" class="tw-mb-2">
                          <v-icon left x-small>mdi-folder</v-icon>
                          {{ boxWatchStatus.folderName || boxWatchStatus.folderId }}
                        </v-chip>
                        <div
                          v-if="boxWatchStatus.lastFilesDetected && boxWatchStatus.lastFilesDetected.length"
                          class="tw-mt-2"
                        >
                          <span class="tw-text-xs tw-text-gray-500 tw-mr-1">ไฟล์ใหม่ล่าสุด:</span>
                          <v-chip
                            v-for="f in boxWatchStatus.lastFilesDetected.slice(0, 3)"
                            :key="f.id"
                            x-small
                            class="tw-mr-1"
                          >{{ f.name }}</v-chip>
                        </div>
                      </div>
                      <div class="tw-flex tw-gap-2 tw-flex-wrap">
                        <v-btn
                          small
                          outlined
                          :loading="isCheckingBoxChanges"
                          @click="checkBoxFolderChanges"
                        >
                          <v-icon left x-small>mdi-refresh</v-icon>
                          ตรวจสอบ
                        </v-btn>
                        <v-btn
                          small
                          color="error"
                          outlined
                          :loading="isStoppingBoxWatch"
                          @click="stopBoxWatchFolder"
                        >
                          <v-icon left x-small>mdi-eye-off</v-icon>
                          หยุด Watch
                        </v-btn>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>

                <div v-if="!boxWatchStatus || !boxWatchStatus.isWatching">
                  <div class="tw-font-semibold tw-text-black tw-mb-3 tw-text-sm">
                    เลือกโฟลเดอร์สำหรับ Watch
                  </div>

                  <div class="tw-flex tw-items-center tw-flex-wrap tw-gap-1 tw-mb-3">
                    <span
                      class="tw-text-sm tw-cursor-pointer tw-text-blue-600 hover:tw-underline"
                      @click="resetBoxBreadcrumb"
                    >All Files</span>
                    <v-icon x-small class="tw-text-gray-400">mdi-chevron-right</v-icon>
                    <span
                      v-for="(crumb, idx) in boxFolderPath"
                      :key="crumb.id"
                      class="tw-flex tw-items-center tw-gap-1"
                    >
                      <span
                        class="tw-text-sm tw-cursor-pointer hover:tw-underline"
                        :class="idx === boxFolderPath.length - 1
                          ? 'tw-text-black tw-font-semibold'
                          : 'tw-text-blue-600'"
                        @click="navigateToBoxBreadcrumb(idx)"
                      >{{ crumb.name }}</span>
                      <v-icon
                        v-if="idx < boxFolderPath.length - 1"
                        x-small
                        class="tw-text-gray-400"
                      >mdi-chevron-right</v-icon>
                    </span>
                  </div>

                  <div v-if="isLoadingBoxFolders" class="tw-flex tw-justify-center tw-py-8">
                    <v-progress-circular indeterminate color="primary" size="28" />
                  </div>
                  <div
                    v-else-if="boxFolderItems.length === 0"
                    class="tw-text-center tw-py-8 tw-text-gray-400 tw-text-sm"
                  >
                    ไม่พบโฟลเดอร์
                  </div>
                  <v-list v-else dense class="tw-rounded-lg tw-border tw-overflow-y-auto" style="max-height: 280px;">
                    <v-list-item
                      v-for="folder in boxFolderItems"
                      :key="folder.id"
                      :class="[
                        'tw-cursor-pointer',
                        selectedBoxWatchFolder && selectedBoxWatchFolder.id === folder.id
                          ? 'blue lighten-5'
                          : ''
                      ]"
                      @click="selectBoxWatchFolder(folder)"
                    >
                      <v-list-item-icon class="mr-2">
                        <v-icon color="amber darken-2" small>mdi-folder</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title class="tw-text-sm">{{ folder.name }}</v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-btn icon x-small @click.stop="navigateToBoxFolder(folder)">
                          <v-icon small>mdi-chevron-right</v-icon>
                        </v-btn>
                      </v-list-item-action>
                    </v-list-item>
                  </v-list>

                  <div
                    v-if="selectedBoxWatchFolder && !isStartingBoxWatch"
                    class="watch-selection-bar"
                  >
                    <div class="watch-selection-info">
                      <div class="watch-selection-icon">
                        <v-icon color="amber darken-2" small>mdi-folder-check</v-icon>
                      </div>
                      <div>
                        <div class="watch-selection-label">โฟลเดอร์ที่เลือก</div>
                        <div class="watch-selection-name">{{ selectedBoxWatchFolder.name }}</div>
                      </div>
                    </div>
                    <div class="watch-selection-actions">
                      <v-btn small outlined @click="selectedBoxWatchFolder = null">
                        ยกเลิก
                      </v-btn>
                      <v-btn small color="primary" @click="startBoxWatchFolder">
                        <v-icon left small>mdi-eye</v-icon>
                        เริ่ม Watch
                      </v-btn>
                    </div>
                  </div>

                  <div
                    v-if="isStartingBoxWatch"
                    class="watch-starting-bar"
                  >
                    <v-progress-circular indeterminate size="20" width="2" color="primary" />
                    <span class="tw-text-sm tw-text-gray-700">
                      กำลังเริ่ม Watch โฟลเดอร์ <span class="tw-font-semibold tw-text-blue-700">{{ selectedBoxWatchFolder ? selectedBoxWatchFolder.name : '' }}</span> ...
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <!-- PSC Connector Configuration Section -->
            <div v-if="isStaff && (isApTypeOne || isApTypeTwo) && isApSelectedSyncProvider === 'pscConnector'" class="sync-provider-config cloud-provider-card cloud-provider-card--psc">
              <div class="cloud-provider-header">
                <div class="cloud-provider-title-row">
                  <div class="cloud-provider-icon">
                    <v-icon color="deep-purple darken-2">mdi-connection</v-icon>
                  </div>
                  <div>
                    <div class="cloud-provider-heading">PSC Connector</div>
                    <div class="cloud-provider-description">
                      บริการเชื่อมต่อแอปพลิเคชันภายนอกสำหรับซิงค์เอกสารใบซื้อ
                    </div>
                    <div
                      class="cloud-status-pill"
                      :class="pscIsConnected ? 'cloud-status-pill--connected' : 'cloud-status-pill--idle'"
                    >
                      <v-icon x-small>{{ pscIsConnected ? 'mdi-check-circle' : 'mdi-link-variant-off' }}</v-icon>
                      {{ pscIsConnected ? 'เชื่อมต่อแล้ว' : 'ยังไม่เชื่อมต่อ' }}
                    </div>
                  </div>
                </div>
                <div class="cloud-provider-actions">
                  <v-btn
                    color="info"
                    outlined
                    small
                    :loading="pscIsLoadingStatus"
                    @click="loadPscStatus"
                  >
                    <v-icon left>mdi-refresh</v-icon>
                    รีเฟรชสถานะ
                  </v-btn>
                </div>
              </div>

              <div v-if="pscIsLoadingStatus" class="cloud-loading-card">
                <v-skeleton-loader type="list-item-avatar" class="tw-rounded-lg" />
                <v-skeleton-loader type="list-item-two-line" class="tw-rounded-lg" />
              </div>

              <div v-else class="tw-mt-4">
                <div class="psc-status-grid">
                  <div class="psc-status-tile">
                    <div class="psc-status-tile-label">การเชื่อมต่อ</div>
                    <div
                      class="psc-status-tile-value"
                      :class="pscIsConnected ? 'psc-status-tile-value--ok' : 'psc-status-tile-value--idle'"
                    >
                      <v-icon small :color="pscIsConnected ? 'success' : 'grey'">
                        {{ pscIsConnected ? 'mdi-check-circle' : 'mdi-link-variant-off' }}
                      </v-icon>
                      <span>{{ pscIsConnected ? 'เคยเชื่อมต่อแล้ว' : 'ยังไม่เคยเชื่อมต่อ' }}</span>
                    </div>
                  </div>
                  <div class="psc-status-tile">
                    <div class="psc-status-tile-label">สถานะการทำงาน</div>
                    <div
                      class="psc-status-tile-value"
                      :class="pscIsSyncing ? 'psc-status-tile-value--running' : 'psc-status-tile-value--idle'"
                    >
                      <v-icon small :color="pscIsSyncing ? 'success' : 'grey'">
                        {{ pscIsSyncing ? 'mdi-sync' : 'mdi-pause-circle-outline' }}
                      </v-icon>
                      <span>{{ pscIsSyncing ? 'กำลังทำงาน (Running)' : 'หยุดทำงาน (Stopped)' }}</span>
                    </div>
                  </div>
                </div>
                <div v-if="pscStatusLastFetchedAt" class="psc-status-meta">
                  อัปเดตล่าสุด: {{ pscStatusLastFetchedAt.toLocaleString() }}
                </div>
                <v-alert
                  type="info"
                  outlined
                  dense
                  class="tw-mt-4 tw-mb-0"
                  icon="mdi-information-outline"
                >
                  การตั้งค่า PSC Connector ทำผ่านระบบภายนอก — หน้านี้แสดงเฉพาะสถานะ
                  ใช้ปุ่ม “รีเฟรชสถานะ” เพื่ออัปเดตข้อมูลล่าสุด
                </v-alert>
              </div>
            </div>
            </section>

            <!-- FoxPro Configuration Section -->
            <template v-if="isStaff && isApTypeTwo">
            <section id="section-foxpro" class="settings-section cloud-provider-card cloud-provider-card--foxpro">
              <div class="cloud-provider-header">
                <div class="cloud-provider-title-row">
                  <div class="cloud-provider-icon">
                    <v-icon color="blue-grey darken-2">mdi-database-outline</v-icon>
                  </div>
                  <div>
                    <div class="cloud-provider-heading">ตั้งค่าการเชื่อมต่อ FoxPro</div>
                    <div class="cloud-provider-description">
                      เชื่อมต่อข้อมูล Express จากไฟล์ DBF — เลือกระหว่าง SMB tunnel หรือ daemon บนเครื่องปลายทาง
                    </div>
                    <div
                      class="cloud-status-pill"
                      :class="foxproStatusPillClass"
                    >
                      <v-icon x-small>{{ foxproStatusPillIcon }}</v-icon>
                      {{ foxproStatusPillLabel }}
                    </div>
                  </div>
                </div>
                <div class="cloud-provider-actions">
                  <v-btn
                    v-if="!isEditingFoxproConfig"
                    @click="toggleFoxproConfigEdit"
                    color="warning"
                    outlined
                    small
                  >
                    <v-icon left small>mdi-pencil</v-icon>
                    แก้ไข
                  </v-btn>
                  <template v-else>
                    <v-btn
                      @click="saveFoxproConfig"
                      color="primary"
                      small
                      :loading="isSavingFoxproConfig"
                    >
                      <v-icon left small>mdi-content-save</v-icon>
                      บันทึก
                    </v-btn>
                    <v-btn
                      @click="cancelFoxproConfigEdit"
                      outlined
                      small
                    >
                      ยกเลิก
                    </v-btn>
                  </template>
                </div>
              </div>

              <v-alert
                v-if="!daemonFlagEnabled && foxproConfig.storageMode === 'daemon'"
                type="warning"
                outlined
                dense
                class="tw-mt-4 tw-mb-0"
              >
                Daemon pilot flag is off สำหรับบริษัทนี้ — บริษัทถูกตั้งเป็น daemon
                ไว้แล้ว สามารถปิด/สลับกลับ SMB ได้ แต่จะกลับมาใช้ daemon
                ต้องเปิด <code>features.foxproDaemon</code> ก่อน
              </v-alert>

              <div class="foxpro-mode-row">
                <div class="foxpro-mode-label">โหมดการเชื่อมต่อ</div>
                <v-btn-toggle
                  v-model="foxproConfig.storageMode"
                  mandatory
                  color="primary"
                  dense
                >
                  <v-btn value="smb" :disabled="foxproFieldsDisabled">
                    <v-icon left small>mdi-cloud-outline</v-icon>
                    SMB Tunnel
                  </v-btn>
                  <v-btn
                    v-if="daemonFlagEnabled || foxproConfig.storageMode === 'daemon'"
                    value="daemon"
                    :disabled="foxproFieldsDisabled"
                  >
                    <v-icon left small>mdi-server-network</v-icon>
                    Daemon (on-prem CLI)
                  </v-btn>
                </v-btn-toggle>
              </div>

              <!-- SMB fields are hidden when daemon is selected but never cleared,
                   so support can switch a customer back without retyping (per
                   docs/foxpro-daemon-migration.md §3). -->
              <template v-if="foxproConfig.storageMode !== 'daemon'">
                <div class="foxpro-fieldset">
                  <div class="foxpro-fieldset-title">
                    <v-icon small left color="grey darken-2">mdi-cloud-outline</v-icon>
                    Cloudflare Tunnel
                  </div>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="foxproConfig.apiUrl"
                        outlined
                        dense
                        label="API URL *"
                        placeholder="https://your-tunnel.trycloudflare.com"
                        persistent-placeholder
                        hint="Tunnel URL ที่ proxy เข้าไปยัง FoxPro reader"
                        persistent-hint
                        :disabled="foxproFieldsDisabled"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </div>

                <div class="foxpro-fieldset">
                  <div class="foxpro-fieldset-title">
                    <v-icon small left color="grey darken-2">mdi-folder-network-outline</v-icon>
                    Network Share
                  </div>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="foxproConfig.networkPath"
                        outlined
                        dense
                        label="Network Path *"
                        placeholder="\\10.1.1.17 หรือ \\server-name"
                        persistent-placeholder
                        :disabled="foxproFieldsDisabled"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="foxproConfig.shareName"
                        outlined
                        dense
                        label="Share Name *"
                        placeholder="expresi01, SharedFolder"
                        persistent-placeholder
                        :disabled="foxproFieldsDisabled"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="foxproConfig.basePath"
                        outlined
                        dense
                        label="Base Path"
                        placeholder="DB/DATA"
                        persistent-placeholder
                        hint="โฟลเดอร์ย่อยภายใน share (optional)"
                        persistent-hint
                        :disabled="foxproFieldsDisabled"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="foxproConfig.domain"
                        outlined
                        dense
                        label="Domain"
                        placeholder="WORKGROUP"
                        persistent-placeholder
                        hint="ใส่เฉพาะกรณีต้องใช้ domain authentication"
                        persistent-hint
                        :disabled="foxproFieldsDisabled"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </div>

                <div class="foxpro-fieldset">
                  <div class="foxpro-fieldset-title">
                    <v-icon small left color="grey darken-2">mdi-key-outline</v-icon>
                    Credentials
                  </div>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="foxproConfig.username"
                        outlined
                        dense
                        label="Username *"
                        placeholder="Windows network username"
                        persistent-placeholder
                        :disabled="foxproFieldsDisabled"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="foxproConfig.password"
                        outlined
                        dense
                        :type="showFoxproPassword ? 'text' : 'password'"
                        :append-icon="showFoxproPassword ? 'mdi-eye' : 'mdi-eye-off'"
                        @click:append="toggleShowFoxproPassword"
                        label="Password *"
                        placeholder="Windows network password"
                        persistent-placeholder
                        :disabled="foxproFieldsDisabled"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </div>

                <div class="foxpro-test-row">
                  <v-btn
                    color="info"
                    outlined
                    :loading="isTestingFoxproConnection"
                    :disabled="foxproTestConnectionDisabled"
                    @click="testFoxproConnection"
                  >
                    <v-icon left small>mdi-router-wireless</v-icon>
                    ทดสอบการเชื่อมต่อ
                  </v-btn>
                  <div
                    v-if="foxproLastTestAt"
                    class="foxpro-test-result"
                    :class="foxproLastTestOk ? 'foxpro-test-result--ok' : 'foxpro-test-result--fail'"
                  >
                    <v-icon small :color="foxproLastTestOk ? 'success' : 'error'">
                      {{ foxproLastTestOk ? 'mdi-check-circle' : 'mdi-alert-circle' }}
                    </v-icon>
                    <div class="foxpro-test-result-body">
                      <div class="foxpro-test-result-label">
                        {{ foxproLastTestOk ? 'เชื่อมต่อสำเร็จ' : 'เชื่อมต่อล้มเหลว' }}
                      </div>
                      <div class="foxpro-test-result-meta">
                        ทดสอบเมื่อ {{ foxproLastTestAt.toLocaleString() }}<template v-if="!foxproLastTestOk && foxproLastTestError"> — {{ foxproLastTestError }}</template>
                      </div>
                    </div>
                  </div>
                  <div v-else-if="foxproTestConnectionDisabled" class="foxpro-test-hint">
                    กรอก API URL, Network Path, Share Name และ Username ก่อนทดสอบ
                  </div>
                </div>
              </template>

              <template v-if="foxproConfig.storageMode === 'daemon'">
                <div class="psc-status-grid tw-mt-4">
                  <div class="psc-status-tile">
                    <div class="psc-status-tile-label">สถานะ Daemon</div>
                    <div
                      class="psc-status-tile-value"
                      :class="daemonStatusTileClass"
                    >
                      <v-icon small :color="daemonPresenceColor">{{ daemonPresenceIcon }}</v-icon>
                      <span>{{ daemonStatusTileLabel }}</span>
                    </div>
                  </div>
                  <div class="psc-status-tile">
                    <div class="psc-status-tile-label">เครื่อง / Version</div>
                    <div class="psc-status-tile-value">
                      <v-icon small color="grey darken-1">mdi-desktop-tower</v-icon>
                      <span>
                        <template v-if="daemonWorker && daemonWorker.machineName">
                          {{ daemonWorker.machineName }}<template v-if="daemonWorker.capabilities && daemonWorker.capabilities.version"> · v{{ daemonWorker.capabilities.version }}</template>
                        </template>
                        <template v-else>—</template>
                      </span>
                    </div>
                  </div>
                </div>
                <div v-if="daemonWorker && daemonWorker.lastSeen" class="psc-status-meta">
                  Last seen: {{ formatDaemonLastSeen(daemonWorker.lastSeen) }}
                </div>
                <div v-if="foxproConfig.daemonWorkerId" class="psc-status-meta">
                  Worker ID:
                  <code class="tw-bg-grey-lighten-4 tw-px-1 tw-rounded">{{ foxproConfig.daemonWorkerId }}</code>
                </div>
                <div v-else class="psc-status-meta">
                  ยังไม่ได้จับคู่ daemon — รัน CLI แล้วเปิดลิงก์ที่ CLI สร้างเพื่อ pair กับบริษัทนี้
                </div>

                <div class="foxpro-fieldset tw-mt-4">
                  <div class="foxpro-fieldset-title">
                    <v-icon small left color="grey darken-2">mdi-folder-outline</v-icon>
                    Company Folder
                  </div>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="foxproConfig.basePath"
                        outlined
                        dense
                        label="Company folder (basePath) *"
                        placeholder="M522DS"
                        persistent-placeholder
                        :disabled="foxproFieldsDisabled"
                        hint="โฟลเดอร์ย่อยของบริษัทใต้ --foxpro-path"
                        persistent-hint
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </div>

                <v-card
                  outlined
                  class="tw-mt-3"
                  style="box-shadow: 0 8px 16px -4px rgba(0, 0, 0, 0.10) !important;"
                >
                  <v-card-title class="tw-text-base tw-font-bold tw-py-2">
                    <v-icon left>mdi-console</v-icon>
                    Daemon Setup
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-card-text class="tw-pt-3">
                    <ol class="tw-list-decimal tw-pl-6 tw-space-y-3 tw-text-sm">
                      <li>
                        ติดตั้ง CLI บนเครื่องที่มีไฟล์ Express:
                        <div class="tw-text-xs tw-text-grey-darken-1 tw-mt-1 tw-mb-1">Windows (PowerShell)</div>
                        <div class="tw-flex tw-items-center tw-gap-2">
                          <code class="tw-bg-grey-lighten-4 tw-px-2 tw-py-1 tw-rounded tw-flex-grow tw-break-all">irm https://phasicharoen.com/install.ps1 | iex</code>
                          <v-btn icon small @click="copyFoxproCommand('irm https://phasicharoen.com/install.ps1 | iex')" title="คัดลอกคำสั่ง">
                            <v-icon small>mdi-content-copy</v-icon>
                          </v-btn>
                        </div>
                        <div class="tw-text-xs tw-text-grey-darken-1 tw-mt-2 tw-mb-1">macOS / Linux</div>
                        <div class="tw-flex tw-items-center tw-gap-2">
                          <code class="tw-bg-grey-lighten-4 tw-px-2 tw-py-1 tw-rounded tw-flex-grow tw-break-all">curl -fsSL https://phasicharoen.com/install.sh | bash</code>
                          <v-btn icon small @click="copyFoxproCommand('curl -fsSL https://phasicharoen.com/install.sh | bash')" title="คัดลอกคำสั่ง">
                            <v-icon small>mdi-content-copy</v-icon>
                          </v-btn>
                        </div>
                      </li>
                      <li>
                        รัน CLI ชี้ไปที่โฟลเดอร์ Express:
                        <div class="tw-flex tw-items-center tw-gap-2 tw-mt-1">
                          <code class="tw-bg-grey-lighten-4 tw-px-2 tw-py-1 tw-rounded tw-flex-grow tw-break-all">etax-foxpro --foxpro-path "D:\ExpressI"</code>
                          <v-btn icon small @click="copyFoxproCommand('etax-foxpro --foxpro-path &quot;D:\\ExpressI&quot;')" title="คัดลอกคำสั่ง">
                            <v-icon small>mdi-content-copy</v-icon>
                          </v-btn>
                        </div>
                      </li>
                      <li>คลิกลิงก์ที่ CLI เปิดบนเบราว์เซอร์ เพื่อจับคู่ daemon กับบริษัทนี้</li>
                    </ol>
                  </v-card-text>
                </v-card>
              </template>
            </section>
            </template>

            <section v-if="isStaff" id="section-model" class="settings-section settings-section--model">
              <div class="settings-section-header">
                <div class="settings-section-title-block">
                  <div class="settings-section-title">
                    <v-icon left color="indigo darken-1">mdi-robot-outline</v-icon>
                    ตั้งค่า Model
                  </div>
                  <div class="settings-section-description">
                    เลือกโมเดลหลักและโมเดลสำรองสำหรับประมวลผลเอกสาร
                  </div>
                </div>
                <div class="settings-section-actions">
                <v-btn
                  v-if="!isEditMode"
                  @click="toggleEditMode"
                  color="warning"
                  outlined
                >
                  แก้ไข
                </v-btn>

                <v-btn
                  v-if="isEditMode"
                  @click="saveSettingModel"
                  color="primary"
                  :loading="isSavingSettingModel"
                >
                  บันทึก
                </v-btn>

                 <v-btn
                  v-if="isEditMode"
                  @click="toggleCancel"
                  outlined
                >
                  ยกเลิก
                </v-btn>
              </div>
              </div>

                      

                      <div class="model-picker">
                        <div class="model-picker-row">
                          <div class="model-picker-label">
                            <div class="model-picker-label-title">Model หลัก</div>
                            <div class="model-picker-label-hint">ใช้เป็นตัวประมวลผลหลัก</div>
                          </div>
                          <div class="model-picker-body">
                            <v-chip-group
                              v-model="primaryModelIndex"
                              mandatory
                              active-class="primary"
                              :disabled="!isEditMode"
                              :class="{ 'disabled-chip-group': !isEditMode }"
                            >
                              <v-chip
                                v-for="model in modelOptions"
                                :key="model.value"
                                :value="model.value"
                                outlined
                                :color="
                                  normalizeModelValue(primaryModelIndex) === model.value
                                    ? 'primary'
                                    : ''
                                "
                              >
                                <v-avatar left>
                                  <img
                                    :src="`/images/${model.image}`"
                                    :alt="`${model.provider} logo`"
                                  />
                                </v-avatar>
                                <v-icon
                                  v-if="normalizeModelValue(primaryModelIndex) === model.value"
                                  color="primary"
                                >mdi-check</v-icon>
                                {{ model.text }}
                              </v-chip>
                            </v-chip-group>
                            <div v-if="selectedPrimaryModel" class="model-picker-selected">
                              <v-icon x-small color="success">mdi-check-circle</v-icon>
                              <span>เลือก:</span>
                              <v-avatar size="18">
                                <img
                                  :src="`/images/${selectedPrimaryModel.image}`"
                                  :alt="`${selectedPrimaryModel.provider} logo`"
                                />
                              </v-avatar>
                              <span class="model-picker-selected-name">{{ selectedPrimaryModel.text }}</span>
                            </div>
                          </div>
                        </div>

                        <v-divider class="tw-my-4"></v-divider>

                        <div class="model-picker-row">
                          <div class="model-picker-label">
                            <div class="model-picker-label-title">Model สำรอง</div>
                            <div class="model-picker-label-hint">ใช้เมื่อ Model หลักไม่พร้อมใช้งาน</div>
                          </div>
                          <div class="model-picker-body">
                            <v-chip-group
                              v-model="secondaryModelIndex"
                              mandatory
                              active-class="primary"
                              :disabled="!isEditMode"
                              :class="{ 'disabled-chip-group': !isEditMode }"
                            >
                              <v-chip
                                v-for="model in modelOptions"
                                :key="model.value"
                                :value="model.value"
                                outlined
                                :color="
                                  normalizeModelValue(secondaryModelIndex) === model.value
                                    ? 'primary'
                                    : ''
                                "
                              >
                                <v-avatar left>
                                  <img
                                    :src="`/images/${model.image}`"
                                    :alt="`${model.provider} logo`"
                                  />
                                </v-avatar>
                                <v-icon
                                  v-if="normalizeModelValue(secondaryModelIndex) === model.value"
                                  color="primary"
                                >mdi-check</v-icon>
                                {{ model.text }}
                              </v-chip>
                            </v-chip-group>
                            <div v-if="selectedSecondaryModel" class="model-picker-selected">
                              <v-icon x-small color="success">mdi-check-circle</v-icon>
                              <span>เลือก:</span>
                              <v-avatar size="18">
                                <img
                                  :src="`/images/${selectedSecondaryModel.image}`"
                                  :alt="`${selectedSecondaryModel.provider} logo`"
                                />
                              </v-avatar>
                              <span class="model-picker-selected-name">{{ selectedSecondaryModel.text }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
<!-- -------------------------------------------------------------------------------------- -->
            <!-- Prompts -->
            <section id="section-prompts" class="settings-section settings-section--prompt">
              <div class="settings-section-header">
                <div class="settings-section-title-block">
                  <div class="settings-section-title">
                    <v-icon left color="teal darken-1">mdi-text-box-edit-outline</v-icon>
                    จัดการคำสั่ง Prompt
                  </div>
                  <div class="settings-section-description">
                    จัดการชุดคำสั่ง แยกประเภทเอกสาร และเลือกคำสั่งที่ใช้งานจริง
                  </div>
                </div>
                <div class="settings-section-actions">
                  <v-btn outlined color="primary" :disabled="savingChanges" @click="openNewPromptDialog">
                    <v-icon left>mdi-plus</v-icon>
                    เพิ่มคำสั่ง
                  </v-btn>
                  <v-btn
                    color="success"
                    :loading="savingChanges"
                    :disabled="!hasUnsavedChanges || savingChanges"
                    @click="savePromptChanges"
                  >
                    <v-icon left>mdi-content-save</v-icon>
                    บันทึก
                  </v-btn>
                </div>
              </div>
            
            <div v-if="!isInitializing">
              <!-- Prompt Type Filter -->
              <v-card-text class="tw-pb-0 tw-px-8">
                <v-chip-group
                  v-model="selectedPromptTypeFilter"
                  mandatory
                  @change="filterPromptsByType"
                >
                  <v-chip
                    filter
                    outlined
                    value="all"
                    class="tw-font-medium"
                    :color="selectedPromptTypeFilter === 'all' ? 'primary' : ''"
                  >
                    ทั้งหมด
                  </v-chip>
                  <v-chip
                    filter
                    outlined
                    :value="1"
                    class="tw-font-medium"
                    :color="selectedPromptTypeFilter === 1 ? 'indigo' : ''"
                  >
                    <v-icon left small>mdi-file-document-outline</v-icon>
                    Invoice
                  </v-chip>
                  <v-chip
                    filter
                    outlined
                    :value="2"
                    class="tw-font-medium"
                    :color="selectedPromptTypeFilter === 2 ? 'black' : ''"
                  >
                    <v-icon left small>mdi-credit-card-outline</v-icon>
                    Credit Advice
                  </v-chip>
                </v-chip-group>
              </v-card-text>

              <div
                v-if="!filteredPrompts.length"
                class="prompt-empty-state"
              >
                <v-icon size="42" color="grey lighten-1">mdi-text-box-plus-outline</v-icon>
                <div class="prompt-empty-state-title">ยังไม่มีคำสั่งในประเภทนี้</div>
                <div class="prompt-empty-state-description">
                  สร้างคำสั่งใหม่เพื่อเริ่มประมวลผลเอกสารด้วยรูปแบบที่ต้องการ
                </div>
                <v-btn color="primary" @click="openNewPromptDialog">
                  <v-icon left>mdi-plus</v-icon>
                  เพิ่มคำสั่ง
                </v-btn>
              </div>

              <v-tabs
                v-else
                v-model="currentTabIndex"
                class="tw-mt-2 prompt-tabs"
                show-arrows
              >
                  <v-tab 
                    v-for="prompt in filteredPrompts" 
                    :key="prompt.promptId"
                    :class="[getPromptTypeClass(prompt.promptType), prompt.isActive ? 'active-prompt' : '']"
                  >
                    <v-icon small left :color="getPromptTypeColor(prompt.promptType)">
                      {{ getPromptTypeIcon(prompt.promptType) }}
                    </v-icon>
                    <span class="tw-relative">
                      {{ prompt.promptName }}
                      <v-badge
                        v-if="prompt.isActive"
                        color="success"
                        dot
                        left
                        class="active-badge"
                      ></v-badge>
                    </span>
                    <v-menu offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon small v-bind="attrs" v-on="on" @click.stop aria-label="ตัวเลือกคำสั่ง">
                          <v-icon small>mdi-dots-vertical</v-icon>
                        </v-btn>
                      </template>
                      <v-list dense>
                        <v-list-item @click="openEditTypeDialog(prompt)">
                          <v-list-item-title class="tw-flex tw-items-center">
                            <v-icon left small color="primary">mdi-pencil</v-icon>
                            แก้ไขประเภท
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="openDeleteDialog(prompt)">
                          <v-list-item-title class="tw-flex tw-items-center tw-text-error">
                            <v-icon left small color="error">mdi-delete</v-icon>
                            ลบคำสั่ง
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-tab>

                <v-tab-item 
                  v-for="prompt in filteredPrompts" 
                  :key="prompt.promptId"
                >
                  <v-card flat class="tw-pt-4 tw-px-2">
                    <v-card-text>
                      <v-row>
                        <v-col cols="12" md="6" lg="3">
                          <v-select
                            :value="prompt.promptType || ''"
                            @input="(value) => updatePromptType(prompt.promptId, value)"
                            :items="promptTypes"
                            item-text="text"
                            item-value="value"
                            label="ประเภทคำสั่ง"
                            outlined
                            dense
                            return-object
                            class="tw-mb-4"
                          >
                            <template v-slot:selection="{ item }">
                              <div class="tw-flex tw-items-center">
                                <v-icon left :color="item.color">{{ item.icon }}</v-icon>
                                {{ item.text }}
                              </div>
                            </template>
                            <template v-slot:item="{ item }">
                              <div class="tw-flex tw-items-center">
                                <v-icon left :color="item.color">{{ item.icon }}</v-icon>
                                {{ item.text }}
                              </div>
                            </template>
                          </v-select>
                        </v-col>
                        <v-col cols="12" md="6" lg="3">
                          <v-card
                            class="tw-mb-4 tw-px-3 tw-py-2"
                            :color="prompt.isActive ? 'success lighten-5' : 'grey lighten-4'"
                            flat
                          >
                            <div class="tw-flex tw-justify-between tw-items-center">
                              <div>
                                <div class="tw-flex tw-items-center tw-mt-1">
                                  <v-icon small :color="prompt.isActive ? 'success' : 'grey'">
                                    {{ prompt.isActive ? 'mdi-check-circle' : 'mdi-circle-outline' }}
                                  </v-icon>
                                  <span class="tw-ml-1 tw-text-sm">
                                    {{ prompt.isActive ? 'กำลังใช้งาน' : 'ไม่ใช้งาน' }}
                                  </span>
                                </div>
                              </div>
                              <v-btn
                                v-if="!prompt.isActive"
                                small
                                color="success"
                                outlined
                                :loading="isActivatingPrompt && activatingPromptId === prompt.promptId"
                                @click="setActivePrompt(prompt)"
                              >
                                เปิดใช้งาน
                              </v-btn>
                            </div>
                          </v-card>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-textarea
                            :value="prompt.promptText"
                            @input="(value) => updatePromptText(prompt.promptId, value)"
                            label="Prompt Text"
                            auto-grow
                            rows="10"
                            outlined
                            dense
                            persistent-placeholder
                            class="prompt-textarea"
                          ></v-textarea>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
              </v-tabs>
            </div>
            <div v-else class="prompt-loading-skeleton">
              <v-skeleton-loader type="heading" />
              <v-skeleton-loader type="list-item-two-line" />
              <v-skeleton-loader type="paragraph" />
            </div>
            </section>

          </v-card-text>
        </v-card>

        <v-dialog v-model="confirmLeaveDialog" max-width="460" persistent>
          <v-card>
            <v-card-title class="tw-flex tw-items-center tw-gap-2">
              <v-icon color="warning">mdi-alert-circle-outline</v-icon>
              มีการเปลี่ยนแปลงที่ยังไม่ได้บันทึก
            </v-card-title>
            <v-card-text>
              <div class="tw-mb-2">
                คุณมีการเปลี่ยนแปลงที่ยังไม่ได้บันทึกในส่วน:
              </div>
              <div class="tw-flex tw-flex-wrap tw-gap-2 tw-mb-2">
                <v-chip
                  v-for="label in dirtySectionLabels"
                  :key="label"
                  small
                  color="warning"
                  outlined
                >
                  {{ label }}
                </v-chip>
              </div>
              <div class="tw-text-sm tw-text-gray-600">
                หากออกจากหน้านี้ การเปลี่ยนแปลงดังกล่าวจะหายไป
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="cancelLeave">อยู่ต่อ</v-btn>
              <v-btn color="error" @click="confirmLeave">ออกอยู่ดี</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="showDeleteDialog" max-width="400">
          <v-card>
            <v-card-title>ยืนยันการลบคำสั่ง</v-card-title>
            <v-card-text>
              คุณต้องการลบคำสั่ง "{{ promptToDelete?.promptName }}" ใช่หรือไม่?
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="closeDeleteDialog">ยกเลิก</v-btn>
              <v-btn
                color="error"
                :loading="deletingPrompt"
                @click="deletePrompt"
              >
                ลบ
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="showEditTypeDialog" max-width="400">
          <v-card>
            <v-card-title>แก้ไขประเภทคำสั่ง</v-card-title>
            <v-card-text>
              <v-select
                v-model="editingPromptType"
                :items="promptTypes"
                item-text="text"
                item-value="value"
                label="ประเภทคำสั่ง"
                outlined
                dense
                return-object
              >
                <template v-slot:selection="{ item }">
                  <div class="tw-flex tw-items-center">
                    <v-icon left :color="item.color">{{ item.icon }}</v-icon>
                    {{ item.text }}
                  </div>
                </template>
                <template v-slot:item="{ item }">
                  <div class="tw-flex tw-items-center">
                    <v-icon left :color="item.color">{{ item.icon }}</v-icon>
                    {{ item.text }}
                  </div>
                </template>
              </v-select>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="closeEditTypeDialog">ยกเลิก</v-btn>
              <v-btn
                color="primary"
                @click="savePromptType"
              >
                บันทึก
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="showNewPromptDialog" max-width="500px">
          <v-card>
            <v-card-title>เพิ่มคำสั่งใหม่</v-card-title>
            <v-card-text>
              <v-text-field
                v-model="newPrompt.name"
                label="ชื่อคำสั่ง"
                outlined
                dense
                class="tw-mb-4"
              ></v-text-field>
              
              <v-select
                v-model="newPrompt.type"
                :items="promptTypes"
                item-text="text"
                item-value="value"
                label="ประเภทคำสั่ง"
                outlined
                dense
                return-object
              >
                <template v-slot:selection="{ item }">
                  <div class="tw-flex tw-items-center">
                    <v-icon left :color="item.color">{{ item.icon }}</v-icon>
                    {{ item.text }}
                  </div>
                </template>
                <template v-slot:item="{ item }">
                  <div class="tw-flex tw-items-center">
                    <v-icon left :color="item.color">{{ item.icon }}</v-icon>
                    {{ item.text }}
                  </div>
                </template>
              </v-select>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="error" text @click="closeNewPromptDialog"
                >ยกเลิก</v-btn
              >
              <v-btn
                color="primary"
                :loading="savingPrompt"
                :disabled="!newPrompt.name || savingPrompt"
                @click="addNewPrompt"
              >
                เพิ่ม
              </v-btn>
            </v-card-actions>
          </v-card>      
        </v-dialog>
      </v-container>
    </v-main>
  </Admin>
</template>

<script>
import Admin from "../../components/admin/admin-main-template";
import { mapState } from "vuex";
import _isEqual from "lodash/isEqual";
import _ from "lodash";
import fc from "@/firebaseConfig";
import axios from "axios";

const gptModels = ["gpt-4o-mini", "gpt-4o"];

export default {
  name: "AI",
  components: { Admin },

  data: () => ({
    modelOptions: [
      { text: "GPT-4o", value: "gpt-4o",provider : 'OpenAI',image :'openai.png'  },
      { text: "GPT-4o Mini", value: "gpt-4o-mini",provider : 'OpenAI',image :'openai.png'  },
      { text: 'Gemini Flash 2.5', value: 'gemini-2.5-flash',provider : 'Google',image :'gg.png' },
      // { label: 'DeepSeek Reasoner', value: 'deepseek-reasoner',provider : 'Deepseek',image :'deepseek.png' },
      // { text: 'DeepSeek Chat', value: 'deepseek-chat',provider : 'Deepseek',image :'deepseek.png' },
      // { text: 'Claude Haiku 3.5', value: 'claude-3-5-haiku-latest',provider : 'Claude',image :'claude.png' },
      // { text: 'GPT-4.1 mini', value: 'gpt-4.1-mini',provider : 'OpenAI',image :'openai.png' },
      // { text: 'Gemini Pro 2.5', value: 'gemini-2.5-pro',provider : 'Google',image :'gg.png' },
      // { text: 'o3', value: 'o3',provider : 'OpenAI',image :'openai.png' },
      // { text: 'GPT-4.1', value: 'gpt-4.1',provider : 'OpenAI' ,image :'openai.png'},
    ],
    selectedMonth: "",
    isEditMode: false,
    isCancel: false,
    savingPrompt: false,
    savingChanges: false,
    singleExpand: true,
    expanded: [],
    modelData: [],
    historyTabIndex: 0,
    selectedAiMonth: "",
    aiExpanded: [],
    // SAP B1 Configuration
    sapConfig: {
      b1sServiceUrl: "",
      databaseName: "",
      b1wsUsername: "",
      b1wsPassword: "",
    },
    originalSapConfig: null,
    isEditingSAPConfig: false,
    isSavingSAPConfig: false,
    isTestingSAPConnection: false,
    showSAPPassword: false,
    // FoxPro Configuration
    foxproConfig: {
      storageMode: "smb",
      apiUrl: "",
      networkPath: "",
      shareName: "",
      username: "",
      password: "",
      domain: "",
      basePath: "",
      daemonUserId: "",
      daemonWorkerId: "",
    },
    // Companies/{cid}.features.foxproDaemon — Phase 8 pilot flag. The
    // daemon storage-mode option is only shown when this is true (unless
    // the company is already on daemon, in which case we keep the option
    // visible so support can flip it off).
    daemonFlagEnabled: false,
    originalFoxproConfig: null,
    isEditingFoxproConfig: false,
    isSavingFoxproConfig: false,
    isTestingFoxproConnection: false,
    showFoxproPassword: false,
    foxproLastTestAt: null,
    foxproLastTestOk: false,
    foxproLastTestError: "",
    // Daemon presence — populated by an RTDB listener on workers/{daemonUserId}/{daemonWorkerId}.
    daemonWorker: null,
    daemonWorkerLoading: false,
    daemonWorkerRef: null,
    daemonWorkerCb: null,
    // Google Drive — connection
    driveIsConnected: false,
    driveIsLoadingStatus: true,
    driveIsConnecting: false,
    driveIsDisconnecting: false,
    isTestingDriveConnection: false,
    // Pre-fetched OAuth URL so the Connect button can redirect instantly
    // instead of waiting on a cloud-function cold start at click time.
    driveAuthUrlCache: null,
    driveAuthUrlPrefetching: false,
    // Google Drive — folder browser (My Drive)
    driveTab: 0,
    currentFolderId: "root",
    currentFolderPath: [{ id: "root", name: "My Drive" }],
    folderItems: [],
    isLoadingFolders: false,
    // Google Drive — Shared Drives
    sharedDrives: [],
    isLoadingSharedDrives: false,
    isLoadingSharedFolders: false,
    selectedSharedDrive: null,
    sharedFolderPath: [],
    sharedFolderItems: [],
    // Google Drive — watch folder
    selectedWatchFolder: null,
    driveWatchStatus: null,
    isStartingWatch: false,
    isStoppingWatch: false,
    isCheckingChanges: false,
    // OneDrive connection
    oneDriveIsConnected: false,
    oneDriveIsLoadingStatus: true,
    oneDriveIsConnecting: false,
    oneDriveIsDisconnecting: false,
    isTestingOneDriveConnection: false,
    oneDriveAuthUrlCache: null,
    oneDriveAuthUrlPrefetching: false,
    oneDriveDrives: [],
    selectedOneDriveDrive: null,
    oneDriveFolderPath: [],
    oneDriveFolderItems: [],
    selectedOneDriveWatchFolder: null,
    oneDriveWatchStatus: null,
    isLoadingOneDriveDrives: false,
    isLoadingOneDriveFolders: false,
    isStartingOneDriveWatch: false,
    isStoppingOneDriveWatch: false,
    isCheckingOneDriveChanges: false,

    // Dropbox connection
    dropboxIsConnected: false,
    dropboxIsLoadingStatus: true,
    dropboxIsConnecting: false,
    dropboxIsDisconnecting: false,
    isTestingDropboxConnection: false,
    dropboxAuthUrlCache: null,
    dropboxAuthUrlPrefetching: false,
    dropboxFolderPath: [],
    dropboxFolderItems: [],
    selectedDropboxWatchFolder: null,
    dropboxWatchStatus: null,
    isLoadingDropboxFolders: false,
    isStartingDropboxWatch: false,
    isStoppingDropboxWatch: false,
    isCheckingDropboxChanges: false,

    // Box.com connection
    boxIsConnected: false,
    boxIsLoadingStatus: true,
    boxIsConnecting: false,
    boxIsDisconnecting: false,
    isTestingBoxConnection: false,
    boxAuthUrlCache: null,
    boxAuthUrlPrefetching: false,
    boxFolderPath: [],
    boxFolderItems: [],
    selectedBoxWatchFolder: null,
    boxWatchStatus: null,
    isLoadingBoxFolders: false,
    isStartingBoxWatch: false,
    isStoppingBoxWatch: false,
    isCheckingBoxChanges: false,
    snackbar: {
      show: false,
      message: "",
      color: "success",
    },
    activeSection: "",
    sectionObserver: null,
    confirmLeaveDialog: false,
    pendingNavigation: null,
    beforeUnloadHandler: null,
    items: [
      {
        text: "ตั้งค่า",
        disabled: false,
        to: { name: "Company.Settings" },
      },
      {
        text: "คำสั่ง Prompt",
        disabled: true,
      },
    ],
    currentTabIndex: 0,
    showKeyOpenAI:false,
    showKeyGoogleAI:false,
    showKey: false,
    // openAiKey: "",
    // googleAiKey: "",
    vendorSearch: "",
    isTestingConnectionOpenAI: false,
    isTestingConnectionGoogleAI: false,
    isSavingOpenAIApiKey: false,
    isSavingGoogleAIApiKey: false,
    isSavingSettingModel: false,
    showNewPromptDialog: false,
    showDeleteDialog: false,
    showEditTypeDialog: false,
    promptToDelete: null,
    promptToEdit: null,
    editingPromptType: null,
    deletingPrompt: false,
    isActivatingPrompt: false,
    activatingPromptId: null,
    companyID: null,
    newPrompt: {
      name: "",
      text: "",
      type: null,
      selectedVendors: [],
    },
    hasUnsavedChanges: false,
    originalPrompts: null,
    OpenAIapiKey: "",
    GoogleAIapiKey: "",
    SettingModel: "",
    isInitializing: true,
    selectedPromptTypeFilter: "all",
    promptTypes: [
      { text: "Invoice", value: 1, icon: "mdi-file-document-outline", color: "indigo" },
      { text: "Credit Advice", value: 2, icon: "mdi-credit-card-outline", color: "black" }
    ],
    isShowHistoryDialog: false,
    primaryModelIndex: "",
    secondaryModelIndex: "",
    vendorOpenAiModel1: gptModels[0],
    vendorOpenAiModel2: gptModels[1],
    isPython: false,
    isApSelectedSyncProvider: "pscConnector",
    isSavingSyncProvider: false,
    pscIsLoadingStatus: false,
    pscIsConnected: false,
    pscIsSyncing: false,
    pscStatusLastFetchedAt: null,
    syncProviderOptions: [
      { key: "googleDrive", name: "Google Drive", icon: "mdi-google-drive", color: "blue darken-2", description: "ซิงค์ไฟล์จาก Google Drive", available: true },
      { key: "oneDrive", name: "OneDrive", icon: "mdi-microsoft-onedrive", color: "blue darken-3", description: "ซิงค์ไฟล์จาก Microsoft 365", available: false, progress: 50 },
      { key: "dropbox", name: "Dropbox", icon: "mdi-dropbox", color: "blue", description: "ซิงค์ไฟล์จาก Dropbox", available: false, progress: 80 },
      { key: "box", name: "Box", icon: "mdi-package-variant-closed", color: "indigo darken-2", description: "ซิงค์ไฟล์จาก Box", available: false, progress: 80 },
      { key: "pscConnector", name: "PSC Connector", icon: "mdi-connection", color: "deep-purple darken-2", description: "เชื่อมต่อผ่านแอปภายนอก", available: true },
    ],
  }),
  created() {
    const companyID = this.$route.params.companyId;
    if (companyID) {
      this.$store.dispatch("user/getRoleUser", { companyId: companyID });
    }


    this.getChatGptActivityLog();
    this.getAiUsageLog();
    this.selectedMonth = this.getCurrentMonth();
    this.selectedAiMonth = this.getCurrentMonth();

  },

  computed: {
    ...mapState({
      selectedCompany: (state) => state.companies.selectedCompany,
      userCompany: (state) => state.user.userCompany,
      loading: (state) => state.companies.loading,
      selectedCompanyApVendors: (state) =>
        state.companies.selectedCompanyApVendors,
      selectedDateChatGptActivityLog: (state) =>
        state.companies.selectedDateChatGptActivityLog,
      prompts: (state) => state.companies.selectedCompanyApPrompts,
      selectedChatGptActivityLog: (state) =>
        state.companies.selectedChatGptActivityLog,
      selectedCompanyProductList: (state) => state.companies.selectedCompanyProductList,
      selectedAiUsageLog: (state) => state.companies.selectedAiUsageLog,
      selectedDateAiUsageLog: (state) => state.companies.selectedDateAiUsageLog,
    }),
    aiSelectedMonthDoc() {
      return this.selectedAiUsageLog.find((m) => m.id === this.selectedAiMonth) || null;
    },
    aiModelTotalsList() {
      const doc = this.aiSelectedMonthDoc;
      return this.toEntries(doc && doc.modelTotals, "modelVersion");
    },
    aiServiceTotalsList() {
      const doc = this.aiSelectedMonthDoc;
      return this.toEntries(doc && doc.serviceTotals, "serviceType");
    },
    isApTypeOne() {
      return this.selectedCompanyProductList?.isApAutomateType === 1;
    },
    isApTypeTwo() {
      return this.selectedCompanyProductList?.isApAutomateType === 2;
    },
    isPscConnectorBlocked() {
      const pl = this.selectedCompanyProductList;
      return !!(pl && pl.isApAutomate === true && pl.isApAutomateType === 1);
    },
    displaySyncProviderOptions() {
      return this.syncProviderOptions.map((opt) => {
        if (opt.key === "pscConnector" && this.isPscConnectorBlocked) {
          return {
            ...opt,
            available: false,
            blocked: true,
            blockedLabel: "มีปัญหา",
            blockedReason: "ไม่รองรับสำหรับ ERP SAP",
          };
        }
        return opt;
      });
    },
    selectedSyncProviderOption() {
      return this.displaySyncProviderOptions.find((opt) => opt.key === this.isApSelectedSyncProvider) || null;
    },
    isCompanyAdmin() {
      return this.userCompany?.isAdmin;
    },
    isStaff() {
      return this.userCompany?.user?.isEngineer || this.userCompany?.isDeveloper;
    },
    daemonPresenceColor() {
      const status = this.daemonWorker && this.daemonWorker.status;
      if (status === "online") return "green";
      if (status === "busy")   return "amber";
      if (status === "offline") return "red";
      return "grey";
    },
    foxproFieldsDisabled() {
      return !this.isEditingFoxproConfig;
    },
    foxproTestConnectionDisabled() {
      const c = this.foxproConfig;
      return !c.apiUrl || !c.networkPath || !c.shareName || !c.username;
    },
    daemonPresenceIcon() {
      const status = this.daemonWorker && this.daemonWorker.status;
      if (status === "online") return "mdi-circle";
      if (status === "busy")   return "mdi-circle-slice-7";
      if (status === "offline") return "mdi-circle-outline";
      return "mdi-help-circle-outline";
    },
    foxproStatusPillClass() {
      if (this.foxproConfig.storageMode === "daemon") {
        return this.daemonWorker && this.daemonWorker.status === "online"
          ? "cloud-status-pill--connected"
          : "cloud-status-pill--idle";
      }
      return this.foxproLastTestOk
        ? "cloud-status-pill--connected"
        : "cloud-status-pill--idle";
    },
    foxproStatusPillIcon() {
      if (this.foxproConfig.storageMode === "daemon") {
        return this.daemonWorker && this.daemonWorker.status === "online"
          ? "mdi-check-circle"
          : "mdi-link-variant-off";
      }
      return this.foxproLastTestOk ? "mdi-check-circle" : "mdi-link-variant-off";
    },
    foxproStatusPillLabel() {
      if (this.foxproConfig.storageMode === "daemon") {
        if (!this.foxproConfig.daemonWorkerId) return "Daemon · ยังไม่ได้จับคู่";
        if (this.daemonWorkerLoading) return "Daemon · กำลังโหลด…";
        if (!this.daemonWorker) return "Daemon · ไม่พบข้อมูล";
        return "Daemon · " + (this.daemonWorker.status || "unknown");
      }
      if (!this.foxproLastTestAt) return "SMB · ยังไม่ได้ทดสอบการเชื่อมต่อ";
      return this.foxproLastTestOk
        ? "SMB · เชื่อมต่อสำเร็จ"
        : "SMB · เชื่อมต่อล้มเหลว";
    },
    daemonStatusTileClass() {
      if (!this.foxproConfig.daemonWorkerId) return "psc-status-tile-value--idle";
      const status = this.daemonWorker && this.daemonWorker.status;
      if (status === "online") return "psc-status-tile-value--ok";
      if (status === "busy")   return "psc-status-tile-value--running";
      return "psc-status-tile-value--idle";
    },
    daemonStatusTileLabel() {
      if (!this.foxproConfig.daemonWorkerId) return "ยังไม่ได้จับคู่";
      if (this.daemonWorkerLoading) return "กำลังโหลด…";
      if (!this.daemonWorker) return "ไม่พบ daemon";
      return this.daemonWorker.status || "unknown";
    },
    // currentPromptId() {
    //   return this.filteredPrompts[this.currentTabIndex]?.promptId || "";
    // },
    // filteredVendors() {
    //   return this.selectedCompanyApVendors.filter(
    //     (vendor) =>
    //       (vendor.venName || "")
    //         .toLowerCase()
    //         .includes((this.vendorSearch || "").toLowerCase()) && vendor.promptId === this.currentPromptId
    //   );
    // },
    selectedPrimaryModel() {
      const value = this.normalizeModelValue(this.primaryModelIndex);
      return this.modelOptions.find((model) => model.value === value) || null;
    },
    selectedSecondaryModel() {
      const value = this.normalizeModelValue(this.secondaryModelIndex);
      return this.modelOptions.find((model) => model.value === value) || null;
    },
    filteredPrompts() {
      if (this.selectedPromptTypeFilter === "all") return this.prompts;
      return this.prompts.filter(prompt => prompt.promptType === Number(this.selectedPromptTypeFilter));
    },
    sectionNavItems() {
      const items = [];
      if (this.isStaff) {
        items.push({ key: "api", label: "API", icon: "mdi-api" });
      }
      if (this.isStaff && this.isApTypeOne) {
        items.push({ key: "sap", label: "SAP B1", icon: "mdi-server-network" });
      }
      if (this.isStaff && (this.isApTypeOne || this.isApTypeTwo)) {
        items.push({ key: "sync", label: "Sync", icon: "mdi-cloud-sync-outline" });
      }
      if (this.isStaff && this.isApTypeTwo) {
        items.push({ key: "foxpro", label: "FoxPro", icon: "mdi-database-outline" });
      }
      if (this.isStaff) {
        items.push({ key: "model", label: "Model", icon: "mdi-robot-outline" });
      }
      items.push({ key: "prompts", label: "Prompts", icon: "mdi-text-box-edit-outline" });
      return items;
    },
    apiDirty() {
      if (!this.selectedCompany) return false;
      const savedOpenAi = this.selectedCompany.openAiKey || "";
      const savedGoogleAi = this.selectedCompany.googleAIapiKey || "";
      return (
        (this.OpenAIapiKey || "") !== savedOpenAi ||
        (this.GoogleAIapiKey || "") !== savedGoogleAi
      );
    },
    sapDirty() {
      if (!this.isApTypeOne || !this.originalSapConfig) return false;
      return !_isEqual(this.sapConfig, this.originalSapConfig);
    },
    foxproDirty() {
      if (!this.isApTypeTwo || !this.originalFoxproConfig) return false;
      return !_isEqual(this.foxproConfig, this.originalFoxproConfig);
    },
    modelDirty() {
      if (!this.selectedCompany) return false;
      const savedPrimary =
        this.normalizeModelValue(this.selectedCompany.models && this.selectedCompany.models.mainmodel) || "";
      const savedSecondary =
        this.normalizeModelValue(this.selectedCompany.models && this.selectedCompany.models.submodel) || "";
      return (
        (this.normalizeModelValue(this.primaryModelIndex) || "") !== savedPrimary ||
        (this.normalizeModelValue(this.secondaryModelIndex) || "") !== savedSecondary
      );
    },
    promptsDirty() {
      return !!this.hasUnsavedChanges;
    },
    dirtyByKey() {
      return {
        api: this.apiDirty,
        sap: this.sapDirty,
        foxpro: this.foxproDirty,
        model: this.modelDirty,
        prompts: this.promptsDirty,
      };
    },
    dirtySectionKeys() {
      return Object.keys(this.dirtyByKey).filter((k) => this.dirtyByKey[k]);
    },
    hasAnyDirty() {
      return this.dirtySectionKeys.length > 0;
    },
    dirtySectionLabels() {
      const labelByKey = {
        api: "API",
        sap: "SAP B1",
        foxpro: "FoxPro",
        model: "Model",
        prompts: "คำสั่ง Prompt",
      };
      return this.dirtySectionKeys.map((k) => labelByKey[k]);
    },
  },

  watch: {
    selectedCompany: {
      handler(newVal) {
        if (newVal) {
          this.OpenAIapiKey = newVal.openAiKey || "";
          this.GoogleAIapiKey = newVal.googleAIapiKey || "";
          this.primaryModelIndex = this.normalizeModelValue(newVal.models?.mainmodel) || "";
          this.secondaryModelIndex = this.normalizeModelValue(newVal.models?.submodel) || "";
        }
      },
      immediate: true,
    },
    selectedMonth(newVal, oldVal) {
      console.log("Selected month changed:", newVal);
      let companyId = this.$route.params.companyId;
      this.$store.dispatch("companies/getDateListChatGptActivityLog", {
        companyId,
        newVal,
      });
      this.modelData = this.findModelData(newVal);
    },
    selectedChatGptActivityLog(newVal, oldVal) {
      console.log("list month", this.selectedChatGptActivityLog.length);
      this.modelData = this.findModelData(this.selectedMonth);
    },
    selectedAiMonth(newVal) {
      if (!newVal) return;
      const companyId = this.$route.params.companyId;
      this.$store.dispatch("companies/getDateListAiUsageLog", {
        companyId,
        newVal,
      });
    },
    selectedCompanyProductList: {
      handler(newVal) {
        if (newVal && newVal.isApSelectedSyncProvider) {
          this.isApSelectedSyncProvider = newVal.isApSelectedSyncProvider;
        }
        this.autoClearPscIfBlocked();
      },
      immediate: true,
    },
    isApSelectedSyncProvider: {
      handler(newVal) {
        if (newVal === "pscConnector") {
          this.loadPscStatus();
        }
      },
      immediate: true,
    },
    // currentTabIndex(val) {
    //   if (this.selectedCompanyAutoDocConfig.length > 0) {
    //     this.searchKeywordsDsp =
    //       this.selectedCompanyAutoDocConfig[val].searchKeywords?.join("||");
    //     this.specialSearchKeywordsDsp =
    //       this.selectedCompanyAutoDocConfig[val].specialSearchKeywords?.join(
    //         "||"
    //       );
    //     this.currentVendor = Object.assign(
    //       {},
    //       this.selectedCompanyAutoDocConfig[val]
    //     );
    //     // Ensure isPython is initialized
    //     this.currentVendor.isPython = this.currentVendor.isPython ?? false;
    //     this.currentVendorCopy = Object.assign({}, this.currentVendor);

    //     // Update model indices when tab changes
    //     this.primaryModelIndex =
    //       this.mainModel || this.modelOptions[0].value;
    //     this.secondaryModelIndex =
    //       this.subModel || this.modelOptions[1].value;

    //     // Update OCR service based on currentVendor
    //     this.currentSelectedOcrService = this.currentVendor.isPython || false;

    //     this.isEditPrompt = false;
    //     this.currentVendorModelTab = 0;
    //   }
    // // },
    // selectedCompanyAutoDocConfig(val) {
    //   if (val && val.length > 0) {
    //     this.searchKeywordsDsp =
    //       val[this.currentTabIndex].searchKeywords?.join("||");
    //     this.specialSearchKeywordsDsp =
    //       val[this.currentTabIndex].specialSearchKeywords?.join("||");
    //     this.currentVendor = Object.assign({}, val[this.currentTabIndex]);
    //     // Ensure isPython is initialized
    //     this.currentVendor.isPython = this.currentVendor.isPython ?? false;
    //     this.currentVendorCopy = Object.assign({}, this.currentVendor);

    //     // Initialize model indices based on currentVendor
    //     this.primaryModelIndex =
    //       this.currentVendor.vendorOpenAiModel1 || this.modelOptions[0].value;
    //     this.secondaryModelIndex =
    //       this.currentVendor.vendorOpenAiModel2 || this.modelOptions[1].value;

    //     // Initialize OCR service based on currentVendor
    //     this.currentSelectedOcrService = this.currentVendor.isPython || false;

    //     this.isEditPrompt = false;
    //   }
    // },
    prompts: {
      handler(newVal) {
        if (this.originalPrompts && !_isEqual(newVal, this.originalPrompts)) {
          this.hasUnsavedChanges = true;
        }
      },
      deep: true,
    },
    sectionNavItems() {
      this.$nextTick(() => this.initSectionObserver());
    },
  },

  mounted() {
    this.init();
    this.$nextTick(() => this.initSectionObserver());
    this.beforeUnloadHandler = (event) => {
      if (this.hasAnyDirty) {
        event.preventDefault();
        event.returnValue = "";
        return "";
      }
    };
    window.addEventListener("beforeunload", this.beforeUnloadHandler);
  },

  beforeDestroy() {
    this.unsubscribeDaemonPresence();
    this.disconnectSectionObserver();
    if (this.beforeUnloadHandler) {
      window.removeEventListener("beforeunload", this.beforeUnloadHandler);
      this.beforeUnloadHandler = null;
    }
  },

  beforeRouteLeave(to, from, next) {
    if (!this.hasAnyDirty) {
      next();
      return;
    }
    this.pendingNavigation = next;
    this.confirmLeaveDialog = true;
  },

  methods: {
    scrollToSection(key) {
      const el = document.getElementById(`section-${key}`);
      if (!el) return;
      el.scrollIntoView({ behavior: "smooth", block: "start" });
      this.activeSection = key;
    },
    initSectionObserver() {
      if (typeof window === "undefined" || typeof window.IntersectionObserver === "undefined") {
        return;
      }
      this.disconnectSectionObserver();
      this.sectionObserver = new window.IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && entry.target && entry.target.id) {
              this.activeSection = entry.target.id.replace("section-", "");
            }
          });
        },
        { rootMargin: "-30% 0px -60% 0px", threshold: 0 }
      );
      this.sectionNavItems.forEach((item) => {
        const el = document.getElementById(`section-${item.key}`);
        if (el) this.sectionObserver.observe(el);
      });
    },
    disconnectSectionObserver() {
      if (this.sectionObserver) {
        this.sectionObserver.disconnect();
        this.sectionObserver = null;
      }
    },
    confirmLeave() {
      const next = this.pendingNavigation;
      this.pendingNavigation = null;
      this.confirmLeaveDialog = false;
      if (typeof next === "function") next();
    },
    cancelLeave() {
      const next = this.pendingNavigation;
      this.pendingNavigation = null;
      this.confirmLeaveDialog = false;
      if (typeof next === "function") next(false);
    },
    normalizeModelValue(model) {
      return model && typeof model === "object" ? model.value : model;
    },
    async loadPscStatus() {
      const companyId = this.$route.params.companyId;
      if (!companyId) return;
      this.pscIsLoadingStatus = true;
      try {
        const snap = await fc.companies
          .doc(companyId)
          .collection("Databases")
          .get();
        this.pscIsConnected = !snap.empty;
        this.pscIsSyncing = snap.docs.some((doc) => doc.data() && doc.data().isSyncing === true);
        this.pscStatusLastFetchedAt = new Date();
      } catch (error) {
        console.error("Error loading PSC Connector status:", error);
        this.notify("error", "ไม่สามารถดึงสถานะ PSC Connector ได้");
      } finally {
        this.pscIsLoadingStatus = false;
      }
    },
    async isSyncProviderActive(providerKey) {
      try {
        switch (providerKey) {
          case "pscConnector":
            await this.loadPscStatus();
            return this.pscIsSyncing === true;
          case "googleDrive":
            if (this.driveIsConnected) await this.loadWatchStatus();
            return !!(this.driveWatchStatus && this.driveWatchStatus.isWatching);
          case "oneDrive":
            if (this.oneDriveIsConnected) await this.loadOneDriveWatchStatus();
            return !!(this.oneDriveWatchStatus && this.oneDriveWatchStatus.isWatching);
          case "dropbox":
            if (this.dropboxIsConnected) await this.loadDropboxWatchStatus();
            return !!(this.dropboxWatchStatus && this.dropboxWatchStatus.isWatching);
          case "box":
            if (this.boxIsConnected) await this.loadBoxWatchStatus();
            return !!(this.boxWatchStatus && this.boxWatchStatus.isWatching);
          default:
            return false;
        }
      } catch (err) {
        console.error("isSyncProviderActive error:", err);
        return false;
      }
    },
    async setSyncProvider(key) {
      if (this.isSavingSyncProvider) return;
      if (this.isApSelectedSyncProvider === key) return;
      const companyId = this.$route.params.companyId;
      if (!companyId) return;

      // Block change while the current provider is actively running/watching — must be stopped first.
      const current = this.isApSelectedSyncProvider;
      if (current) {
        const active = await this.isSyncProviderActive(current);
        if (active) {
          const currentName =
            (this.syncProviderOptions.find((opt) => opt.key === current) || {}).name || current;
          this.notify(
            "error",
            `กรุณาหยุดการทำงานของ ${currentName} ก่อนเปลี่ยนผู้ให้บริการซิงค์`
          );
          return;
        }
      }

      const previous = this.isApSelectedSyncProvider;
      this.isApSelectedSyncProvider = key;
      this.isSavingSyncProvider = true;
      try {
        await fc.companies
          .doc(companyId)
          .collection("ProductList")
          .doc("PSC")
          .set({ isApSelectedSyncProvider: key, updatedAt: new Date() }, { merge: true });
        await this.$store.dispatch("companies/getCompanyProductList", { companyId });
      } catch (error) {
        console.error("Error saving sync provider:", error);
        this.isApSelectedSyncProvider = previous;
        this.notify("error", "ไม่สามารถบันทึกผู้ให้บริการซิงค์ได้");
      } finally {
        this.isSavingSyncProvider = false;
      }
    },
    async autoClearPscIfBlocked() {
      // Triggered from the selectedCompanyProductList watcher. When a company
      // becomes SAP (isApAutomate=true && isApAutomateType=1) and PSC was the
      // active sync provider, the picker tile flips to "มีปัญหา" — we also
      // wipe the selection so downstream UI/cron jobs don't keep treating
      // PSC as the active provider.
      if (!this.isPscConnectorBlocked) return;
      if (this.isApSelectedSyncProvider !== "pscConnector") return;

      const companyId = this.$route.params.companyId;
      if (!companyId) return;
      if (this.isSavingSyncProvider) return;

      // Don't yank an in-flight sync — surface a warning so the staff can
      // stop it manually, mirroring setSyncProvider's safety check.
      try {
        const active = await this.isSyncProviderActive("pscConnector");
        if (active) {
          this.notify(
            "error",
            "PSC Connector กำลังซิงค์อยู่ — กรุณาหยุดการซิงค์ก่อนเปลี่ยน ERP เป็น SAP"
          );
          return;
        }
      } catch (err) {
        console.error("[autoClearPscIfBlocked] active check failed:", err);
        return;
      }

      this.isSavingSyncProvider = true;
      try {
        await fc.companies
          .doc(companyId)
          .collection("ProductList")
          .doc("PSC")
          .set({ isApSelectedSyncProvider: "", updatedAt: new Date() }, { merge: true });
        this.isApSelectedSyncProvider = "";
        await this.$store.dispatch("companies/getCompanyProductList", { companyId });
        this.notify(
          "info",
          "ล้างการเลือก PSC Connector อัตโนมัติ (ไม่รองรับสำหรับ ERP SAP)"
        );
      } catch (err) {
        console.error("[autoClearPscIfBlocked] failed to clear:", err);
        this.notify("error", "ไม่สามารถล้างการเลือก PSC Connector ได้");
      } finally {
        this.isSavingSyncProvider = false;
      }
    },
     toggleEditMode() {
      this.isEditMode = true;
    },
    toggleCancel() {
     this.primaryModelIndex = this.normalizeModelValue(this.selectedCompany?.models?.mainmodel) || "";
     this.secondaryModelIndex = this.normalizeModelValue(this.selectedCompany?.models?.submodel) || "";
     this.isEditMode = false;
    },
    fetchDateData() {
      let companyId = this.$route.params.companyId;
      this.$store.dispatch("companies/getDateListChatGptActivityLog", {
        companyId,
        newVal: this.selectedMonth,
      });
    },
    showHistoryDialog() {
      this.isShowHistoryDialog = true;
    },
    findModelData(month) {
      const selectedData = this.selectedChatGptActivityLog.find(
        (item) => item.id === this.selectedMonth
      );
      return selectedData ? selectedData.modelData : [];
    },
    getCurrentMonth() {
      const now = new Date();
      const year = now.getFullYear();
      const month = now.getMonth() + 1;
      const formattedMonth = month < 10 ? `0${month}` : `${month}`;
      return `${year}-${formattedMonth}`;
    },
    getChatGptActivityLog() {
      console.log("start", this.selectedChatGptActivityLog);
      let companyId = this.$route.params.companyId;
      this.$store.dispatch("companies/getChatGptActivityLog", { companyId });
    },
    getAiUsageLog() {
      const companyId = this.$route.params.companyId;
      this.$store.dispatch("companies/getAiUsageLog", { companyId });
    },
    toEntries(map, keyName) {
      if (!map || typeof map !== "object") return [];
      return Object.keys(map).map((k) => {
        const v = map[k] || {};
        return {
          [keyName]: k,
          countDetails: v.countDetails || 0,
          tokenPrompt: v.tokenPrompt || 0,
          tokenCompletion: v.tokenCompletion || 0,
          tokenTotal: v.tokenTotal || 0,
          cachedTokens: v.cachedTokens || 0,
          reasoningTokens: v.reasoningTokens || 0,
        };
      });
    },
    formatAiNumbers(data) {
      if (!Array.isArray(data)) return [];
      return data.map((item) => ({
        ...item,
        countDetails: (item.countDetails || 0).toLocaleString(),
        tokenPrompt: (item.tokenPrompt || 0).toLocaleString(),
        tokenCompletion: (item.tokenCompletion || 0).toLocaleString(),
        tokenTotal: (item.tokenTotal || 0).toLocaleString(),
        cachedTokens: (item.cachedTokens || 0).toLocaleString(),
        reasoningTokens: (item.reasoningTokens || 0).toLocaleString(),
      }));
    },
    formatNumbers(data) {
      return data.map((item) => ({
        ...item,
        countDetails: item.countDetails.toLocaleString(),
        tokenPrompt: item.tokenPrompt.toLocaleString(),
        tokenCompletion: item.tokenCompletion.toLocaleString(),
        tokenTotal: item.tokenTotal.toLocaleString(),
      }))},
    getPromptTypeClass(type) {
      if (type === 1) return "prompt-type-invoice";
      if (type === 2) return "prompt-type-credit";
      return "";
    },
    
    getPromptTypeIcon(type) {
      if (type === 1) return "mdi-file-document-outline";
      if (type === 2) return "mdi-credit-card-outline";
      return "mdi-help-circle-outline";
    },
    
    getPromptTypeColor(type) {
      if (type === 1) return "indigo";
      if (type === 2) return "black";
      return "grey";
    },
    
    filterPromptsByType() {
      this.currentTabIndex = 0;
    },
    
    copyPromptId(promptId) {
      navigator.clipboard.writeText(promptId);
      this.notify("success", "คัดลอก ID คำสั่งสำเร็จ");
    },
    
    openEditTypeDialog(prompt) {
      this.promptToEdit = prompt;
      this.editingPromptType = this.promptTypes.find(t => t.value === prompt.promptType) || this.promptTypes[0];
      this.showEditTypeDialog = true;
    },
    
    closeEditTypeDialog() {
      this.promptToEdit = null;
      this.editingPromptType = null;
      this.showEditTypeDialog = false;
    },
    
    async savePromptType() {
      if (this.promptToEdit && this.editingPromptType) {
        this.updatePromptType(this.promptToEdit.promptId, this.editingPromptType);
        this.closeEditTypeDialog();
        
        // If the changes resulted in an inconsistent state, fix it immediately
        await this.ensureActivePromptsPerType();
        
        this.notify("success", "อัปเดตประเภทคำสั่งสำเร็จ");
      }
    },
    
    updatePromptType(promptId, value) {
      // Get the current prompt
      const currentPrompt = this.prompts.find(p => p.promptId === promptId);
      
      // Check if we're changing the type
      if (currentPrompt && currentPrompt.promptType !== Number(value.value)) {
   
        const newType = value.value;
        const oldType = currentPrompt.promptType;
        
        // Start with a copy of the prompts
        let updatedPrompts = [...this.prompts];
        
        // Check if the prompt we're updating is active
        const isCurrentPromptActive = currentPrompt.isActive;
        
        // Check if there's already an active prompt of the new type
        const existingActivePrompt = this.prompts.find(p => 
          p.promptType === newType && 
          p.isActive && 
          p.promptId !== promptId
        );
        
        // First pass: Update the type of the current prompt
        updatedPrompts = updatedPrompts.map(p => {
          if (p.promptId === promptId) {
            // If changing to a type that already has an active prompt,
            // this prompt should not be active
            const shouldBeActive = isCurrentPromptActive && !existingActivePrompt;
            return { 
              ...p, 
              promptType: newType,
              isActive: shouldBeActive 
            };
          }
          return p;
        });
        
        // If the current prompt was active, and there's no active prompt of the old type left,
        // activate the first prompt of the old type if one exists
        if (isCurrentPromptActive) {
          const oldTypePromptsRemaining = updatedPrompts.filter(p => 
            p.promptType === oldType && p.promptId !== promptId
          );
          
          if (oldTypePromptsRemaining.length > 0 && 
              !oldTypePromptsRemaining.some(p => p.isActive)) {
            // Activate the first prompt of the old type
            const firstOldTypePromptId = oldTypePromptsRemaining[0].promptId;
            updatedPrompts = updatedPrompts.map(p => {
              if (p.promptId === firstOldTypePromptId) {
                return { ...p, isActive: true };
              }
              return p;
            });
          }
        }
        
        this.$store.commit(
          "companies/setSelectedCompanyApPrompts",
          updatedPrompts
        );
        this.handlePromptChange();
        
        // Notify the user about the active status change if needed
        if (isCurrentPromptActive && existingActivePrompt) {
          this.notify(
            "info", 
            `ประเภทคำสั่งถูกเปลี่ยน และ "${existingActivePrompt.promptName}" ยังคงเป็นคำสั่งที่ใช้งานสำหรับประเภทนี้`
          );
        }
      } else {
        // If the type isn't changing, just update as normal
        const updatedPrompts = this.prompts.map((p) => {
          if (p.promptId === promptId) {
            return { ...p, promptType: value.value };
          }
          return p;
        });
        this.$store.commit(
          "companies/setSelectedCompanyApPrompts",
          updatedPrompts
        );
        this.handlePromptChange();
      }
    },
    
    async deletePrompt() {
      try {
        this.deletingPrompt = true;
        await this.$store.dispatch("companies/deletePrompt", {
          companyId: this.$route.params.companyId,
          promptId: this.promptToDelete.promptId,
        });
        this.notify("success", "ลบคำสั่งสำเร็จ");
        this.closeDeleteDialog();
      } catch (error) {
        this.notify("error", "เกิดข้อผิดพลาดในการลบคำสั่ง");
      } finally {
        this.deletingPrompt = false;
      }
    },
    
    notify(type, message) {
      this.snackbar = {
        show: true,
        message,
        color: type,
      };
    },
    
    openDeleteDialog(prompt) {
      this.promptToDelete = prompt;
      this.showDeleteDialog = true;
    },

    closeDeleteDialog() {
      this.promptToDelete = null;
      this.showDeleteDialog = false;
    },

    async init() {
      this.isInitializing = true
      const companyId = this.$route.params.companyId;
      if (companyId) {
        try {
          await Promise.all([
            this.$store.dispatch("user/getRoleUser", { companyId }),
            this.$store.dispatch("companies/fetchPrompts", { companyId }),
            this.fetchVendors(companyId),
            this.loadSAPConfig(),
            this.loadFoxproConfig(),
            this.loadDriveConnectionStatus(),
            this.loadOneDriveConnectionStatus(),
            this.loadDropboxConnectionStatus(),
            this.loadBoxConnectionStatus(),
          ]);

          // Ensure we have one active prompt per type if prompts exist for that type
          await this.ensureActivePromptsPerType();

          this.originalPrompts = _.cloneDeep(this.prompts);

          // Handle OAuth redirect callback
          if (this.$route.query.driveConnected === "true") {
            this.notify("success", "เชื่อมต่อ Google Drive สำเร็จ");
            this.$router.replace({ query: {} });
          }
          if (this.$route.query.onedriveStatus === "success") {
            await this.loadOneDriveConnectionStatus();
            this.notify("success", "เชื่อมต่อ OneDrive สำเร็จ");
            this.$router.replace({ query: {} });
          }
          if (this.$route.query.dropboxStatus === "success") {
            await this.loadDropboxConnectionStatus();
            this.notify("success", "เชื่อมต่อ Dropbox สำเร็จ");
            this.$router.replace({ query: {} });
          }
          if (this.$route.query.boxStatus === "success") {
            await this.loadBoxConnectionStatus();
            this.notify("success", "เชื่อมต่อ Box.com สำเร็จ");
            this.$router.replace({ query: {} });
          }
        } catch (error) {
          this.notify("error", "เกิดข้อผิดพลาดในการดึงข้อมูล");
        }
      }
      this.isInitializing = false
    },
    
    async ensureActivePromptsPerType() {
      // Group prompts by type
      const promptsByType = _.groupBy(this.prompts, 'promptType');
      
      // Check each type to ensure there's exactly one active prompt
      let updatedPrompts = [...this.prompts];
      let hasChanges = false;
      
      for (const [type, prompts] of Object.entries(promptsByType)) {
        if (prompts.length > 0) {
          // Count active prompts for this type
          const activePrompts = prompts.filter(p => p.isActive);
          
          if (activePrompts.length === 0) {
            // No active prompts for this type, activate the first one
            const firstPromptId = prompts[0].promptId;
            updatedPrompts = updatedPrompts.map(p => {
              if (p.promptId === firstPromptId) {
                hasChanges = true;
                return { ...p, isActive: true };
              }
              return p;
            });
          } else if (activePrompts.length > 1) {
            // Multiple active prompts, keep only the first one active
            const keepActiveId = activePrompts[0].promptId;
            updatedPrompts = updatedPrompts.map(p => {
              if (p.promptType === type && p.isActive && p.promptId !== keepActiveId) {
                hasChanges = true;
                return { ...p, isActive: false };
              }
              return p;
            });
          }
        }
      }
      
      if (hasChanges) {
        // Update store with corrected active states
        this.$store.commit(
          "companies/setSelectedCompanyApPrompts",
          updatedPrompts
        );
        
        // Save changes to backend
        await this.$store.dispatch("companies/updatePrompts", {
          companyId: this.$route.params.companyId,
          prompts: updatedPrompts,
        });
      }
    },

    async fetchVendors(companyId) {
      const vendorsRef = await fc.companies
        .doc(companyId)
        .collection("PurchaseInvoiceVendors")
        .get();

      const vendors = vendorsRef.docs.map((doc) => ({
        vendorId: doc.id,
        ...doc.data(),
      }));

      this.$store.commit("companies/setSelectedCompanyApVendors", vendors);
    },
    
    updatePromptText(promptId, value) {
      const updatedPrompts = this.prompts.map((p) => {
        if (p.promptId === promptId) {
          return { ...p, promptText: value };
        }
        return p;
      });
      this.$store.commit(
        "companies/setSelectedCompanyApPrompts",
        updatedPrompts
      );
      this.handlePromptChange();
    },

    toggleShowKey() {
      this.showKey = !this.showKey;
    },
    toggleshowKeyOpenAI() {
      this.showKeyOpenAI = !this.showKeyOpenAI;
    },
    toggleShowKeyGoogleAI() {
      this.showKeyGoogleAI = !this.showKeyGoogleAI
    },

    async testConnectionOpenAI() {
      this.isTestingConnectionOpenAI = true;
      try {
        const response = await fetch("https://api.openai.com/v1/models", {
          headers: { Authorization: `Bearer ${this.OpenAIapiKey}` },
        });
        if (response.ok) {
          this.notify("success", "การเชื่อมต่อ OpenAIapiKey สำเร็จ");
        } else {
          throw new Error("Connection failed");
        }
      } catch (error) {
        this.notify("error", "การเชื่อมต่อล้มเหลว กรุณาตรวจสอบ OpenAI API Key");
      } finally {
        this.isTestingConnectionOpenAI = false;
      }
    },

    async testConnectionOpenAIGoogleAI() {
      this.isTestingConnectionGoogleAI = true;
      const params = {
    "contents":[
    {"parts":[{
      "text":"hello" 
          
    }]}
  ],
  "generationConfig":{
    "maxOutputTokens":100,
    "temperature":0.8
  }        
};
      const options = {
    method: 'POST',
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(params)
};
      try {
        const response = await fetch(
          `https://generativelanguage.googleapis.com/v1beta/models/gemini-2.5-flash:generateContent?key=${encodeURIComponent(this.GoogleAIapiKey)}`,
          options
        );
         if (response.ok) {
          this.notify("success", "การเชื่อมต่อ GoogleAIapiKey สำเร็จ");
        } else {
          throw new Error("Connection failed");
        }
      } catch (error) {
        this.notify("error", "การเชื่อมต่อล้มเหลว กรุณาตรวจสอบ GoogleAI API Key");
      } finally {
        this.isTestingConnectionGoogleAI = false;
      }
    },
    async saveOpenAIApiKey() {
      this.isSavingOpenAIApiKey = true;
      console.log("ttttttttttttttttttttttttt")
      try {
        console.log("yyyyyyyyyyyyyyyyyyyyyyyyy")
        await this.$store.dispatch("companies/updateOpenAIApiKey", {
          companyId: this.$route.params.companyId,
          OpenAIapiKey: this.OpenAIapiKey,
        });
        console.log("55555555555555555555555555")
        this.notify("success", "บันทึก OpenAIapiKey สำเร็จ");
      } catch (error) {
        this.notify("error", "เกิดข้อผิดพลาดในการบันทึก OpenAI Key");
      } finally {
        this.isSavingOpenAIApiKey = false;
      }
    },
    async saveGoogleAIApiKey() {
      this.isSavingGoogleAIApiKey = true;
      try {
        await this.$store.dispatch("companies/updateGoogleAIApiKey", {
          companyId: this.$route.params.companyId,
          GoogleAIapiKey: this.GoogleAIapiKey,
        });
        this.notify("success", "บันทึก GoogleAIapiKey สำเร็จ");
      } catch (error) {
        this.notify("error", "เกิดข้อผิดพลาดในการบันทึก GoogleAI Key");
      } finally {
        this.isSavingGoogleAIApiKey = false;
      }
    },
    async saveSettingModel() {
      this.isSavingSettingModel = true;
      const selectedPrimary = this.normalizeModelValue(this.primaryModelIndex);
      const selectedSecondary = this.normalizeModelValue(this.secondaryModelIndex);
      try {
        await this.$store.dispatch("companies/updateSettingModel", {
          companyId: this.$route.params.companyId,
          primaryModelIndex: selectedPrimary,
          secondaryModelIndex: selectedSecondary
        });
        this.primaryModelIndex = selectedPrimary;
        this.secondaryModelIndex = selectedSecondary;

        // Fetch backend (sync for safety)
        await this.$store.dispatch("companies/setCompany", { companyId: this.$route.params.companyId });
        const newCompany = this.$store.state.companies.selectedCompany;

        // If backend value is different, update local value
        this.primaryModelIndex = this.normalizeModelValue(newCompany.models?.mainmodel) || selectedPrimary;
        this.secondaryModelIndex = this.normalizeModelValue(newCompany.models?.submodel) || selectedSecondary;

        this.notify("success", "บันทึก Model สำเร็จ");
      } catch (error) {
        this.notify("error", "เกิดข้อผิดพลาดในการบันทึก GoogleAI Key");
      } finally {
        this.isSavingSettingModel = false;
        this.isEditMode = false;
      }
    },

    openNewPromptDialog() {
      this.newPrompt = {
        name: "",
        text: "",
        type: this.promptTypes[0],
        selectedVendors: [],
      };
      this.showNewPromptDialog = true;
    },

    closeNewPromptDialog() {
      this.showNewPromptDialog = false;
      this.newPrompt = {
        name: "",
        text: "",
        type: null,
        selectedVendors: [],
      };
    },

    async setActivePrompt(prompt) {
      try {
        this.isActivatingPrompt = true;
        this.activatingPromptId = prompt.promptId;
        
        // Check if there's already an active prompt of this type
        const currentActivePrompt = this.prompts.find(p => 
          p.promptType === prompt.promptType && p.isActive
        );
        
        // Deactivate the current active prompt of this type
        let updatedPrompts = [...this.prompts];
        if (currentActivePrompt) {
          updatedPrompts = updatedPrompts.map(p => {
            if (p.promptId === currentActivePrompt.promptId) {
              return { ...p, isActive: false };
            }
            return p;
          });
        }
        
        // Activate the new prompt
        updatedPrompts = updatedPrompts.map(p => {
          if (p.promptId === prompt.promptId) {
            return { ...p, isActive: true };
          }
          return p;
        });
        
        // Update store
        this.$store.commit(
          "companies/setSelectedCompanyApPrompts",
          updatedPrompts
        );
        
        // Save changes
        await this.$store.dispatch("companies/updatePrompts", {
          companyId: this.$route.params.companyId,
          prompts: updatedPrompts,
        });
        
        this.originalPrompts = _.cloneDeep(updatedPrompts);
        this.hasUnsavedChanges = false;
        this.notify("success", "ตั้งค่าคำสั่งเป็นใช้งานสำเร็จ");
      } catch (error) {
        this.notify("error", "เกิดข้อผิดพลาดในการตั้งค่าคำสั่ง");
      } finally {
        this.isActivatingPrompt = false;
        this.activatingPromptId = null;
      }
    },
    
    async addNewPrompt() {
      try {
        this.savingPrompt = true;
        
        // Check if we should automatically set this prompt as active
        // This happens if there are no other prompts of this type
        const existingPromptsOfType = this.prompts.filter(p => 
          p.promptType === this.newPrompt.type.value
        );
        const shouldSetActive = existingPromptsOfType.length === 0;
        
        const newPrompt = {
          promptName: this.newPrompt.name,
          promptText: "",
          promptType: this.newPrompt.type.value,
          isActive: shouldSetActive,
          selectedVendors: [],
        };

        await this.$store.dispatch("companies/addPrompt", {
          companyId: this.$route.params.companyId,
          prompt: newPrompt,
        });

        this.closeNewPromptDialog();
        this.notify("success", shouldSetActive ? 
          "เพิ่มคำสั่งสำเร็จและตั้งเป็นใช้งาน" : 
          "เพิ่มคำสั่งสำเร็จ"
        );
      } catch (error) {
        this.notify("error", "เกิดข้อผิดพลาดในการเพิ่มคำสั่ง");
      } finally {
        this.savingPrompt = false;
      }
    },

    handlePromptChange() {
      this.hasUnsavedChanges = true;
    },

    handleVendorSelection() {
      this.hasUnsavedChanges = true;
    },

    async savePromptChanges() {
      try {
        this.savingChanges = true;

        // Ensure we have one active prompt per type before saving
        await this.ensureActivePromptsPerType();

        await this.$store.dispatch("companies/updatePrompts", {
          companyId: this.$route.params.companyId,
          prompts: this.prompts,
        });

        this.hasUnsavedChanges = false;
        this.originalPrompts = _.cloneDeep(this.prompts);
        this.notify("success", "บันทึกการเปลี่ยนแปลงสำเร็จ");
      } catch (error) {
        this.notify("error", "เกิดข้อผิดพลาดในการบันทึกการเปลี่ยนแปลง");
      } finally {
        this.savingChanges = false;
      }
    },

    // SAP B1 Configuration Methods
    async loadSAPConfig() {
      try {
        const companyId = this.$route.params.companyId;
        const databasesRef = await fc.companies
          .doc(companyId)
          .collection("Databases")
          .get();

        if (!databasesRef.empty) {
          const databaseData = databasesRef.docs[0].data();
          this.sapConfig = {
            b1sServiceUrl: databaseData.b1sServiceUrl || "",
            databaseName: databaseData.databaseName || "",
            b1wsUsername: databaseData.b1wsUsername || "",
            b1wsPassword: databaseData.b1wsPassword || "", // Load password to allow editing
          };
          this.originalSapConfig = _.cloneDeep(this.sapConfig);
        }
      } catch (error) {
        console.error("Error loading SAP config:", error);
        this.notify("error", "เกิดข้อผิดพลาดในการโหลดการตั้งค่า SAP");
      }
    },

    toggleSAPConfigEdit() {
      this.isEditingSAPConfig = true;
      this.originalSapConfig = _.cloneDeep(this.sapConfig);
    },

    cancelSAPConfigEdit() {
      this.isEditingSAPConfig = false;
      this.sapConfig = _.cloneDeep(this.originalSapConfig);
      this.showSAPPassword = false;
    },

    toggleShowSAPPassword() {
      this.showSAPPassword = !this.showSAPPassword;
    },

    async saveSAPConfig() {
      try {
        this.isSavingSAPConfig = true;
        const companyId = this.$route.params.companyId;

        // Get existing database document
        const databasesRef = await fc.companies
          .doc(companyId)
          .collection("Databases")
          .get();

        let databaseDoc;
        if (databasesRef.empty) {
          // Create new document
          databaseDoc = fc.companies.doc(companyId).collection("Databases").doc();
        } else {
          // Use existing document
          databaseDoc = databasesRef.docs[0].ref;
        }

        // Prepare update data
        const updateData = {
          b1sServiceUrl: this.sapConfig.b1sServiceUrl || "",
          databaseName: this.sapConfig.databaseName || "",
          b1wsUsername: this.sapConfig.b1wsUsername || "",
          b1wsPassword: this.sapConfig.b1wsPassword || "",
          type: 1, // SAP Business One
          programName: "SAP Business One",
          timeCreated: new Date(),
        };

        await databaseDoc.set(updateData, { merge: true });

        this.isEditingSAPConfig = false;
        this.notify("success", "บันทึกการตั้งค่า SAP สำเร็จ");

        // Reload the config to get the updated data
        await this.loadSAPConfig();
      } catch (error) {
        console.error("Error saving SAP config:", error);
        this.notify("error", "เกิดข้อผิดพลาดในการบันทึกการตั้งค่า SAP");
      } finally {
        this.isSavingSAPConfig = false;
      }
    },

    async testSAPConnection() {
      try {
        this.isTestingSAPConnection = true;

        // Basic validation
        if (
          !this.sapConfig.b1sServiceUrl ||
          !this.sapConfig.b1wsUsername ||
          !this.sapConfig.b1wsPassword
        ) {
          this.notify(
            "error",
            "กรุณากรอก Service Layer URL, Username และ Password"
          );
          return;
        }

        // Call Cloud Function to test connection (bypasses CORS)
        const companyId = this.$route.params.companyId;
        console.log("Testing SAP connection for company:", companyId);

        const cloudFunctionUrl = `${process.env.VUE_APP_FIREBASE_FUNCTIONS_URL || 'https://us-central1-sld-etax.cloudfunctions.net'}/apiSapTestConnection`;

        const response = await axios.post(
          cloudFunctionUrl,
          { companyId },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        console.log("SAP test response:", response.data);

        if (response.data && response.data.success) {
          this.notify("success", "เชื่อมต่อ SAP Business One สำเร็จ");
        } else {
          throw new Error(response.data.error || "Connection test failed");
        }
      } catch (error) {
        console.error("SAP connection test error:", error);
        console.error("Error details:", {
          message: error.message,
          code: error.code,
          response: error.response,
        });

        let errorMessage = "";

        // Check if error response from Cloud Function
        if (error.response && error.response.data) {
          const errorData = error.response.data;
          const status = error.response.status;

          if (status === 401) {
            errorMessage = "Authentication failed: Username, Password หรือ Company DB ไม่ถูกต้อง";
          } else if (status === 404) {
            errorMessage = "URL ไม่ถูกต้อง: ตรวจสอบ Service Layer URL (ควรเป็น https://server:port/b1s/v1 หรือ v2)";
          } else if (status === 400) {
            errorMessage = errorData.error || "Invalid configuration";
          } else {
            errorMessage = errorData.error || errorData.message || `HTTP ${status}`;
          }
        }
        // Check for network errors calling Cloud Function
        else if (error.code === "ERR_NETWORK" || error.message.includes("Network Error")) {
          errorMessage = "ไม่สามารถเชื่อมต่อ Cloud Function ได้ ตรวจสอบ network connection";
        }
        // Other errors
        else {
          errorMessage = error.message || "Connection failed";
        }

        this.notify("error", `การเชื่อมต่อล้มเหลว: ${errorMessage}`);
      } finally {
        this.isTestingSAPConnection = false;
      }
    },

    // FoxPro Configuration Methods
    async loadFoxproConfig() {
      try {
        const companyId = this.$route.params.companyId;

        // Pilot flag (Phase 8 of the daemon migration). Read once so the
        // daemon button in the storage-mode toggle can appear conditionally.
        try {
          const companySnap = await fc.companies.doc(companyId).get();
          const cd = companySnap.exists ? (companySnap.data() || {}) : {};
          this.daemonFlagEnabled = !!(cd.features && cd.features.foxproDaemon);
        } catch (flagErr) {
          // Flag read failure is non-fatal — default to false (no daemon
          // option visible). The settings page still loads the rest of
          // the FoxPro config so support can debug.
          console.warn("Failed to read features.foxproDaemon:", flagErr.message);
          this.daemonFlagEnabled = false;
        }

        // Read from FoxproConfig/config; fall back to legacy Databases (type==2) for companies that haven't re-saved yet.
        const configDoc = await fc.companies
          .doc(companyId)
          .collection("FoxproConfig")
          .doc("config")
          .get();

        let databaseData = null;
        if (configDoc.exists) {
          databaseData = configDoc.data();
        } else {
          const legacyRef = await fc.companies
            .doc(companyId)
            .collection("Databases")
            .where("type", "==", 2)
            .limit(1)
            .get();
          if (!legacyRef.empty) databaseData = legacyRef.docs[0].data();
        }

        if (databaseData) {
          this.foxproConfig = {
            storageMode: databaseData.storageMode || "smb",
            apiUrl: databaseData.apiUrl || "",
            networkPath: databaseData.networkPath || "",
            shareName: databaseData.shareName || "",
            username: databaseData.username || "",
            password: databaseData.password || "",
            domain: databaseData.domain || "",
            basePath: databaseData.basePath || "",
            daemonUserId: databaseData.daemonUserId || "",
            daemonWorkerId: databaseData.daemonWorkerId || "",
          };
          this.originalFoxproConfig = _.cloneDeep(this.foxproConfig);
          this.subscribeDaemonPresence();
        }
      } catch (error) {
        console.error("Error loading FoxPro config:", error);
        this.notify("error", "เกิดข้อผิดพลาดในการโหลดการตั้งค่า FoxPro");
      }
    },

    toggleFoxproConfigEdit() {
      this.isEditingFoxproConfig = true;
      this.originalFoxproConfig = _.cloneDeep(this.foxproConfig);
    },

    cancelFoxproConfigEdit() {
      this.isEditingFoxproConfig = false;
      if (this.originalFoxproConfig) {
        this.foxproConfig = _.cloneDeep(this.originalFoxproConfig);
      }
      this.showFoxproPassword = false;
    },

    toggleShowFoxproPassword() {
      this.showFoxproPassword = !this.showFoxproPassword;
    },

    async saveFoxproConfig() {
      try {
        this.isSavingFoxproConfig = true;
        const companyId = this.$route.params.companyId;

        const updateData = {
          storageMode: this.foxproConfig.storageMode || "smb",
          apiUrl: this.foxproConfig.apiUrl || "",
          networkPath: this.foxproConfig.networkPath || "",
          shareName: this.foxproConfig.shareName || "",
          username: this.foxproConfig.username || "",
          password: this.foxproConfig.password || "",
          domain: this.foxproConfig.domain || "",
          basePath: this.foxproConfig.basePath || "",
          daemonUserId: this.foxproConfig.daemonUserId || "",
          daemonWorkerId: this.foxproConfig.daemonWorkerId || "",
          updatedAt: new Date(),
        };

        await fc.companies
          .doc(companyId)
          .collection("FoxproConfig")
          .doc("config")
          .set(updateData, { merge: true });

        this.isEditingFoxproConfig = false;
        this.notify("success", "บันทึกการตั้งค่า FoxPro สำเร็จ");

        await this.loadFoxproConfig();
      } catch (error) {
        console.error("Error saving FoxPro config:", error);
        this.notify("error", "เกิดข้อผิดพลาดในการบันทึกการตั้งค่า FoxPro");
      } finally {
        this.isSavingFoxproConfig = false;
      }
    },

    // ─── Daemon presence ─────────────────────────────────────────────
    // Watches workers/{daemonUserId}/{daemonWorkerId} in RTDB so the
    // settings page reflects whether the customer's daemon is alive.
    subscribeDaemonPresence() {
      this.unsubscribeDaemonPresence();
      const uid = this.foxproConfig.daemonUserId;
      const wid = this.foxproConfig.daemonWorkerId;
      if (!uid || !wid) {
        this.daemonWorker = null;
        return;
      }
      this.daemonWorkerLoading = true;
      const ref = fc.rtdb.ref(`workers/${uid}/${wid}`);
      const cb = ref.on("value", (snap) => {
        this.daemonWorker = snap.val();
        this.daemonWorkerLoading = false;
      }, (err) => {
        // Permission errors here usually mean the rules aren't deployed
        // yet — surface so it gets debugged rather than masked as offline.
        console.warn("Daemon presence listener cancelled:", err.message);
        this.daemonWorker = null;
        this.daemonWorkerLoading = false;
      });
      this.daemonWorkerRef = ref;
      this.daemonWorkerCb = cb;
    },

    unsubscribeDaemonPresence() {
      if (this.daemonWorkerRef && this.daemonWorkerCb) {
        try { this.daemonWorkerRef.off("value", this.daemonWorkerCb); } catch (e) { /* */ }
      }
      this.daemonWorkerRef = null;
      this.daemonWorkerCb = null;
    },

    formatDaemonLastSeen(ts) {
      if (!ts) return "";

      try {
        let date;

        // Firestore Timestamp object
        if (typeof ts.toDate === "function") {
          date = ts.toDate();
        }
        // Firestore raw timestamp object
        else if (ts.seconds) {
          date = new Date(ts.seconds * 1000);
        }
        // milliseconds timestamp
        else {
          date = new Date(Number(ts));
        }

        if (isNaN(date.getTime())) return String(ts);

        const pad = (n) => String(n).padStart(2, "0");

        return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()} ` +
              `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;

      } catch (e) {
        return String(ts);
      }
    },

    copyFoxproCommand(text) {
      navigator.clipboard.writeText(text);
      this.notify("success", "คัดลอกคำสั่งสำเร็จ");
    },

    async testFoxproConnection() {
      try {
        this.isTestingFoxproConnection = true;

        if (
          !this.foxproConfig.apiUrl ||
          !this.foxproConfig.networkPath ||
          !this.foxproConfig.shareName ||
          !this.foxproConfig.username
        ) {
          this.notify("error", "กรุณากรอก API URL, Network Path, Share Name และ Username");
          return;
        }

        const companyId = this.$route.params.companyId;
        console.log("Testing FoxPro connection for company:", companyId);

        const cloudFunctionUrl = `${fc.cloudFunctionUrl}apiFoxproTestConnection`;

        const response = await axios.post(
          cloudFunctionUrl,
          { companyId },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        console.log("FoxPro test response:", response.data);

        if (response.data && response.data.success) {
          this.foxproLastTestAt = new Date();
          this.foxproLastTestOk = true;
          this.foxproLastTestError = "";
          this.notify("success", "เชื่อมต่อ FoxPro สำเร็จ");
        } else {
          throw new Error(response.data.error || "Connection test failed");
        }
      } catch (error) {
        console.error("FoxPro connection test error:", error);

        let errorMessage = "";

        if (error.response && error.response.data) {
          const errorData = error.response.data;
          const status = error.response.status;

          if (status === 401) {
            errorMessage = "Authentication failed: Username, Password หรือ Domain ไม่ถูกต้อง";
          } else if (status === 404) {
            errorMessage = "ไม่พบ Share หรือ Network Path: ตรวจสอบ Network Path และ Share Name";
          } else if (status === 400) {
            errorMessage = errorData.error || "Invalid configuration";
          } else {
            errorMessage = errorData.error || errorData.message || `HTTP ${status}`;
          }
        } else if (error.code === "ERR_NETWORK" || error.message.includes("Network Error")) {
          errorMessage = "ไม่สามารถเชื่อมต่อ Cloud Function ได้ ตรวจสอบ network connection";
        } else {
          errorMessage = error.message || "Connection failed";
        }

        this.foxproLastTestAt = new Date();
        this.foxproLastTestOk = false;
        this.foxproLastTestError = errorMessage;
        this.notify("error", `การเชื่อมต่อล้มเหลว: ${errorMessage}`);
      } finally {
        this.isTestingFoxproConnection = false;
      }
    },

    // ─── Google Drive helpers ────────────────────────────────────────────────

    async _driveAuthHeaders() {
      const user = fc.auth.currentUser;
      if (!user) {
        throw new Error("ไม่ได้เข้าสู่ระบบ กรุณาเข้าสู่ระบบใหม่อีกครั้ง");
      }
      const idToken = await user.getIdToken();
      return {
        "Content-Type": "application/json",
        Authorization: `Bearer ${idToken}`,
      };
    },

    _driveUrl(fnName) {
      const base = process.env.VUE_APP_FIREBASE_FUNCTIONS_URL || "https://us-central1-sld-etax.cloudfunctions.net";
      return `${base}/${fnName}`;
    },

    formatDriveDate(val) {
      if (!val) return "";
      const d = val instanceof Date ? val : (val.toDate ? val.toDate() : new Date(val));
      return d.toLocaleString("th-TH", { calendar: "gregory" });
    },

    // ─── Connection ──────────────────────────────────────────────────────────

    async loadDriveConnectionStatus() {
      this.driveIsLoadingStatus = true;
      try {
        const companyId = this.$route.params.companyId;
        if (!companyId) return;
        const snap = await fc.companies
          .doc(companyId)
          .collection("GoogleDriveConfigs")
          .get();
        const configData = !snap.empty ? snap.docs[0].data() : null;
        this.driveIsConnected = !!configData?.oauthTokens && typeof configData.oauthTokens === "object";
        if (this.driveIsConnected) {
          await Promise.all([
            this.loadFolders("root"),
            this.loadSharedDrives(),
            this.loadWatchStatus(),
          ]);
        } else {
          this._prefetchDriveAuthUrl();
        }
      } catch (err) {
        console.error("loadDriveConnectionStatus error:", err.code, err.message);
      } finally {
        this.driveIsLoadingStatus = false;
      }
    },

    async _prefetchDriveAuthUrl() {
      if (this.driveAuthUrlCache || this.driveAuthUrlPrefetching) return;
      const companyId = this.$route.params.companyId;
      if (!companyId) return;
      this.driveAuthUrlPrefetching = true;
      try {
        const headers = await this._driveAuthHeaders();
        const { data } = await axios.post(
          this._driveUrl("googleDriveAuth"),
          { companyId },
          { headers }
        );
        if (data && data.authUrl) {
          this.driveAuthUrlCache = data.authUrl;
        }
      } catch (err) {
        // Silent — the click handler will fall back to fetching on demand.
        console.debug("prefetchDriveAuthUrl failed:", err.message);
      } finally {
        this.driveAuthUrlPrefetching = false;
      }
    },

    async connectGoogleDrive() {
      if (this.driveIsConnecting) return;
      this.driveIsConnecting = true;

      // Open popup immediately on user click to avoid browser popup blocker
      const popup = window.open("about:blank", "googleDriveOAuth", "width=600,height=700,left=100,top=100");

      // Show a loading page in the popup while we fetch the auth URL
      if (popup) {
        popup.document.write(`
          <!DOCTYPE html>
          <html>
          <head>
            <title>Google Drive - กำลังเชื่อมต่อ</title>
            <style>
              body { margin:0; display:flex; align-items:center; justify-content:center; min-height:100vh; background:#f9fafb; font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif; }
              .container { text-align:center; padding:2rem; }
              .spinner { width:48px; height:48px; border:4px solid #e5e7eb; border-top-color:#4285f4; border-radius:50%; animation:spin .8s linear infinite; margin:0 auto 1.5rem; }
              @keyframes spin { to { transform:rotate(360deg); } }
              .title { font-size:1.125rem; font-weight:600; color:#1f2937; margin-bottom:.5rem; }
              .subtitle { font-size:.875rem; color:#6b7280; }
              .google-icon { margin-bottom:1rem; }
              .google-icon svg { width:40px; height:40px; }
            </style>
          </head>
          <body>
            <div class="container">
              <div class="google-icon">
                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 01-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4"/>
                  <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
                  <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
                  <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
                </svg>
              </div>
              <div class="spinner"></div>
              <div class="title">กำลังเชื่อมต่อ Google Drive</div>
              <div class="subtitle">กรุณารอสักครู่...</div>
            </div>
          </body>
          </html>
        `);
        popup.document.close();
      }

      try {
        const companyId = this.$route.params.companyId;

        let authUrl = this.driveAuthUrlCache;
        if (!authUrl) {
          const headers = await this._driveAuthHeaders();
          const { data } = await axios.post(
            this._driveUrl("googleDriveAuth"),
            { companyId },
            { headers }
          );
          if (!data.authUrl) throw new Error("No authUrl returned");
          authUrl = data.authUrl;
        }
        // Single-use: clear so a future reconnect re-prefetches a fresh URL.
        this.driveAuthUrlCache = null;

        if (!popup || popup.closed) {
          window.location.href = authUrl;
          return;
        }

        popup.location.href = authUrl;

        // Listen for postMessage from the popup callback page
        const onMessage = async (event) => {
          if (event.origin !== window.location.origin) return;
          if (event.data?.type !== "GOOGLE_DRIVE_OAUTH_CALLBACK") return;

          window.removeEventListener("message", onMessage);
          clearInterval(fallbackPoll);
          this.driveIsConnecting = false;

          if (event.data.status === "success") {
            await this.loadDriveConnectionStatus();
            this.notify("success", "เชื่อมต่อ Google Drive สำเร็จ");
          } else {
            this.notify("error", "การเชื่อมต่อ Google Drive ล้มเหลว");
          }
        };
        window.addEventListener("message", onMessage);

        // Fallback: if popup is closed without postMessage (e.g. user closes it)
        const fallbackPoll = setInterval(() => {
          if (!popup || popup.closed) {
            clearInterval(fallbackPoll);
            window.removeEventListener("message", onMessage);
            this.driveIsConnecting = false;
          }
        }, 1000);
      } catch (err) {
        if (popup && !popup.closed) popup.close();
        this.driveIsConnecting = false;
        this.notify("error", "เกิดข้อผิดพลาดในการเชื่อมต่อ Google Drive: " + (err.message || ""));
      }
    },

    async disconnectGoogleDrive() {
      this.driveIsDisconnecting = true;
      let watchStopFailed = false;
      try {
        // Stop active watch first to avoid orphaned webhook channels
        if (this.driveWatchStatus?.isWatching) {
          try {
            await this.stopWatchFolder();
          } catch (stopErr) {
            // Continue with disconnect even if stop fails, but warn the user
            // so they know a Drive push channel may still be orphaned server-side.
            watchStopFailed = true;
            console.error("disconnectGoogleDrive: stopWatchFolder failed", stopErr);
          }
        }
        const companyId = this.$route.params.companyId;
        const snap = await fc.companies.doc(companyId).collection("GoogleDriveConfigs").get();
        if (!snap.empty) {
          await snap.docs[0].ref.update({ oauthTokens: null });
        }
        this.driveIsConnected = false;
        this.folderItems = [];
        this.sharedDrives = [];
        this.selectedWatchFolder = null;
        this.driveWatchStatus = null;
        this.driveAuthUrlCache = null;
        this._prefetchDriveAuthUrl();
        if (watchStopFailed) {
          this.notify(
            "warning",
            "ยกเลิกการเชื่อมต่อแล้ว แต่ไม่สามารถหยุด Watch ได้ — กรุณาตรวจสอบ webhook channel ฝั่ง Google"
          );
        } else {
          this.notify("success", "ยกเลิกการเชื่อมต่อ Google Drive สำเร็จ");
        }
      } catch (err) {
        this.notify("error", "เกิดข้อผิดพลาดในการยกเลิกการเชื่อมต่อ");
      } finally {
        this.driveIsDisconnecting = false;
      }
    },

    async testDriveConnection() {
      this.isTestingDriveConnection = true;
      try {
        const headers = await this._driveAuthHeaders();
        const response = await axios.post(
          this._driveUrl("googleDriveTestConnection"),
          { companyId: this.$route.params.companyId },
          { headers }
        );
        if (response.data?.success) {
          this.notify("success", "เชื่อมต่อ Google Drive สำเร็จ");
        } else {
          throw new Error(response.data?.error || "Connection test failed");
        }
      } catch (err) {
        const msg = err.response?.data?.error || err.message || "Connection failed";
        this.notify("error", `การเชื่อมต่อล้มเหลว: ${msg}`);
      } finally {
        this.isTestingDriveConnection = false;
      }
    },

    // ─── Folder browser — My Drive ───────────────────────────────────────────

    async loadFolders(parentId = "root") {
      this.isLoadingFolders = true;
      try {
        const headers = await this._driveAuthHeaders();
        const response = await axios.post(
          this._driveUrl("googleDriveListFolders"),
          { companyId: this.$route.params.companyId, parentId },
          { headers }
        );
        this.folderItems = response.data.folders || [];
      } catch (err) {
        console.error("loadFolders error:", err);
        this.folderItems = [];
      } finally {
        this.isLoadingFolders = false;
      }
    },

    navigateToFolder(folder) {
      this.currentFolderPath.push({ id: folder.id, name: folder.name });
      this.currentFolderId = folder.id;
      this.loadFolders(folder.id);
    },

    navigateToBreadcrumb(index) {
      if (index === this.currentFolderPath.length - 1) return;
      this.currentFolderPath = this.currentFolderPath.slice(0, index + 1);
      const crumb = this.currentFolderPath[this.currentFolderPath.length - 1];
      this.currentFolderId = crumb.id;
      this.loadFolders(crumb.id);
    },

    // ─── Folder browser — Shared Drives ──────────────────────────────────────

    async loadSharedDrives() {
      this.isLoadingSharedDrives = true;
      try {
        const headers = await this._driveAuthHeaders();
        const response = await axios.post(
          this._driveUrl("googleDriveListSharedDrives"),
          { companyId: this.$route.params.companyId },
          { headers }
        );
        this.sharedDrives = response.data.drives || [];
      } catch (err) {
        console.error("loadSharedDrives error:", err);
        this.sharedDrives = [];
      } finally {
        this.isLoadingSharedDrives = false;
      }
    },

    async openSharedDrive(drive) {
      this.selectedSharedDrive = drive;
      this.sharedFolderPath = [{ id: drive.id, name: drive.name }];
      await this.loadSharedFolders(drive.id, drive.id);
    },

    async navigateToSharedFolder(folder) {
      this.sharedFolderPath.push({ id: folder.id, name: folder.name });
      await this.loadSharedFolders(folder.id, this.selectedSharedDrive.id);
    },

    async navigateToSharedBreadcrumb(index) {
      if (index === this.sharedFolderPath.length - 1) return;
      this.sharedFolderPath = this.sharedFolderPath.slice(0, index + 1);
      const crumb = this.sharedFolderPath[this.sharedFolderPath.length - 1];
      await this.loadSharedFolders(crumb.id, this.selectedSharedDrive.id);
    },

    async loadSharedFolders(parentId, driveId) {
      this.isLoadingSharedFolders = true;
      try {
        const headers = await this._driveAuthHeaders();
        const response = await axios.post(
          this._driveUrl("googleDriveListFolders"),
          { companyId: this.$route.params.companyId, parentId, driveId },
          { headers }
        );
        this.sharedFolderItems = response.data.folders || [];
      } catch (err) {
        console.error("loadSharedFolders error:", err);
        this.sharedFolderItems = [];
      } finally {
        this.isLoadingSharedFolders = false;
      }
    },

    onDriveTabChange(tab) {
      if (tab === 0) this.loadFolders(this.currentFolderId);
    },

    selectWatchFolder(folder) {
      this.selectedWatchFolder = {
        ...folder,
        driveId: this.driveTab === 1 && this.selectedSharedDrive ? this.selectedSharedDrive.id : null,
      };
    },

    // ─── Watch folder ─────────────────────────────────────────────────────────

    async loadWatchStatus() {
      try {
        const companyId = this.$route.params.companyId;
        const snap = await fc.companies
          .doc(companyId)
          .collection("GoogleDriveWatchFolders")
          .where("isActive", "==", true)
          .limit(1)
          .get();

        if (!snap.empty) {
          const d = snap.docs[0].data();
          this.driveWatchStatus = {
            isWatching: true,
            folderId: d.folderId,
            folderName: d.folderName,
            expiresAt: d.expiresAt?.toDate ? d.expiresAt.toDate() : d.expiresAt,
            lastFilesDetected: d.lastFilesDetected || [],
          };
        } else {
          this.driveWatchStatus = { isWatching: false };
        }
      } catch (err) {
        console.error("loadWatchStatus error:", err);
      }
    },

    async startWatchFolder() {
      if (!this.selectedWatchFolder) return;
      this.isStartingWatch = true;
      try {
        const headers = await this._driveAuthHeaders();
        const payload = {
          companyId: this.$route.params.companyId,
          folderId: this.selectedWatchFolder.id,
          folderName: this.selectedWatchFolder.name,
        };
        if (this.selectedWatchFolder.driveId) {
          payload.driveId = this.selectedWatchFolder.driveId;
        }
        await axios.post(
          this._driveUrl("googleDriveStartWatch"),
          payload,
          { headers }
        );
        this.selectedWatchFolder = null;
        await this.loadWatchStatus();
        this.notify("success", "เริ่ม Watch โฟลเดอร์สำเร็จ");
      } catch (err) {
        const msg = err.response?.data?.error || err.message || "";
        this.notify("error", `เกิดข้อผิดพลาดในการเริ่ม Watch: ${msg}`);
      } finally {
        this.isStartingWatch = false;
      }
    },

    async stopWatchFolder() {
      if (!this.driveWatchStatus?.folderId) return;
      this.isStoppingWatch = true;
      try {
        const headers = await this._driveAuthHeaders();
        await axios.post(
          this._driveUrl("googleDriveStopWatch"),
          { companyId: this.$route.params.companyId, folderId: this.driveWatchStatus.folderId },
          { headers }
        );
        this.driveWatchStatus = { isWatching: false };
        this.notify("success", "หยุด Watch โฟลเดอร์สำเร็จ");
      } catch (err) {
        const msg = err.response?.data?.error || err.message || "";
        this.notify("error", `เกิดข้อผิดพลาดในการหยุด Watch: ${msg}`);
      } finally {
        this.isStoppingWatch = false;
      }
    },

    async checkFolderChanges() {
      if (!this.driveWatchStatus?.folderId) return;
      this.isCheckingChanges = true;
      try {
        const headers = await this._driveAuthHeaders();
        const response = await axios.post(
          this._driveUrl("googleDriveCheckChanges"),
          { companyId: this.$route.params.companyId, folderId: this.driveWatchStatus.folderId },
          { headers }
        );
        const count = response.data.newFilesCount || 0;
        this.notify(count > 0 ? "success" : "info", count > 0 ? `พบไฟล์ใหม่ ${count} ไฟล์` : "ไม่พบไฟล์ใหม่");
        await this.loadWatchStatus();
      } catch (err) {
        const msg = err.response?.data?.error || err.message || "";
        this.notify("error", `เกิดข้อผิดพลาดในการตรวจสอบการเปลี่ยนแปลง: ${msg}`);
      } finally {
        this.isCheckingChanges = false;
      }
    },

    async loadOneDriveConnectionStatus() {
      this.oneDriveIsLoadingStatus = true;
      try {
        const companyId = this.$route.params.companyId;
        if (!companyId) return;
        const snap = await fc.companies
          .doc(companyId)
          .collection("OneDriveConfigs")
          .get();
        const configData = !snap.empty ? snap.docs[0].data() : null;
        this.oneDriveIsConnected = !!configData?.oauthTokens && typeof configData.oauthTokens === "object";
        if (this.oneDriveIsConnected) {
          await Promise.all([
            this.loadOneDriveDrives(),
            this.loadOneDriveWatchStatus(),
          ]);
        } else {
          this._prefetchOneDriveAuthUrl();
        }
      } catch (err) {
        console.error("loadOneDriveConnectionStatus error:", err.code, err.message);
      } finally {
        this.oneDriveIsLoadingStatus = false;
      }
    },

    async _prefetchOneDriveAuthUrl() {
      if (this.oneDriveAuthUrlCache || this.oneDriveAuthUrlPrefetching) return;
      const companyId = this.$route.params.companyId;
      if (!companyId) return;
      this.oneDriveAuthUrlPrefetching = true;
      try {
        const headers = await this._driveAuthHeaders();
        const { data } = await axios.post(
          this._driveUrl("oneDriveAuth"),
          { companyId },
          { headers }
        );
        if (data && data.authUrl) {
          this.oneDriveAuthUrlCache = data.authUrl;
        }
      } catch (err) {
        console.debug("prefetchOneDriveAuthUrl failed:", err.message);
      } finally {
        this.oneDriveAuthUrlPrefetching = false;
      }
    },

    async connectOneDrive() {
      const popup = window.open("about:blank", "oneDriveOAuth", "width=600,height=700,left=100,top=100");
      if (popup) {
        popup.document.write(`
          <!DOCTYPE html>
          <html>
          <head>
            <title>OneDrive - Connecting</title>
            <style>
              body { margin:0; display:flex; align-items:center; justify-content:center; min-height:100vh; background:#f9fafb; font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif; }
              .container { text-align:center; padding:2rem; }
              .spinner { width:48px; height:48px; border:4px solid #e5e7eb; border-top-color:#2563eb; border-radius:50%; animation:spin .8s linear infinite; margin:0 auto 1.5rem; }
              @keyframes spin { to { transform:rotate(360deg); } }
              .title { font-size:1.125rem; font-weight:600; color:#1f2937; margin-bottom:.5rem; }
              .subtitle { font-size:.875rem; color:#6b7280; }
            </style>
          </head>
          <body>
            <div class="container">
              <div class="spinner"></div>
              <div class="title">Connecting OneDrive</div>
              <div class="subtitle">Please wait...</div>
            </div>
          </body>
          </html>
        `);
        popup.document.close();
      }

      this.oneDriveIsConnecting = true;
      try {
        let authUrl = this.oneDriveAuthUrlCache;
        if (!authUrl) {
          const headers = await this._driveAuthHeaders();
          const { data } = await axios.post(
            this._driveUrl("oneDriveAuth"),
            { companyId: this.$route.params.companyId },
            { headers }
          );
          if (!data.authUrl) throw new Error("No authUrl returned");
          authUrl = data.authUrl;
        }
        this.oneDriveAuthUrlCache = null;

        if (!popup || popup.closed) {
          window.location.href = authUrl;
          return;
        }

        popup.location.href = authUrl;
        const fallbackPoll = setInterval(async () => {
          if (!popup || popup.closed) {
            clearInterval(fallbackPoll);
            this.oneDriveIsConnecting = false;
            await this.loadOneDriveConnectionStatus();
            if (this.oneDriveIsConnected) {
              this.notify("success", "เชื่อมต่อ OneDrive สำเร็จ");
            }
          }
        }, 1200);
      } catch (err) {
        if (popup && !popup.closed) popup.close();
        this.oneDriveIsConnecting = false;
        this.notify("error", "เกิดข้อผิดพลาดในการเชื่อมต่อ OneDrive: " + (err.message || ""));
      }
    },

    async disconnectOneDrive() {
      this.oneDriveIsDisconnecting = true;
      try {
        if (this.oneDriveWatchStatus?.isWatching) {
          try {
            await this.stopOneDriveWatchFolder();
          } catch (_) {
            // Continue with disconnect even if stopping the subscription fails.
          }
        }
        const companyId = this.$route.params.companyId;
        const snap = await fc.companies.doc(companyId).collection("OneDriveConfigs").get();
        if (!snap.empty) {
          await snap.docs[0].ref.update({ oauthTokens: null });
        }
        this.oneDriveIsConnected = false;
        this.oneDriveDrives = [];
        this.selectedOneDriveDrive = null;
        this.oneDriveFolderPath = [];
        this.oneDriveFolderItems = [];
        this.selectedOneDriveWatchFolder = null;
        this.oneDriveWatchStatus = null;
        this.oneDriveAuthUrlCache = null;
        this._prefetchOneDriveAuthUrl();
        this.notify("success", "ยกเลิกการเชื่อมต่อ OneDrive สำเร็จ");
      } catch (err) {
        this.notify("error", "เกิดข้อผิดพลาดในการยกเลิกการเชื่อมต่อ OneDrive");
      } finally {
        this.oneDriveIsDisconnecting = false;
      }
    },

    async testOneDriveConnection() {
      this.isTestingOneDriveConnection = true;
      try {
        const headers = await this._driveAuthHeaders();
        const response = await axios.post(
          this._driveUrl("oneDriveTestConnection"),
          { companyId: this.$route.params.companyId },
          { headers }
        );
        if (response.data?.success) {
          this.notify("success", "เชื่อมต่อ OneDrive สำเร็จ");
        } else {
          throw new Error(response.data?.error || "Connection test failed");
        }
      } catch (err) {
        const msg = err.response?.data?.error || err.message || "Connection failed";
        this.notify("error", `การเชื่อมต่อ OneDrive ล้มเหลว: ${msg}`);
      } finally {
        this.isTestingOneDriveConnection = false;
      }
    },

    async loadOneDriveDrives() {
      this.isLoadingOneDriveDrives = true;
      try {
        const headers = await this._driveAuthHeaders();
        const response = await axios.post(
          this._driveUrl("oneDriveListDrives"),
          { companyId: this.$route.params.companyId },
          { headers }
        );
        this.oneDriveDrives = response.data.drives || [];
      } catch (err) {
        console.error("loadOneDriveDrives error:", err);
        this.oneDriveDrives = [];
      } finally {
        this.isLoadingOneDriveDrives = false;
      }
    },

    async openOneDriveDrive(drive) {
      this.selectedOneDriveDrive = drive;
      this.oneDriveFolderPath = [{ id: "root", name: drive.name || "OneDrive" }];
      await this.loadOneDriveFolders("root");
    },

    resetOneDriveDriveSelection() {
      this.selectedOneDriveDrive = null;
      this.oneDriveFolderPath = [];
      this.oneDriveFolderItems = [];
      this.selectedOneDriveWatchFolder = null;
    },

    async loadOneDriveFolders(parentId = "root") {
      if (!this.selectedOneDriveDrive) return;
      this.isLoadingOneDriveFolders = true;
      try {
        const headers = await this._driveAuthHeaders();
        const response = await axios.post(
          this._driveUrl("oneDriveListFolders"),
          {
            companyId: this.$route.params.companyId,
            driveId: this.selectedOneDriveDrive.id,
            parentId,
          },
          { headers }
        );
        this.oneDriveFolderItems = response.data.folders || [];
      } catch (err) {
        console.error("loadOneDriveFolders error:", err);
        this.oneDriveFolderItems = [];
      } finally {
        this.isLoadingOneDriveFolders = false;
      }
    },

    async navigateToOneDriveFolder(folder) {
      this.oneDriveFolderPath.push({ id: folder.id, name: folder.name });
      await this.loadOneDriveFolders(folder.id);
    },

    async navigateToOneDriveBreadcrumb(index) {
      if (index === this.oneDriveFolderPath.length - 1) return;
      this.oneDriveFolderPath = this.oneDriveFolderPath.slice(0, index + 1);
      const crumb = this.oneDriveFolderPath[this.oneDriveFolderPath.length - 1];
      await this.loadOneDriveFolders(crumb.id);
    },

    selectOneDriveWatchFolder(folder) {
      if (!this.selectedOneDriveDrive) return;
      this.selectedOneDriveWatchFolder = {
        ...folder,
        driveId: this.selectedOneDriveDrive.id,
      };
    },

    async loadOneDriveWatchStatus() {
      try {
        const companyId = this.$route.params.companyId;
        const snap = await fc.companies
          .doc(companyId)
          .collection("OneDriveWatchFolders")
          .where("isActive", "==", true)
          .limit(1)
          .get();

        if (!snap.empty) {
          const d = snap.docs[0].data();
          this.oneDriveWatchStatus = {
            isWatching: true,
            driveId: d.driveId,
            folderId: d.folderId,
            folderName: d.folderName,
            expiresAt: d.expiresAt?.toDate ? d.expiresAt.toDate() : d.expiresAt,
            lastFilesDetected: d.lastFilesDetected || [],
          };
        } else {
          this.oneDriveWatchStatus = { isWatching: false };
        }
      } catch (err) {
        console.error("loadOneDriveWatchStatus error:", err);
      }
    },

    async startOneDriveWatchFolder() {
      if (!this.selectedOneDriveWatchFolder) return;
      this.isStartingOneDriveWatch = true;
      try {
        const headers = await this._driveAuthHeaders();
        await axios.post(
          this._driveUrl("oneDriveStartWatch"),
          {
            companyId: this.$route.params.companyId,
            driveId: this.selectedOneDriveWatchFolder.driveId,
            folderId: this.selectedOneDriveWatchFolder.id,
            folderName: this.selectedOneDriveWatchFolder.name,
          },
          { headers }
        );
        this.selectedOneDriveWatchFolder = null;
        await this.loadOneDriveWatchStatus();
        this.notify("success", "เริ่ม Watch โฟลเดอร์ OneDrive สำเร็จ");
      } catch (err) {
        const msg = err.response?.data?.error || err.message || "";
        this.notify("error", `เกิดข้อผิดพลาดในการเริ่ม Watch OneDrive: ${msg}`);
      } finally {
        this.isStartingOneDriveWatch = false;
      }
    },

    async stopOneDriveWatchFolder() {
      if (!this.oneDriveWatchStatus?.folderId) return;
      this.isStoppingOneDriveWatch = true;
      try {
        const headers = await this._driveAuthHeaders();
        await axios.post(
          this._driveUrl("oneDriveStopWatch"),
          { companyId: this.$route.params.companyId, folderId: this.oneDriveWatchStatus.folderId },
          { headers }
        );
        this.oneDriveWatchStatus = { isWatching: false };
        this.notify("success", "หยุด Watch โฟลเดอร์ OneDrive สำเร็จ");
      } catch (err) {
        const msg = err.response?.data?.error || err.message || "";
        this.notify("error", `เกิดข้อผิดพลาดในการหยุด Watch OneDrive: ${msg}`);
      } finally {
        this.isStoppingOneDriveWatch = false;
      }
    },

    async checkOneDriveFolderChanges() {
      if (!this.oneDriveWatchStatus?.folderId) return;
      this.isCheckingOneDriveChanges = true;
      try {
        const headers = await this._driveAuthHeaders();
        const response = await axios.post(
          this._driveUrl("oneDriveCheckChanges"),
          { companyId: this.$route.params.companyId, folderId: this.oneDriveWatchStatus.folderId },
          { headers }
        );
        const count = response.data.newFilesCount || 0;
        this.notify(count > 0 ? "success" : "info", count > 0 ? `พบไฟล์ใหม่ ${count} ไฟล์` : "ไม่พบไฟล์ใหม่");
        await this.loadOneDriveWatchStatus();
      } catch (err) {
        const msg = err.response?.data?.error || err.message || "";
        this.notify("error", `เกิดข้อผิดพลาดในการตรวจสอบ OneDrive: ${msg}`);
      } finally {
        this.isCheckingOneDriveChanges = false;
      }
    },

    // ===== Dropbox =====
    async loadDropboxConnectionStatus() {
      this.dropboxIsLoadingStatus = true;
      try {
        const companyId = this.$route.params.companyId;
        if (!companyId) return;
        const snap = await fc.companies.doc(companyId).collection("DropboxConfigs").get();
        const configData = !snap.empty ? snap.docs[0].data() : null;
        this.dropboxIsConnected = !!configData?.oauthTokens && typeof configData.oauthTokens === "object" && !!configData.oauthTokens.refresh_token;
        if (this.dropboxIsConnected) {
          await Promise.all([
            this.loadDropboxFolders(""),
            this.loadDropboxWatchStatus(),
          ]);
        } else {
          this._prefetchDropboxAuthUrl();
        }
      } catch (err) {
        console.error("loadDropboxConnectionStatus error:", err.code, err.message);
      } finally {
        this.dropboxIsLoadingStatus = false;
      }
    },

    async _prefetchDropboxAuthUrl() {
      if (this.dropboxAuthUrlCache || this.dropboxAuthUrlPrefetching) return;
      const companyId = this.$route.params.companyId;
      if (!companyId) return;
      this.dropboxAuthUrlPrefetching = true;
      try {
        const headers = await this._driveAuthHeaders();
        const { data } = await axios.post(
          this._driveUrl("dropboxAuth"),
          { companyId },
          { headers }
        );
        if (data && data.authUrl) {
          this.dropboxAuthUrlCache = data.authUrl;
        }
      } catch (err) {
        console.debug("prefetchDropboxAuthUrl failed:", err.message);
      } finally {
        this.dropboxAuthUrlPrefetching = false;
      }
    },

    async connectDropbox() {
      const popup = window.open("about:blank", "dropboxOAuth", "width=600,height=700,left=100,top=100");
      if (popup) {
        popup.document.write(`
          <!DOCTYPE html>
          <html>
          <head>
            <title>Dropbox - Connecting</title>
            <style>
              body { margin:0; display:flex; align-items:center; justify-content:center; min-height:100vh; background:#f9fafb; font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif; }
              .container { text-align:center; padding:2rem; }
              .spinner { width:48px; height:48px; border:4px solid #e5e7eb; border-top-color:#2563eb; border-radius:50%; animation:spin .8s linear infinite; margin:0 auto 1.5rem; }
              @keyframes spin { to { transform:rotate(360deg); } }
              .title { font-size:1.125rem; font-weight:600; color:#1f2937; margin-bottom:.5rem; }
              .subtitle { font-size:.875rem; color:#6b7280; }
            </style>
          </head>
          <body>
            <div class="container">
              <div class="spinner"></div>
              <div class="title">Connecting Dropbox</div>
              <div class="subtitle">Please wait...</div>
            </div>
          </body>
          </html>
        `);
        popup.document.close();
      }

      this.dropboxIsConnecting = true;
      try {
        let authUrl = this.dropboxAuthUrlCache;
        if (!authUrl) {
          const headers = await this._driveAuthHeaders();
          const { data } = await axios.post(
            this._driveUrl("dropboxAuth"),
            { companyId: this.$route.params.companyId },
            { headers }
          );
          if (!data.authUrl) throw new Error("No authUrl returned");
          authUrl = data.authUrl;
        }
        this.dropboxAuthUrlCache = null;

        if (!popup || popup.closed) {
          window.location.href = authUrl;
          return;
        }

        popup.location.href = authUrl;
        const fallbackPoll = setInterval(async () => {
          if (!popup || popup.closed) {
            clearInterval(fallbackPoll);
            this.dropboxIsConnecting = false;
            await this.loadDropboxConnectionStatus();
            if (this.dropboxIsConnected) {
              this.notify("success", "เชื่อมต่อ Dropbox สำเร็จ");
            }
          }
        }, 1200);
      } catch (err) {
        if (popup && !popup.closed) popup.close();
        this.dropboxIsConnecting = false;
        this.notify("error", "เกิดข้อผิดพลาดในการเชื่อมต่อ Dropbox: " + (err.message || ""));
      }
    },

    async disconnectDropbox() {
      this.dropboxIsDisconnecting = true;
      try {
        if (this.dropboxWatchStatus?.isWatching) {
          try { await this.stopDropboxWatchFolder(); } catch (_) { /* ignore */ }
        }
        const companyId = this.$route.params.companyId;
        const snap = await fc.companies.doc(companyId).collection("DropboxConfigs").get();
        if (!snap.empty) {
          await snap.docs[0].ref.update({ oauthTokens: null });
        }
        this.dropboxIsConnected = false;
        this.dropboxFolderPath = [];
        this.dropboxFolderItems = [];
        this.selectedDropboxWatchFolder = null;
        this.dropboxWatchStatus = null;
        this.dropboxAuthUrlCache = null;
        this._prefetchDropboxAuthUrl();
        this.notify("success", "ยกเลิกการเชื่อมต่อ Dropbox สำเร็จ");
      } catch (err) {
        this.notify("error", "เกิดข้อผิดพลาดในการยกเลิกการเชื่อมต่อ Dropbox");
      } finally {
        this.dropboxIsDisconnecting = false;
      }
    },

    async testDropboxConnection() {
      this.isTestingDropboxConnection = true;
      try {
        const headers = await this._driveAuthHeaders();
        const response = await axios.post(
          this._driveUrl("dropboxTestConnection"),
          { companyId: this.$route.params.companyId },
          { headers }
        );
        if (response.data?.success) {
          this.notify("success", "เชื่อมต่อ Dropbox สำเร็จ");
        } else {
          throw new Error(response.data?.error || "Connection test failed");
        }
      } catch (err) {
        const msg = err.response?.data?.error || err.message || "Connection failed";
        this.notify("error", `การเชื่อมต่อ Dropbox ล้มเหลว: ${msg}`);
      } finally {
        this.isTestingDropboxConnection = false;
      }
    },

    async loadDropboxFolders(parentPath = "") {
      this.isLoadingDropboxFolders = true;
      try {
        const headers = await this._driveAuthHeaders();
        const response = await axios.post(
          this._driveUrl("dropboxListFolders"),
          { companyId: this.$route.params.companyId, parentPath },
          { headers }
        );
        this.dropboxFolderItems = response.data.folders || [];
      } catch (err) {
        console.error("loadDropboxFolders error:", err);
        this.dropboxFolderItems = [];
      } finally {
        this.isLoadingDropboxFolders = false;
      }
    },

    resetDropboxBreadcrumb() {
      this.dropboxFolderPath = [];
      this.selectedDropboxWatchFolder = null;
      this.loadDropboxFolders("");
    },

    async navigateToDropboxFolder(folder) {
      this.dropboxFolderPath.push({ path: folder.path, name: folder.name });
      await this.loadDropboxFolders(folder.path);
    },

    async navigateToDropboxBreadcrumb(index) {
      if (index === this.dropboxFolderPath.length - 1) return;
      this.dropboxFolderPath = this.dropboxFolderPath.slice(0, index + 1);
      const crumb = this.dropboxFolderPath[this.dropboxFolderPath.length - 1];
      await this.loadDropboxFolders(crumb.path);
    },

    selectDropboxWatchFolder(folder) {
      this.selectedDropboxWatchFolder = { ...folder };
    },

    async loadDropboxWatchStatus() {
      try {
        const companyId = this.$route.params.companyId;
        const snap = await fc.companies
          .doc(companyId)
          .collection("DropboxWatchFolders")
          .where("isActive", "==", true)
          .limit(1)
          .get();
        if (!snap.empty) {
          const d = snap.docs[0].data();
          this.dropboxWatchStatus = {
            isWatching: true,
            folderId: d.folderId,
            folderName: d.folderName,
            folderPath: d.folderPath,
            lastFilesDetected: d.lastFilesDetected || [],
          };
        } else {
          this.dropboxWatchStatus = { isWatching: false };
        }
      } catch (err) {
        console.error("loadDropboxWatchStatus error:", err);
      }
    },

    async startDropboxWatchFolder() {
      if (!this.selectedDropboxWatchFolder) return;
      this.isStartingDropboxWatch = true;
      try {
        const headers = await this._driveAuthHeaders();
        await axios.post(
          this._driveUrl("dropboxStartWatch"),
          {
            companyId: this.$route.params.companyId,
            folderPath: this.selectedDropboxWatchFolder.path,
            folderName: this.selectedDropboxWatchFolder.name,
          },
          { headers }
        );
        this.selectedDropboxWatchFolder = null;
        await this.loadDropboxWatchStatus();
        this.notify("success", "เริ่ม Watch โฟลเดอร์ Dropbox สำเร็จ");
      } catch (err) {
        const msg = err.response?.data?.error || err.message || "";
        this.notify("error", `เกิดข้อผิดพลาดในการเริ่ม Watch Dropbox: ${msg}`);
      } finally {
        this.isStartingDropboxWatch = false;
      }
    },

    async stopDropboxWatchFolder() {
      if (!this.dropboxWatchStatus?.folderId) return;
      this.isStoppingDropboxWatch = true;
      try {
        const headers = await this._driveAuthHeaders();
        await axios.post(
          this._driveUrl("dropboxStopWatch"),
          { companyId: this.$route.params.companyId, folderId: this.dropboxWatchStatus.folderId },
          { headers }
        );
        this.dropboxWatchStatus = { isWatching: false };
        this.notify("success", "หยุด Watch โฟลเดอร์ Dropbox สำเร็จ");
      } catch (err) {
        const msg = err.response?.data?.error || err.message || "";
        this.notify("error", `เกิดข้อผิดพลาดในการหยุด Watch Dropbox: ${msg}`);
      } finally {
        this.isStoppingDropboxWatch = false;
      }
    },

    async checkDropboxFolderChanges() {
      if (!this.dropboxWatchStatus?.folderId) return;
      this.isCheckingDropboxChanges = true;
      try {
        const headers = await this._driveAuthHeaders();
        const response = await axios.post(
          this._driveUrl("dropboxCheckChanges"),
          { companyId: this.$route.params.companyId, folderId: this.dropboxWatchStatus.folderId },
          { headers }
        );
        const count = response.data.newFilesCount || 0;
        this.notify(count > 0 ? "success" : "info", count > 0 ? `พบไฟล์ใหม่ ${count} ไฟล์` : "ไม่พบไฟล์ใหม่");
        await this.loadDropboxWatchStatus();
      } catch (err) {
        const msg = err.response?.data?.error || err.message || "";
        this.notify("error", `เกิดข้อผิดพลาดในการตรวจสอบ Dropbox: ${msg}`);
      } finally {
        this.isCheckingDropboxChanges = false;
      }
    },

    // ===== Box.com =====
    async loadBoxConnectionStatus() {
      this.boxIsLoadingStatus = true;
      try {
        const companyId = this.$route.params.companyId;
        if (!companyId) return;
        const snap = await fc.companies.doc(companyId).collection("BoxConfigs").get();
        const configData = !snap.empty ? snap.docs[0].data() : null;
        this.boxIsConnected = !!configData?.oauthTokens && typeof configData.oauthTokens === "object" && !!configData.oauthTokens.refresh_token;
        if (this.boxIsConnected) {
          await Promise.all([
            this.loadBoxFolders("0"),
            this.loadBoxWatchStatus(),
          ]);
        } else {
          this._prefetchBoxAuthUrl();
        }
      } catch (err) {
        console.error("loadBoxConnectionStatus error:", err.code, err.message);
      } finally {
        this.boxIsLoadingStatus = false;
      }
    },

    async _prefetchBoxAuthUrl() {
      if (this.boxAuthUrlCache || this.boxAuthUrlPrefetching) return;
      const companyId = this.$route.params.companyId;
      if (!companyId) return;
      this.boxAuthUrlPrefetching = true;
      try {
        const headers = await this._driveAuthHeaders();
        const { data } = await axios.post(
          this._driveUrl("boxAuth"),
          { companyId },
          { headers }
        );
        if (data && data.authUrl) {
          this.boxAuthUrlCache = data.authUrl;
        }
      } catch (err) {
        console.debug("prefetchBoxAuthUrl failed:", err.message);
      } finally {
        this.boxAuthUrlPrefetching = false;
      }
    },

    async connectBox() {
      const popup = window.open("about:blank", "boxOAuth", "width=600,height=700,left=100,top=100");
      if (popup) {
        popup.document.write(`
          <!DOCTYPE html>
          <html>
          <head>
            <title>Box.com - Connecting</title>
            <style>
              body { margin:0; display:flex; align-items:center; justify-content:center; min-height:100vh; background:#f9fafb; font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif; }
              .container { text-align:center; padding:2rem; }
              .spinner { width:48px; height:48px; border:4px solid #e5e7eb; border-top-color:#2563eb; border-radius:50%; animation:spin .8s linear infinite; margin:0 auto 1.5rem; }
              @keyframes spin { to { transform:rotate(360deg); } }
              .title { font-size:1.125rem; font-weight:600; color:#1f2937; margin-bottom:.5rem; }
              .subtitle { font-size:.875rem; color:#6b7280; }
            </style>
          </head>
          <body>
            <div class="container">
              <div class="spinner"></div>
              <div class="title">Connecting Box.com</div>
              <div class="subtitle">Please wait...</div>
            </div>
          </body>
          </html>
        `);
        popup.document.close();
      }

      this.boxIsConnecting = true;
      try {
        let authUrl = this.boxAuthUrlCache;
        if (!authUrl) {
          const headers = await this._driveAuthHeaders();
          const { data } = await axios.post(
            this._driveUrl("boxAuth"),
            { companyId: this.$route.params.companyId },
            { headers }
          );
          if (!data.authUrl) throw new Error("No authUrl returned");
          authUrl = data.authUrl;
        }
        this.boxAuthUrlCache = null;

        if (!popup || popup.closed) {
          window.location.href = authUrl;
          return;
        }

        popup.location.href = authUrl;
        const fallbackPoll = setInterval(async () => {
          if (!popup || popup.closed) {
            clearInterval(fallbackPoll);
            this.boxIsConnecting = false;
            await this.loadBoxConnectionStatus();
            if (this.boxIsConnected) {
              this.notify("success", "เชื่อมต่อ Box.com สำเร็จ");
            }
          }
        }, 1200);
      } catch (err) {
        if (popup && !popup.closed) popup.close();
        this.boxIsConnecting = false;
        this.notify("error", "เกิดข้อผิดพลาดในการเชื่อมต่อ Box.com: " + (err.message || ""));
      }
    },

    async disconnectBox() {
      this.boxIsDisconnecting = true;
      try {
        if (this.boxWatchStatus?.isWatching) {
          try { await this.stopBoxWatchFolder(); } catch (_) { /* ignore */ }
        }
        const companyId = this.$route.params.companyId;
        const snap = await fc.companies.doc(companyId).collection("BoxConfigs").get();
        if (!snap.empty) {
          await snap.docs[0].ref.update({ oauthTokens: null });
        }
        this.boxIsConnected = false;
        this.boxFolderPath = [];
        this.boxFolderItems = [];
        this.selectedBoxWatchFolder = null;
        this.boxWatchStatus = null;
        this.boxAuthUrlCache = null;
        this._prefetchBoxAuthUrl();
        this.notify("success", "ยกเลิกการเชื่อมต่อ Box.com สำเร็จ");
      } catch (err) {
        this.notify("error", "เกิดข้อผิดพลาดในการยกเลิกการเชื่อมต่อ Box.com");
      } finally {
        this.boxIsDisconnecting = false;
      }
    },

    async testBoxConnection() {
      this.isTestingBoxConnection = true;
      try {
        const headers = await this._driveAuthHeaders();
        const response = await axios.post(
          this._driveUrl("boxTestConnection"),
          { companyId: this.$route.params.companyId },
          { headers }
        );
        if (response.data?.success) {
          this.notify("success", "เชื่อมต่อ Box.com สำเร็จ");
        } else {
          throw new Error(response.data?.error || "Connection test failed");
        }
      } catch (err) {
        const msg = err.response?.data?.error || err.message || "Connection failed";
        this.notify("error", `การเชื่อมต่อ Box.com ล้มเหลว: ${msg}`);
      } finally {
        this.isTestingBoxConnection = false;
      }
    },

    async loadBoxFolders(parentId = "0") {
      this.isLoadingBoxFolders = true;
      try {
        const headers = await this._driveAuthHeaders();
        const response = await axios.post(
          this._driveUrl("boxListFolders"),
          { companyId: this.$route.params.companyId, parentId },
          { headers }
        );
        this.boxFolderItems = response.data.folders || [];
      } catch (err) {
        console.error("loadBoxFolders error:", err);
        this.boxFolderItems = [];
      } finally {
        this.isLoadingBoxFolders = false;
      }
    },

    resetBoxBreadcrumb() {
      this.boxFolderPath = [];
      this.selectedBoxWatchFolder = null;
      this.loadBoxFolders("0");
    },

    async navigateToBoxFolder(folder) {
      this.boxFolderPath.push({ id: folder.id, name: folder.name });
      await this.loadBoxFolders(folder.id);
    },

    async navigateToBoxBreadcrumb(index) {
      if (index === this.boxFolderPath.length - 1) return;
      this.boxFolderPath = this.boxFolderPath.slice(0, index + 1);
      const crumb = this.boxFolderPath[this.boxFolderPath.length - 1];
      await this.loadBoxFolders(crumb.id);
    },

    selectBoxWatchFolder(folder) {
      this.selectedBoxWatchFolder = { ...folder };
    },

    async loadBoxWatchStatus() {
      try {
        const companyId = this.$route.params.companyId;
        const snap = await fc.companies
          .doc(companyId)
          .collection("BoxWatchFolders")
          .where("isActive", "==", true)
          .limit(1)
          .get();
        if (!snap.empty) {
          const d = snap.docs[0].data();
          this.boxWatchStatus = {
            isWatching: true,
            folderId: d.folderId,
            folderName: d.folderName,
            lastFilesDetected: d.lastFilesDetected || [],
          };
        } else {
          this.boxWatchStatus = { isWatching: false };
        }
      } catch (err) {
        console.error("loadBoxWatchStatus error:", err);
      }
    },

    async startBoxWatchFolder() {
      if (!this.selectedBoxWatchFolder) return;
      this.isStartingBoxWatch = true;
      try {
        const headers = await this._driveAuthHeaders();
        await axios.post(
          this._driveUrl("boxStartWatch"),
          {
            companyId: this.$route.params.companyId,
            folderId: this.selectedBoxWatchFolder.id,
            folderName: this.selectedBoxWatchFolder.name,
          },
          { headers }
        );
        this.selectedBoxWatchFolder = null;
        await this.loadBoxWatchStatus();
        this.notify("success", "เริ่ม Watch โฟลเดอร์ Box.com สำเร็จ");
      } catch (err) {
        const msg = err.response?.data?.error || err.message || "";
        this.notify("error", `เกิดข้อผิดพลาดในการเริ่ม Watch Box.com: ${msg}`);
      } finally {
        this.isStartingBoxWatch = false;
      }
    },

    async stopBoxWatchFolder() {
      if (!this.boxWatchStatus?.folderId) return;
      this.isStoppingBoxWatch = true;
      try {
        const headers = await this._driveAuthHeaders();
        await axios.post(
          this._driveUrl("boxStopWatch"),
          { companyId: this.$route.params.companyId, folderId: this.boxWatchStatus.folderId },
          { headers }
        );
        this.boxWatchStatus = { isWatching: false };
        this.notify("success", "หยุด Watch โฟลเดอร์ Box.com สำเร็จ");
      } catch (err) {
        const msg = err.response?.data?.error || err.message || "";
        this.notify("error", `เกิดข้อผิดพลาดในการหยุด Watch Box.com: ${msg}`);
      } finally {
        this.isStoppingBoxWatch = false;
      }
    },

    async checkBoxFolderChanges() {
      if (!this.boxWatchStatus?.folderId) return;
      this.isCheckingBoxChanges = true;
      try {
        const headers = await this._driveAuthHeaders();
        const response = await axios.post(
          this._driveUrl("boxCheckChanges"),
          { companyId: this.$route.params.companyId, folderId: this.boxWatchStatus.folderId },
          { headers }
        );
        const count = response.data.newFilesCount || 0;
        this.notify(count > 0 ? "success" : "info", count > 0 ? `พบไฟล์ใหม่ ${count} ไฟล์` : "ไม่พบไฟล์ใหม่");
        await this.loadBoxWatchStatus();
      } catch (err) {
        const msg = err.response?.data?.error || err.message || "";
        this.notify("error", `เกิดข้อผิดพลาดในการตรวจสอบ Box.com: ${msg}`);
      } finally {
        this.isCheckingBoxChanges = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.v-tab {
  text-transform: none;
  padding-right: 8px !important;

  .v-btn {
    margin-left: 8px;
  }
}

.prompt-type-invoice {
  border-left: 3px solid #3f51b5;
}

.prompt-type-credit {
  border-left: 3px solid #000000;
}

.active-prompt {
  background-color: #f5f9ff !important;
  font-weight: 500;
}

.active-badge {
  position: absolute;
  top: -4px;
  left: -10px;
}
.row-wrapper {
  padding-left: 20px;
}

.nowrap th,
td {
  white-space: nowrap;
}

.expanded-item-td {
  padding: 0;
}

.v-data-table
  > .v-data-table__wrapper
  tbody
  tr.v-data-table__expanded__content {
  box-shadow: 0 0 0 0 !important;
}

.my-header-style {
  background: rgba(59, 130, 246, 0.5);
}

.row_Class {
  background-color: rgba(0, 0, 0, 0.12);
}

.vendor-avatar {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}

.img-show {
  width: 6rem;
  height: 6rem;
  object-fit: contain;
}
:deep(.el-tabs__item) {
  font-size: 16px !important;
}

:deep(.el-tabs__item.is-active) {
  color: #6ec39b !important;
  font-weight: 600 !important;
}

:deep(.el-tabs__item:hover) {
  color: #6ec39b90 !important;
  font-weight: 600 !important;
}

:deep(.el-tabs__active-bar) {
  background-color: #6ec39b !important;
}

.model_wrapper {
  background-color: #f0f0f025;
  border: 1px solid #b6b6b653;
}

.settings-section {
  margin: 32px 20px 0;
  padding: 20px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  scroll-margin-top: 80px;
}

.settings-section--api {
  margin-top: 8px;
}

.section-nav {
  position: sticky;
  top: 0;
  z-index: 4;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
  margin: 8px 20px 0;
  padding: 6px 8px;
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: saturate(180%) blur(8px);
  border: 1px solid #e5e7eb;
  border-radius: 999px;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.05);
}

.section-nav-item {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 999px;
  color: #475569;
  font-size: 13px;
  font-weight: 600;
  text-decoration: none;
  white-space: nowrap;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.section-nav-item:hover {
  background: #f1f5f9;
  color: #0f172a;
}

.section-nav-item--active {
  background: #e0e7ff;
  color: #1d4ed8;
}

.section-nav-item--dirty {
  color: #b45309;
}

.section-nav-item--dirty.section-nav-item--active {
  background: #fef3c7;
  color: #92400e;
}

.section-nav-item-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  margin-left: 6px;
  background: #f59e0b;
  border-radius: 999px;
  box-shadow: 0 0 0 2px rgba(245, 158, 11, 0.18);
}

@media (max-width: 600px) {
  .section-nav {
    flex-wrap: nowrap;
    overflow-x: auto;
    border-radius: 12px;
    margin: 8px 0 0;
  }
}

.settings-section-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #eef2f7;
}

.settings-section-title-block {
  min-width: 0;
}

.settings-section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #111827;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.3;
}

.settings-section-description {
  max-width: 680px;
  margin-top: 4px;
  color: #64748b;
  font-size: 13px;
  line-height: 1.5;
}

.settings-section-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
}

.settings-section-body {
  margin-top: 16px;
}

.api-key-grid {
  margin-top: 16px;
}

.api-key-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 10px;
}

.prompt-tabs {
  border-top: 1px solid #eef2f7;
}

:deep(.prompt-textarea textarea) {
  max-height: 60vh;
  overflow-y: auto;
}

.history-totals {
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #eef2f7;
}

.history-totals-title {
  font-size: 13px;
  font-weight: 700;
  color: #475569;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 8px;
}

.model-picker {
  margin-top: 16px;
  padding: 20px;
  background: #fafbfd;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
}

.model-picker-row {
  display: grid;
  grid-template-columns: 200px 1fr;
  gap: 24px;
  align-items: start;
}

@media (max-width: 768px) {
  .model-picker-row {
    grid-template-columns: 1fr;
    gap: 8px;
  }
}

.model-picker-label-title {
  color: #111827;
  font-size: 15px;
  font-weight: 700;
}

.model-picker-label-hint {
  margin-top: 2px;
  color: #64748b;
  font-size: 12px;
}

.model-picker-body {
  min-width: 0;
}

.model-picker-selected {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 6px;
  padding: 4px 10px;
  background: #ecfdf5;
  border: 1px solid #a7f3d0;
  border-radius: 999px;
  color: #047857;
  font-size: 12px;
  font-weight: 600;
}

.model-picker-selected-name {
  color: #065f46;
}

.prompt-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin-top: 24px;
  padding: 40px 20px;
  background: #f9fafb;
  border: 1px dashed #d1d5db;
  border-radius: 12px;
  text-align: center;
}

.prompt-empty-state-title {
  color: #111827;
  font-size: 15px;
  font-weight: 700;
}

.prompt-empty-state-description {
  max-width: 360px;
  color: #64748b;
  font-size: 13px;
  line-height: 1.5;
  margin-bottom: 6px;
}

.prompt-loading-skeleton {
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

:deep(.prompt-tabs .v-slide-group__content) {
  align-items: stretch;
}

:deep(.prompt-tabs .v-tab) {
  max-width: 260px;
}

.cloud-provider-card {
  position: relative;
  overflow: hidden;
  padding: 20px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 14px 32px rgba(15, 23, 42, 0.06);
}

.sync-provider-config {
  margin-top: 18px;
  background: #fbfdff;
  box-shadow: none;
}

.cloud-provider-card::before {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 4px;
}

.cloud-provider-card--google::before {
  background: linear-gradient(180deg, #4285f4 0%, #34a853 48%, #fbbc04 100%);
}

.cloud-provider-card--onedrive::before {
  background: linear-gradient(180deg, #0078d4 0%, #35a3f4 100%);
}

.cloud-provider-card--dropbox::before {
  background: linear-gradient(180deg, #0061ff 0%, #00a1ff 100%);
}

.cloud-provider-card--box::before {
  background: linear-gradient(180deg, #0061d5 0%, #1f2937 100%);
}

.cloud-provider-card--psc::before {
  background: linear-gradient(180deg, #5e35b1 0%, #8e24aa 100%);
}

.cloud-provider-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #eef2f7;
}

.cloud-provider-title-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  min-width: 0;
}

.cloud-provider-icon,
.connect-state-icon,
.connected-summary-icon,
.watch-selection-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 44px;
  height: 44px;
  border-radius: 8px;
}

.cloud-provider-card--google .cloud-provider-icon,
.cloud-provider-card--google .connect-state-icon {
  background: #e8f0fe;
}

.cloud-provider-card--onedrive .cloud-provider-icon,
.cloud-provider-card--onedrive .connect-state-icon {
  background: #e5f3ff;
}

.cloud-provider-card--dropbox .cloud-provider-icon,
.cloud-provider-card--dropbox .connect-state-icon {
  background: #eaf3ff;
}

.cloud-provider-card--box .cloud-provider-icon,
.cloud-provider-card--box .connect-state-icon {
  background: #eef4ff;
}

.cloud-provider-heading {
  color: #111827;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.25;
}

.cloud-provider-description {
  max-width: 640px;
  margin-top: 4px;
  color: #64748b;
  font-size: 13px;
  line-height: 1.5;
}

.cloud-provider-actions,
.watch-selection-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
}

.cloud-status-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  width: fit-content;
  margin-top: 10px;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
}

.cloud-status-pill--connected {
  color: #047857;
  background: #ecfdf5;
  border: 1px solid #a7f3d0;
}

.cloud-status-pill--idle {
  color: #64748b;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
}

.cloud-loading-card {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 18px;
  padding: 18px;
  background: #f8fafc;
  border: 1px solid #eef2f7;
  border-radius: 8px;
}

.connect-state-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  margin-top: 18px;
  padding: 20px;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}

.connect-state-copy {
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 0;
}

.connect-state-title,
.connected-summary-title {
  color: #111827;
  font-size: 15px;
  font-weight: 700;
}

.connect-state-description,
.connected-summary-description {
  max-width: 620px;
  margin-top: 3px;
  color: #64748b;
  font-size: 13px;
  line-height: 1.45;
}

.connect-steps {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  margin-top: 10px;
  color: #475569;
  font-size: 12px;
  font-weight: 600;
}

.connect-steps span {
  padding: 4px 8px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 999px;
}

.connect-state-action {
  flex: 0 0 auto;
}

.connected-summary {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 18px;
  padding: 14px 16px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}

.connected-summary-icon {
  width: 36px;
  height: 36px;
  background: #ecfdf5;
}

.watch-status-card {
  overflow: hidden;
  border: 1px solid #bbf7d0 !important;
  border-radius: 8px !important;
  background: #f7fef9 !important;
}

:deep(.watch-status-card .v-card__text) {
  padding: 18px !important;
}

.watch-selection-bar,
.watch-starting-bar {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-top: 16px;
  padding: 14px 16px;
  background: #f8fbff;
  border: 1px solid #bfdbfe;
  border-radius: 8px;
}

.watch-selection-bar {
  justify-content: space-between;
}

.watch-starting-bar {
  color: #334155;
}

.watch-selection-info {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.watch-selection-icon {
  width: 38px;
  height: 38px;
  background: #fff7ed;
}

.watch-selection-label {
  color: #64748b;
  font-size: 12px;
  font-weight: 600;
}

.watch-selection-name {
  color: #1d4ed8;
  font-size: 14px;
  font-weight: 700;
  overflow-wrap: anywhere;
}

:deep(.cloud-provider-card .v-list) {
  border-color: #e2e8f0 !important;
}

:deep(.cloud-provider-card .v-list-item) {
  border-radius: 6px;
}

:deep(.cloud-provider-card .v-list-item:hover) {
  background: #f8fafc;
}

@media (max-width: 768px) {
  .cloud-provider-header,
  .connect-state-card,
  .settings-section-header,
  .watch-selection-bar {
    align-items: stretch;
    flex-direction: column;
  }

  .cloud-provider-actions,
  .settings-section-actions,
  .watch-selection-actions {
    justify-content: flex-start;
  }

  .settings-section {
    margin: 24px 0 0;
    padding: 16px;
  }

  .api-key-actions .v-btn {
    flex: 1 1 140px;
  }

  .connect-state-action {
    width: 100%;
  }
}

.disabled-chip-group {
  opacity: 0.6;
  pointer-events: none;
}

.sync-picker-header {
  margin-bottom: 16px;
}

.sync-picker-current {
  align-items: center;
}

.sync-picker-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 12px;
}

@media (max-width: 520px) {
  .sync-picker-grid {
    grid-template-columns: 1fr;
  }
}

.sync-picker-card {
  position: relative;
  min-height: 166px;
  padding: 16px 14px 14px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;
  display: flex;
  flex-direction: column;
  gap: 8px;
  user-select: none;
}

.sync-picker-card:hover {
  border-color: #93c5fd;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.08);
  transform: translateY(-1px);
}

.sync-picker-card:focus-visible {
  outline: 3px solid rgba(25, 118, 210, 0.28);
  outline-offset: 2px;
}

.sync-picker-card--active {
  border-color: #1976d2;
  box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.18), 0 12px 28px rgba(25, 118, 210, 0.12);
  background: #f5faff;
}

.sync-picker-card--disabled {
  opacity: 0.6;
  pointer-events: none;
}

.sync-picker-card--unavailable {
  cursor: not-allowed;
  background: #fafafa;
  border-style: dashed;
}

.sync-picker-card--unavailable:hover {
  border-color: #e5e7eb;
  box-shadow: none;
  transform: none;
}

.sync-picker-card--unavailable .sync-picker-card-name,
.sync-picker-card--unavailable .sync-picker-card-description,
.sync-picker-card--unavailable .sync-picker-card-icon {
  opacity: 0.55;
}

.sync-picker-card-ribbon {
  position: absolute;
  top: 8px;
  right: 8px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 999px;
  background: #fef3c7;
  color: #92400e;
  font-size: 11px;
  font-weight: 600;
}

.sync-picker-card-ribbon--blocked {
  background: #fee2e2;
  color: #b91c1c;
}

.sync-picker-card--blocked {
  border-color: #fca5a5;
  background: #fff5f5;
}

.sync-picker-card--blocked:hover {
  border-color: #fca5a5;
  box-shadow: none;
  transform: none;
}

.sync-picker-card-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 8px;
  background: #f3f4f6;
}

.sync-picker-card--active .sync-picker-card-icon {
  background: #e3f2fd;
}

.sync-picker-card-name {
  font-weight: 600;
  font-size: 14px;
  color: #111827;
  margin-top: 4px;
}

.sync-picker-card-description {
  font-size: 12px;
  color: #6b7280;
  line-height: 1.35;
}

.sync-picker-card-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  color: #6b7280;
  margin-top: auto;
}

.sync-picker-card--active .sync-picker-card-badge {
  color: #1b5e20;
  font-weight: 600;
}

.sync-picker-card-progress {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.sync-picker-card-progress-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 11px;
  color: #92400e;
  font-weight: 600;
}

.sync-picker-card-progress-value {
  color: #b45309;
}

.sync-picker-card-progress-bar {
  width: 100%;
  height: 6px;
  background: #fef3c7;
  border-radius: 999px;
  overflow: hidden;
}

.sync-picker-card-progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #f59e0b, #d97706);
  border-radius: 999px;
  transition: width 0.3s ease;
}

.sync-picker-empty {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 14px;
  padding: 8px 12px;
  background: #f9fafb;
  border: 1px dashed #d1d5db;
  border-radius: 8px;
  color: #6b7280;
  font-size: 13px;
}

.psc-status-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

@media (max-width: 700px) {
  .psc-status-grid {
    grid-template-columns: 1fr;
  }
}

.psc-status-tile {
  padding: 14px 16px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
}

.psc-status-tile-label {
  font-size: 12px;
  color: #6b7280;
  margin-bottom: 6px;
}

.psc-status-tile-value {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 600;
}

.psc-status-tile-value--ok {
  color: #1b5e20;
}

.psc-status-tile-value--running {
  color: #1b5e20;
}

.psc-status-tile-value--idle {
  color: #6b7280;
}

.psc-status-meta {
  margin-top: 10px;
  font-size: 12px;
  color: #6b7280;
}

.cloud-provider-card--foxpro::before {
  background: linear-gradient(180deg, #455a64 0%, #0288d1 100%);
}

.cloud-provider-card--foxpro .cloud-provider-icon {
  background: #eceff1;
}

.foxpro-mode-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 14px;
  margin-top: 18px;
}

.foxpro-mode-label {
  font-size: 13px;
  font-weight: 600;
  color: #334155;
}

.foxpro-fieldset {
  margin-top: 18px;
  padding: 14px 16px 4px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
}

.foxpro-fieldset-title {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  font-size: 12px;
  font-weight: 700;
  color: #475569;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.foxpro-test-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 14px;
  margin-top: 18px;
}

.foxpro-test-hint {
  font-size: 12px;
  color: #6b7280;
}

.foxpro-test-result {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  border-radius: 10px;
  font-size: 13px;
  max-width: 100%;
}

.foxpro-test-result--ok {
  color: #047857;
  background: #ecfdf5;
  border: 1px solid #a7f3d0;
}

.foxpro-test-result--fail {
  color: #b91c1c;
  background: #fef2f2;
  border: 1px solid #fecaca;
}

.foxpro-test-result-label {
  font-weight: 700;
  line-height: 1.2;
}

.foxpro-test-result-meta {
  margin-top: 2px;
  font-size: 12px;
  opacity: 0.85;
  word-break: break-word;
}
</style>
